{
  "v": "5.7.1",
  "fr": 60,
  "ip": 0,
  "op": 144,
  "w": 1080,
  "h": 1920,
  "nm": "Comp 1",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Layer 11 Outlines 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.833,
                "y": 0.833
              },
              "o": {
                "x": 0.167,
                "y": 0.167
              },
              "t": 0,
              "s": [803, 349.5, 0],
              "to": [91.333, 156.333, 0],
              "ti": [-217.333, -162.333, 0]
            },
            {
              "t": 141,
              "s": [871, 1391.5, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [28, 37.5, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [100, 100, 100],
          "ix": 6
        }
      },
      "ao": 1,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.099, 0.594],
                    [0, 0],
                    [-0.299, -0.397],
                    [-0.197, 0.298],
                    [-0.893, 0.794],
                    [-0.498, -0.693],
                    [0, -0.396],
                    [0.099, -0.099],
                    [0.299, 0.398],
                    [0.198, -0.199],
                    [0.994, -0.994],
                    [0.597, 0.696]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0.396],
                    [0.397, 0.397],
                    [0.597, -0.594],
                    [0.397, -0.397],
                    [0.397, 0.499],
                    [-0.2, 0],
                    [0, -0.298],
                    [-0.298, -0.396],
                    [-0.596, 0.496],
                    [-0.397, 0.398],
                    [-0.495, -0.597]
                  ],
                  "v": [
                    [-1.787, -0.347],
                    [-1.292, -0.347],
                    [-0.894, 0.943],
                    [0.097, 1.141],
                    [-0.199, -1.64],
                    [1.39, -1.243],
                    [1.886, 0.05],
                    [1.488, 0.148],
                    [1.091, -0.944],
                    [0.198, -1.142],
                    [0.494, 1.639],
                    [-1.193, 1.34]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [26.815, 44.825],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.101, 0.2],
                    [-0.693, 0.695],
                    [0.296, 0.396],
                    [0.398, 0],
                    [0.794, -0.696],
                    [0.102, 0.197],
                    [-1.191, 0.892],
                    [-0.098, -0.197],
                    [0.197, -0.099],
                    [-0.299, -0.496],
                    [0.597, -0.495],
                    [0.795, -0.695]
                  ],
                  "o": [
                    [0.695, -0.594],
                    [0.499, -0.397],
                    [-0.299, -0.398],
                    [-0.794, 0.695],
                    [-0.099, -0.197],
                    [1.093, -0.893],
                    [0.099, 0.2],
                    [-0.199, 0.101],
                    [0.396, 0],
                    [0.495, 0.594],
                    [-0.794, 0.696],
                    [0, -0.098]
                  ],
                  "v": [
                    [-0.595, 1.985],
                    [1.092, 0.397],
                    [1.193, -0.794],
                    [0.1, -1.29],
                    [-1.885, 0.397],
                    [-2.184, -0.099],
                    [0.596, -2.383],
                    [0.894, -1.886],
                    [0.498, -1.589],
                    [1.689, -0.893],
                    [1.489, 0.696],
                    [-0.396, 2.383]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [24.53, 41.896],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.498, 0.397],
                    [0.398, 0.694],
                    [0.597, -0.496],
                    [-0.496, -0.597]
                  ],
                  "o": [
                    [0.595, -0.496],
                    [-0.397, -0.695],
                    [-0.594, 0.397],
                    [0.498, 0.695]
                  ],
                  "v": [
                    [0.646, 1.042],
                    [1.043, -0.843],
                    [-0.745, -1.042],
                    [-1.142, 0.845]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.893, 0.595],
                    [-0.598, -0.994],
                    [0.794, -0.695],
                    [0.595, 0.991]
                  ],
                  "o": [
                    [0.794, -0.596],
                    [0.593, 0.992],
                    [-0.793, 0.693],
                    [-0.695, -0.995]
                  ],
                  "v": [
                    [-0.942, -1.637],
                    [1.54, -1.141],
                    [1.043, 1.54],
                    [-1.438, 1.144]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [22.297, 38.57],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.695, 0.496],
                    [0.298, 0.696],
                    [0.397, 0],
                    [0.597, -0.397],
                    [-0.298, -0.397]
                  ],
                  "o": [
                    [0.693, -0.496],
                    [-0.198, -0.397],
                    [-0.499, 0.397],
                    [-0.197, 0.397],
                    [0.296, 0.695]
                  ],
                  "v": [
                    [1.291, 1.142],
                    [1.886, -0.745],
                    [0.894, -1.438],
                    [-0.497, -0.545],
                    [-0.396, 0.844]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.197, 0.496],
                    [0.596, -0.498],
                    [0.097, 0.298],
                    [-1.688, 0.994],
                    [-0.101, -0.197],
                    [0.201, -0.099],
                    [-0.197, -0.496],
                    [0.895, -0.696],
                    [0.495, 0.893]
                  ],
                  "o": [
                    [-0.593, 0.398],
                    [-0.099, -0.199],
                    [1.588, -1.191],
                    [0.098, 0.2],
                    [-0.2, 0.101],
                    [0.398, 0.098],
                    [0.496, 0.892],
                    [-0.893, 0.693],
                    [-0.2, -0.498]
                  ],
                  "v": [
                    [-0.895, -0.247],
                    [-2.482, 0.945],
                    [-2.778, 0.348],
                    [1.39, -2.432],
                    [1.688, -1.936],
                    [1.189, -1.637],
                    [2.282, -0.843],
                    [1.587, 1.739],
                    [-0.793, 1.342]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [19.469, 34.797],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.099, 0.2],
                    [-0.101, 0.102],
                    [0.197, 0.595],
                    [-0.697, 0.396],
                    [-0.895, 0.495],
                    [-0.099, -0.299],
                    [0.795, -0.498],
                    [-0.2, -0.496],
                    [-0.397, -0.099],
                    [-0.893, 0.498],
                    [-0.099, -0.299],
                    [1.191, -0.794]
                  ],
                  "o": [
                    [0.197, -0.099],
                    [-0.397, -0.098],
                    [-0.299, -0.794],
                    [0.892, -0.496],
                    [0.1, 0.199],
                    [-0.795, 0.496],
                    [-0.597, 0.296],
                    [0.197, 0.496],
                    [0.896, -0.597],
                    [0.098, 0.2],
                    [-1.19, 0.794],
                    [0, -0.396]
                  ],
                  "v": [
                    [-1.09, 1.836],
                    [-0.693, 1.537],
                    [-1.786, 0.547],
                    [-1.29, -1.241],
                    [0.895, -2.531],
                    [1.093, -1.935],
                    [-0.992, -0.743],
                    [-1.389, 0.547],
                    [-0.397, 1.341],
                    [1.887, -0.051],
                    [2.084, 0.547],
                    [-0.992, 2.531]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [18.277, 31.024],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.597, 0.299],
                    [0.295, 0.892],
                    [0.697, -0.396],
                    [-0.296, -0.795]
                  ],
                  "o": [
                    [0.693, -0.397],
                    [-0.299, -0.795],
                    [-0.692, 0.397],
                    [0.298, 0.797]
                  ],
                  "v": [
                    [0.498, 1.29],
                    [1.293, -0.695],
                    [-0.398, -1.293],
                    [-1.191, 0.693]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.892, 0.495],
                    [-0.396, -1.089],
                    [0.893, -0.498],
                    [0.398, 1.192]
                  ],
                  "o": [
                    [0.992, -0.496],
                    [0.395, 1.093],
                    [-0.892, 0.496],
                    [-0.396, -1.191]
                  ],
                  "v": [
                    [-0.595, -1.887],
                    [1.689, -0.896],
                    [0.695, 1.887],
                    [-1.688, 0.991]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [16.59, 26.706],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.49, 0.597],
                    [-0.397, -1.589],
                    [0.394, -0.696],
                    [0.099, 0.099],
                    [0.099, 0.594],
                    [1.093, -0.496],
                    [-0.299, -1.191],
                    [-0.498, -0.098],
                    [0, -0.299],
                    [0.298, 0.991]
                  ],
                  "o": [
                    [1.489, -0.595],
                    [0.199, 0.991],
                    [-0.201, -0.198],
                    [0.296, -0.495],
                    [-0.296, -1.191],
                    [-1.09, 0.498],
                    [0.197, 0.696],
                    [0, 0.299],
                    [-0.693, -0.2],
                    [-0.496, -1.589]
                  ],
                  "v": [
                    [-0.546, -2.583],
                    [2.53, -0.795],
                    [2.136, 1.687],
                    [1.738, 1.289],
                    [2.034, -0.495],
                    [-0.349, -1.788],
                    [-1.737, 1.289],
                    [-0.645, 2.481],
                    [-0.746, 3.177],
                    [-2.233, 1.49]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [15.846, 21.642],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [9.234, -9.384],
                    [10.127, -10.177],
                    [10.721, -9.482],
                    [9.828, -8.687]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [7.544, -7.693],
                    [8.439, -8.487],
                    [9.034, -7.794],
                    [8.141, -7]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [5.857, -6.105],
                    [6.75, -6.899],
                    [7.346, -6.205],
                    [6.454, -5.411]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.071, -4.516],
                    [4.963, -5.31],
                    [5.558, -4.617],
                    [4.666, -3.823]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [2.384, -2.828],
                    [3.277, -3.623],
                    [3.872, -2.927],
                    [2.978, -2.134]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.595, -1.24],
                    [1.489, -2.034],
                    [2.086, -1.339],
                    [1.292, -0.544]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.091, 0.348],
                    [-0.199, -0.445],
                    [0.398, 0.25],
                    [-0.495, 1.044]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.779, 2.036],
                    [-1.886, 1.24],
                    [-1.288, 1.937],
                    [-2.184, 2.731]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-4.567, 3.624],
                    [-3.671, 2.83],
                    [-3.078, 3.525],
                    [-3.97, 4.319]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-6.254, 5.213],
                    [-5.362, 4.418],
                    [-4.764, 5.114],
                    [-5.658, 5.907]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-7.942, 6.899],
                    [-7.048, 6.105],
                    [-6.452, 6.801],
                    [-7.344, 7.595]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-9.727, 8.488],
                    [-8.834, 7.694],
                    [-8.24, 8.389],
                    [-9.133, 9.183]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-10.721, 9.482],
                    [-10.522, 9.281],
                    [-9.927, 9.978],
                    [-10.124, 10.177]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.181, 50.98],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, -0.397],
                    [0, -0.201],
                    [-0.099, -0.298],
                    [0, -0.2],
                    [-0.099, -0.2],
                    [-0.101, -0.198],
                    [-0.098, -0.299],
                    [-0.101, -0.298],
                    [-0.099, -0.299],
                    [-0.102, -0.299],
                    [0, -0.298],
                    [-0.1, -0.198],
                    [-0.098, -0.296],
                    [-0.098, -0.2],
                    [-0.101, -0.299],
                    [0, -0.196],
                    [-0.098, -0.197],
                    [0, -0.199],
                    [-0.098, -0.197],
                    [0, -0.2],
                    [-0.099, -0.199],
                    [-0.098, -0.197],
                    [-0.101, -0.298],
                    [-0.098, -0.2],
                    [-0.198, -0.299],
                    [0, -0.2],
                    [-0.098, -0.299],
                    [0, -0.197],
                    [-0.099, -0.299],
                    [-0.098, -0.098],
                    [-0.197, -0.296],
                    [-0.102, -0.197],
                    [-0.099, -0.397],
                    [0, 0],
                    [-0.2, -0.298],
                    [0, 0],
                    [-3.275, -3.873],
                    [-0.896, 0.696],
                    [-0.496, 0.197],
                    [-0.298, 0.299],
                    [-0.296, 0.199],
                    [-1.389, 1.389],
                    [-1.588, 1.388],
                    [-2.084, 1.687],
                    [0.197, 4.07],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.596, -0.497],
                    [0.499, 0.594],
                    [0, 0],
                    [0.595, -0.496],
                    [0.495, 0.594],
                    [0, 0],
                    [0.593, -0.496],
                    [0.496, 0.594],
                    [0, 0],
                    [0.598, -0.397],
                    [0.496, 0.495],
                    [0, 0],
                    [0.593, -0.496],
                    [0.499, 0.495],
                    [0, 0],
                    [0.595, -0.496],
                    [0.495, 0.495],
                    [0, 0],
                    [0.596, -0.496],
                    [0.496, 0.496],
                    [0, 0],
                    [0.496, -0.397],
                    [0.498, 0.496],
                    [0, 0],
                    [0, -0.496],
                    [0, -0.197]
                  ],
                  "o": [
                    [0, 0.199],
                    [0.098, 0.299],
                    [0, 0.2],
                    [0.099, 0.296],
                    [0.098, 0.197],
                    [0.099, 0.297],
                    [0.099, 0.2],
                    [0.099, 0.299],
                    [0.098, 0.199],
                    [0.098, 0.299],
                    [0.099, 0.197],
                    [0.099, 0.299],
                    [0.102, 0.2],
                    [0.099, 0.298],
                    [0.099, 0.198],
                    [0.098, 0.299],
                    [0.099, 0.2],
                    [0.101, 0.197],
                    [0.099, 0.2],
                    [0.098, 0.299],
                    [0.098, 0.198],
                    [0.099, 0.299],
                    [0.099, 0.2],
                    [0.102, 0.296],
                    [0.1, 0.197],
                    [0.098, 0.298],
                    [0.099, 0.197],
                    [0.101, 0.298],
                    [0.101, 0.098],
                    [0.198, 0.298],
                    [0.099, 0.101],
                    [0.197, 0.298],
                    [0, 0.099],
                    [0.2, 0.396],
                    [0, 0],
                    [3.075, 5.162],
                    [0.892, -0.795],
                    [0.397, -0.397],
                    [0.299, -0.299],
                    [0.299, -0.296],
                    [1.489, -1.29],
                    [1.49, -1.49],
                    [2.084, -1.888],
                    [-14.494, -16.085],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.496, 0.598],
                    [-0.595, 0.498],
                    [0, 0],
                    [0.499, 0.598],
                    [-0.595, 0.498],
                    [0, 0],
                    [0.496, 0.598],
                    [-0.598, 0.498],
                    [0, 0],
                    [0.398, 0.597],
                    [-0.594, 0.495],
                    [0, 0],
                    [0.398, 0.598],
                    [-0.598, 0.495],
                    [0, 0],
                    [0.397, 0.598],
                    [-0.597, 0.495],
                    [0, 0],
                    [0.398, 0.598],
                    [-0.595, 0.495],
                    [0, 0],
                    [0.396, 0.594],
                    [-0.496, 0.397],
                    [0, 0],
                    [0.099, 0.496],
                    [0, 0.198],
                    [0.692, 0.201]
                  ],
                  "v": [
                    [-19.207, -7.101],
                    [-19.109, -6.503],
                    [-18.911, -5.611],
                    [-18.81, -5.013],
                    [-18.613, -4.219],
                    [-18.413, -3.625],
                    [-18.217, -2.831],
                    [-18.016, -2.135],
                    [-17.819, -1.34],
                    [-17.618, -0.646],
                    [-17.422, 0.148],
                    [-17.222, 0.744],
                    [-16.927, 1.538],
                    [-16.726, 2.135],
                    [-16.427, 2.929],
                    [-16.23, 3.522],
                    [-15.932, 4.219],
                    [-15.735, 4.815],
                    [-15.436, 5.509],
                    [-15.236, 6.105],
                    [-14.94, 6.801],
                    [-14.642, 7.396],
                    [-14.344, 8.189],
                    [-14.048, 8.788],
                    [-13.65, 9.582],
                    [-13.45, 10.078],
                    [-13.053, 10.872],
                    [-12.856, 11.368],
                    [-12.459, 12.162],
                    [-12.26, 12.559],
                    [-11.763, 13.452],
                    [-11.563, 13.849],
                    [-11.068, 14.843],
                    [-10.969, 15.041],
                    [-10.371, 16.133],
                    [-10.371, 16.231],
                    [-0.744, 29.835],
                    [1.838, 27.551],
                    [3.525, 25.864],
                    [4.418, 24.87],
                    [5.311, 24.076],
                    [9.679, 20.304],
                    [14.146, 16.035],
                    [20.301, 10.573],
                    [4.22, -29.14],
                    [4.22, -29.635],
                    [4.22, -29.737],
                    [4.22, -29.835],
                    [3.128, -28.943],
                    [2.928, -26.957],
                    [0.942, -27.154],
                    [0.148, -26.561],
                    [-0.05, -24.574],
                    [-2.034, -24.771],
                    [-2.829, -24.177],
                    [-3.026, -22.191],
                    [-5.012, -22.388],
                    [-5.806, -21.794],
                    [-6.007, -19.907],
                    [-7.89, -20.005],
                    [-8.685, -19.412],
                    [-8.983, -17.524],
                    [-10.87, -17.623],
                    [-11.664, -17.029],
                    [-11.961, -15.141],
                    [-13.847, -15.24],
                    [-14.642, -14.646],
                    [-14.94, -12.758],
                    [-16.824, -12.858],
                    [-17.618, -12.162],
                    [-17.918, -10.376],
                    [-19.705, -10.476],
                    [-20.301, -9.979],
                    [-20.104, -8.489],
                    [-20.002, -7.994]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.106, 30.926],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [2.084, -1.885],
                    [1.489, -1.389],
                    [1.49, -1.293],
                    [0.299, -0.299],
                    [0.296, -0.296],
                    [0.398, -0.398],
                    [0.894, -0.694],
                    [3.079, 5.162],
                    [0, 0],
                    [0, 0],
                    [0.098, 0.101],
                    [-0.499, 0.498],
                    [-0.495, -0.496],
                    [0, -0.098],
                    [0, 0],
                    [0.099, 0],
                    [-0.495, 0.496],
                    [-0.496, -0.496],
                    [0, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.499, 0.499],
                    [-0.496, -0.495],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.496, 0.496],
                    [-0.496, -0.498],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.499, 0.495],
                    [-0.498, -0.496],
                    [-0.099, 0],
                    [0, 0],
                    [0, 0.098],
                    [-0.496, 0.496],
                    [-0.496, -0.496],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.495, 0.499],
                    [-0.497, -0.495],
                    [0, 0],
                    [-0.498, 0.496],
                    [-0.496, -0.498],
                    [0, 0],
                    [3.87, 4.266]
                  ],
                  "o": [
                    [-1.589, 1.392],
                    [-1.391, 1.391],
                    [-0.298, 0.298],
                    [-0.298, 0.299],
                    [-0.496, 0.2],
                    [-0.895, 0.793],
                    [-3.176, -3.87],
                    [9.83, 16.778],
                    [0, 0],
                    [-0.099, 0],
                    [-0.499, -0.594],
                    [0.594, -0.496],
                    [0.102, 0.102],
                    [0, 0],
                    [-0.099, 0],
                    [-0.495, -0.597],
                    [0.595, -0.496],
                    [0, 0],
                    [0, 0],
                    [-0.101, 0],
                    [-0.499, -0.595],
                    [0.594, -0.495],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.496, -0.598],
                    [0.496, -0.498],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.499, -0.596],
                    [0.594, -0.496],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.496, -0.594],
                    [0.498, -0.496],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.495, -0.597],
                    [0.595, -0.495],
                    [0, 0],
                    [-0.498, -0.598],
                    [0.595, -0.498],
                    [0, 0],
                    [-5.855, -3.377],
                    [-1.589, 2.084]
                  ],
                  "v": [
                    [2.285, -10.724],
                    [-2.182, -6.454],
                    [-6.552, -2.68],
                    [-7.444, -1.886],
                    [-8.336, -0.895],
                    [-10.024, 0.796],
                    [-12.607, 3.077],
                    [-22.237, -10.524],
                    [0.896, 16.579],
                    [1.49, 15.985],
                    [1.294, 15.785],
                    [1.294, 13.799],
                    [3.276, 13.799],
                    [3.378, 13.999],
                    [4.071, 13.303],
                    [3.873, 13.205],
                    [3.873, 11.219],
                    [5.859, 11.219],
                    [5.958, 11.417],
                    [6.653, 10.723],
                    [6.554, 10.623],
                    [6.554, 8.636],
                    [8.538, 8.636],
                    [8.638, 8.738],
                    [9.332, 8.043],
                    [9.233, 7.944],
                    [9.233, 5.958],
                    [11.219, 5.958],
                    [11.317, 6.056],
                    [12.013, 5.361],
                    [11.915, 5.262],
                    [11.915, 3.277],
                    [13.9, 3.277],
                    [13.999, 3.376],
                    [14.694, 2.679],
                    [14.594, 2.581],
                    [14.594, 0.595],
                    [16.579, 0.595],
                    [16.677, 0.694],
                    [17.373, 0.001],
                    [17.274, 0.001],
                    [17.274, -1.988],
                    [19.26, -1.988],
                    [19.956, -2.68],
                    [19.956, -4.666],
                    [21.939, -4.666],
                    [22.237, -4.964],
                    [7.844, -16.579]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.266, 57.484],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Layer 10 Outlines 4",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 0,
              "s": [26]
            },
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 72,
              "s": [-45]
            },
            {
              "t": 138,
              "s": [19]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.458,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [963.5, -165, 0],
              "to": [-0.667, 208, 0],
              "ti": [0.667, -208, 0]
            },
            {
              "t": 143,
              "s": [959.5, 1083, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [119.5, -146, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [66, 66, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.696, 0.794],
                    [-0.2, 0.298],
                    [-0.893, -0.099],
                    [0, 0.695],
                    [-0.296, 2.482],
                    [-1.589, -0.199],
                    [-0.496, -0.595],
                    [0.197, -0.298],
                    [0.794, 0.099],
                    [0.099, -0.596],
                    [0.098, -2.681],
                    [1.785, 0.198]
                  ],
                  "o": [
                    [0.2, -0.298],
                    [0.397, 0.595],
                    [1.093, 0.1],
                    [0.098, -1.588],
                    [0.101, -0.992],
                    [1.093, 0.099],
                    [-0.2, 0.298],
                    [-0.397, -0.497],
                    [-0.893, -0.099],
                    [-0.098, 1.489],
                    [0, 1.092],
                    [-1.093, -0.099]
                  ],
                  "v": [
                    [-2.829, 2.135],
                    [-2.232, 1.44],
                    [-0.049, 2.631],
                    [1.638, 1.638],
                    [-2.333, -1.936],
                    [0.348, -3.524],
                    [2.731, -2.333],
                    [2.235, -1.638],
                    [0.348, -2.73],
                    [-1.241, -1.836],
                    [2.731, 1.738],
                    [-0.049, 3.525]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [67.101, 60.714],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.1],
                    [-0.2, 1.687],
                    [0.896, 0.099],
                    [0.495, -0.397],
                    [0.199, -1.986],
                    [0.397, 0.1],
                    [-0.397, 2.581],
                    [-0.498, -0.099],
                    [0.098, -0.397],
                    [-0.994, -0.099],
                    [0.2, -1.39],
                    [0.099, -1.887]
                  ],
                  "o": [
                    [0.099, -1.787],
                    [0.099, -1.192],
                    [-0.793, -0.199],
                    [-0.299, 1.986],
                    [-0.397, -0.099],
                    [0.298, -2.68],
                    [0.397, 0.099],
                    [-0.101, 0.397],
                    [0.596, -0.497],
                    [1.389, 0.298],
                    [-0.197, 1.886],
                    [-0.495, 0]
                  ],
                  "v": [
                    [1.539, 3.722],
                    [1.936, -0.645],
                    [0.643, -2.432],
                    [-1.539, -1.837],
                    [-2.136, 3.028],
                    [-3.226, 2.829],
                    [-2.334, -3.823],
                    [-1.241, -3.624],
                    [-1.44, -2.631],
                    [1.142, -3.326],
                    [3.026, -0.844],
                    [2.629, 3.823]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.451, 59.622],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.2, 1.39],
                    [1.392, 0.397],
                    [0.298, -1.29],
                    [-1.49, -0.398]
                  ],
                  "o": [
                    [0.197, -1.39],
                    [-1.487, -0.397],
                    [-0.296, 1.39],
                    [1.49, 0.397]
                  ],
                  "v": [
                    [2.384, 0.546],
                    [0.595, -2.63],
                    [-2.184, -0.744],
                    [-0.297, 2.533]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.397, 1.985],
                    [-2.087, -0.596],
                    [0.299, -1.986],
                    [2.182, 0.595]
                  ],
                  "o": [
                    [0.397, -1.986],
                    [2.084, 0.596],
                    [-0.296, 1.986],
                    [-2.087, -0.596]
                  ],
                  "v": [
                    [-3.376, -1.042],
                    [0.697, -3.524],
                    [3.474, 0.845],
                    [-0.494, 3.525]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.757, 58.032],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.296, 1.39],
                    [1.293, 0.397],
                    [0.495, -0.397],
                    [0.298, -1.191],
                    [-0.895, -0.298]
                  ],
                  "o": [
                    [0.298, -1.489],
                    [-0.794, -0.298],
                    [-0.299, 1.192],
                    [0.2, 0.695],
                    [1.389, 0.397]
                  ],
                  "v": [
                    [2.433, 0.397],
                    [0.844, -2.879],
                    [-1.437, -2.582],
                    [-2.134, 0.397],
                    [-0.246, 2.283]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.993],
                    [0.197, -1.489],
                    [0.398, 0.199],
                    [-0.994, 3.673],
                    [-0.495, -0.099],
                    [0.101, -0.397],
                    [-0.994, -0.298],
                    [0.395, -2.185],
                    [1.788, 0.695]
                  ],
                  "o": [
                    [-0.299, 1.39],
                    [-0.496, -0.199],
                    [0.696, -3.772],
                    [0.397, 0.199],
                    [-0.099, 0.397],
                    [0.695, -0.497],
                    [1.786, 0.596],
                    [-0.396, 2.184],
                    [-1.093, -0.298]
                  ],
                  "v": [
                    [-2.33, 1.191],
                    [-3.027, 4.865],
                    [-4.119, 4.467],
                    [-1.933, -4.865],
                    [-0.844, -4.468],
                    [-1.141, -3.475],
                    [1.441, -3.773],
                    [3.725, 0.695],
                    [-0.049, 3.177]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [44.865, 55.998],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.199],
                    [-0.098, 0.397],
                    [1.09, 0.496],
                    [-0.397, 1.489],
                    [-0.597, 1.787],
                    [-0.495, -0.199],
                    [0.499, -1.788],
                    [-0.992, -0.496],
                    [-0.496, 0.298],
                    [-0.496, 1.886],
                    [-0.496, -0.099],
                    [0.595, -2.681]
                  ],
                  "o": [
                    [0.099, -0.397],
                    [-0.693, 0.397],
                    [-1.49, -0.695],
                    [0.499, -1.886],
                    [0.398, 0.198],
                    [-0.594, 1.688],
                    [-0.296, 1.191],
                    [0.893, 0.397],
                    [0.496, -1.985],
                    [0.397, 0.198],
                    [-0.795, 2.681],
                    [-0.397, -0.099]
                  ],
                  "v": [
                    [0.944, 4.219],
                    [1.141, 3.227],
                    [-1.636, 3.227],
                    [-3.326, 0.049],
                    [-1.936, -4.617],
                    [-0.845, -4.121],
                    [-2.135, 0.249],
                    [-0.943, 2.531],
                    [1.341, 2.433],
                    [2.63, -2.433],
                    [3.724, -2.036],
                    [2.036, 4.617]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.321, 52.374],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.397, 1.39],
                    [1.389, 0.794],
                    [0.497, -1.39],
                    [-1.489, -0.794]
                  ],
                  "o": [
                    [0.397, -1.39],
                    [-1.39, -0.794],
                    [-0.496, 1.39],
                    [1.489, 0.794]
                  ],
                  "v": [
                    [2.232, 1.192],
                    [0.843, -2.581],
                    [-2.334, -1.29],
                    [-0.845, 2.582]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.694, 1.887],
                    [-2.085, -1.092],
                    [0.598, -1.886],
                    [2.085, 1.091]
                  ],
                  "o": [
                    [0.696, -1.886],
                    [1.986, 1.093],
                    [-0.594, 1.887],
                    [-2.184, -1.093]
                  ],
                  "v": [
                    [-3.327, -1.886],
                    [1.24, -3.475],
                    [3.423, 1.688],
                    [-1.043, 3.476]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [29.678, 48.75],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.191, 2.78],
                    [-2.581, -1.688],
                    [-0.298, -1.489],
                    [0.496, 0.099],
                    [0.994, 0.694],
                    [0.993, -2.184],
                    [-2.085, -1.291],
                    [-0.794, 0.397],
                    [-0.298, -0.397],
                    [1.688, 1.093]
                  ],
                  "o": [
                    [1.191, -2.78],
                    [1.588, 1.092],
                    [-0.497, 0],
                    [-0.199, -1.092],
                    [-1.985, -1.291],
                    [-0.894, 2.185],
                    [1.092, 0.695],
                    [0.298, 0.496],
                    [-1.191, 0.596],
                    [-2.68, -1.687]
                  ],
                  "v": [
                    [-4.07, -2.979],
                    [2.581, -4.368],
                    [5.261, -0.398],
                    [4.07, -0.496],
                    [2.183, -3.376],
                    [-2.879, -2.086],
                    [-0.794, 3.971],
                    [2.283, 4.269],
                    [3.077, 5.361],
                    [-1.192, 4.964]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.984, 42.793],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.102, -0.099],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, -0.099]
                  ],
                  "v": [
                    [0.051, 0.049],
                    [-0.051, 0.049]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [48.142, 84.443],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.945, -24.971],
                    [1.142, -27.253],
                    [2.83, -27.154],
                    [2.631, -24.871]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.547, -20.502],
                    [0.745, -22.786],
                    [2.432, -22.687],
                    [2.234, -20.403]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.25, -16.035],
                    [0.447, -18.318],
                    [2.136, -18.219],
                    [1.937, -15.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.049, -11.467],
                    [0.15, -13.751],
                    [1.837, -13.651],
                    [1.638, -11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.348, -7],
                    [-0.148, -9.284],
                    [1.54, -9.184],
                    [1.342, -6.9]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.644, -2.532],
                    [-0.446, -4.815],
                    [1.241, -4.716],
                    [1.043, -2.433]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.041, 1.936],
                    [-0.843, -0.348],
                    [0.844, -0.249],
                    [0.646, 2.035]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.339, 6.502],
                    [-1.14, 4.22],
                    [0.547, 4.318],
                    [0.348, 6.603]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.638, 10.971],
                    [-1.438, 8.688],
                    [0.25, 8.787],
                    [0.048, 11.07]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.934, 15.438],
                    [-1.736, 13.154],
                    [-0.049, 13.254],
                    [-0.247, 15.538]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.232, 19.907],
                    [-2.034, 17.623],
                    [-0.348, 17.722],
                    [-0.545, 20.005]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.629, 24.474],
                    [-2.433, 22.189],
                    [-0.745, 22.289],
                    [-0.942, 24.573]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.83, 27.154],
                    [-2.83, 26.757],
                    [-1.14, 26.856],
                    [-1.14, 27.253]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [81.297, 63.891],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.596, -0.397],
                    [-0.298, -0.298],
                    [-0.496, -0.298],
                    [-0.297, -0.198],
                    [-0.497, -0.297],
                    [-0.397, -0.199],
                    [-0.397, -0.298],
                    [-0.397, -0.298],
                    [-0.397, -0.297],
                    [-0.397, -0.299],
                    [-0.397, -0.298],
                    [-0.298, -0.198],
                    [-0.397, -0.198],
                    [-0.298, -0.199],
                    [-0.397, -0.198],
                    [-0.298, -0.199],
                    [-0.497, -0.199],
                    [-0.297, -0.099],
                    [-0.496, -0.298],
                    [-0.397, -0.199],
                    [-0.497, -0.199],
                    [-0.397, -0.199],
                    [-0.397, -0.198],
                    [-0.397, -0.1],
                    [-0.498, -0.198],
                    [-0.299, -0.099],
                    [-0.595, -0.199],
                    [-0.398, -0.198],
                    [-0.496, -0.198],
                    [-0.299, -0.099],
                    [-0.595, -0.199],
                    [-0.2, 0],
                    [-0.696, -0.297],
                    [-0.199, -0.099],
                    [-0.696, -0.199],
                    [0, 0],
                    [-9.429, -1.191],
                    [-0.197, 2.184],
                    [-0.496, 0.992],
                    [0, 0],
                    [-0.099, 0.695],
                    [-0.098, 3.674],
                    [-0.397, 3.971],
                    [-0.696, 5.163],
                    [5.46, 5.461],
                    [0.199, 0.198],
                    [0, 0],
                    [0, 0],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0.199],
                    [0, 0],
                    [0.199, -1.39],
                    [1.489, 0.199],
                    [0, 0],
                    [0.198, -1.39],
                    [1.39, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.389, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0],
                    [0, 0],
                    [0.198, -1.39],
                    [1.291, 0],
                    [0, 0],
                    [0.199, -1.389],
                    [1.29, 0],
                    [0, 0],
                    [-0.794, -0.595],
                    [-0.299, -0.199]
                  ],
                  "o": [
                    [0.297, 0.199],
                    [0.497, 0.298],
                    [0.298, 0.199],
                    [0.497, 0.298],
                    [0.396, 0.199],
                    [0.397, 0.298],
                    [0.397, 0.198],
                    [0.397, 0.298],
                    [0.397, 0.199],
                    [0.397, 0.297],
                    [0.397, 0.198],
                    [0.397, 0.199],
                    [0.397, 0.199],
                    [0.398, 0.199],
                    [0.397, 0.199],
                    [0.496, 0.198],
                    [0.397, 0.199],
                    [0.496, 0.199],
                    [0.397, 0.199],
                    [0.496, 0.198],
                    [0.397, 0.198],
                    [0.496, 0.198],
                    [0.398, 0.1],
                    [0.496, 0.198],
                    [0.296, 0.1],
                    [0.496, 0.199],
                    [0.298, 0.099],
                    [0.495, 0.199],
                    [0.299, 0.099],
                    [0.594, 0.198],
                    [0.199, 0.099],
                    [0.693, 0.199],
                    [0.197, 0.1],
                    [0.795, 0.298],
                    [0, 0],
                    [10.92, 3.276],
                    [0.198, -2.184],
                    [0.101, -1.092],
                    [0, 0],
                    [0, -0.795],
                    [0.397, -3.673],
                    [0.2, -3.971],
                    [0.597, -5.262],
                    [-40.998, -3.772],
                    [-0.298, -0.298],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.49, 0.199],
                    [-0.198, 1.49],
                    [0, 0],
                    [1.489, 0.199],
                    [-0.198, 1.489],
                    [0, 0],
                    [1.39, 0.198],
                    [-0.199, 1.39],
                    [0, 0],
                    [1.39, 0.298],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.389, 0.297],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.291, 0.298],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.291, 0.298],
                    [-0.199, 1.39],
                    [0, 0],
                    [1.29, 0.397],
                    [-0.198, 1.291],
                    [0, 0],
                    [0.794, 0.596],
                    [0.298, 0.199],
                    [0.893, 0]
                  ],
                  "v": [
                    [-36.332, 17.623],
                    [-35.439, 18.318],
                    [-34.049, 19.311],
                    [-33.057, 20.006],
                    [-31.667, 20.899],
                    [-30.575, 21.595],
                    [-29.284, 22.488],
                    [-28.192, 23.183],
                    [-26.902, 23.977],
                    [-25.81, 24.673],
                    [-24.519, 25.467],
                    [-23.427, 26.062],
                    [-22.137, 26.757],
                    [-21.045, 27.353],
                    [-19.754, 28.048],
                    [-18.662, 28.644],
                    [-17.272, 29.339],
                    [-16.181, 29.835],
                    [-14.792, 30.53],
                    [-13.699, 31.027],
                    [-12.309, 31.623],
                    [-11.217, 32.119],
                    [-9.829, 32.714],
                    [-8.736, 33.112],
                    [-7.246, 33.707],
                    [-6.254, 34.104],
                    [-4.665, 34.7],
                    [-3.671, 35.097],
                    [-2.086, 35.693],
                    [-1.19, 35.991],
                    [0.596, 36.587],
                    [1.291, 36.785],
                    [3.277, 37.48],
                    [3.771, 37.679],
                    [6.057, 38.374],
                    [6.155, 38.374],
                    [37.027, 44.926],
                    [37.622, 38.374],
                    [37.822, 33.807],
                    [37.822, 31.325],
                    [38.019, 29.041],
                    [39.21, 18.219],
                    [39.906, 6.404],
                    [41.396, -9.184],
                    [-32.262, -43.933],
                    [-32.957, -44.628],
                    [-33.057, -44.727],
                    [-33.156, -44.827],
                    [-33.255, -44.926],
                    [-33.652, -42.245],
                    [-33.553, -42.245],
                    [-31.271, -39.267],
                    [-34.248, -36.983],
                    [-34.446, -35.097],
                    [-32.163, -32.118],
                    [-35.141, -29.835],
                    [-35.439, -27.948],
                    [-33.255, -24.97],
                    [-36.134, -22.686],
                    [-36.432, -20.8],
                    [-34.248, -17.821],
                    [-37.126, -15.538],
                    [-37.424, -13.651],
                    [-35.34, -10.673],
                    [-38.119, -8.389],
                    [-38.417, -6.503],
                    [-36.432, -3.524],
                    [-39.211, -1.241],
                    [-39.509, 0.645],
                    [-37.523, 3.624],
                    [-40.204, 5.908],
                    [-40.501, 7.794],
                    [-38.616, 10.772],
                    [-41.196, 13.056],
                    [-41.396, 14.446],
                    [-39.112, 16.233],
                    [-38.317, 16.829]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [41.739, 46.019],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.496, -5.262],
                    [0.2, -3.971],
                    [0.397, -3.574],
                    [0.098, -0.794],
                    [0, 0],
                    [0.098, -1.092],
                    [0.197, -2.184],
                    [10.917, 3.276],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.389, -0.099],
                    [-0.098, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.388, -0.099],
                    [-0.099, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [-0.098, -0.1],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.389],
                    [-1.388, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.389],
                    [-1.389, -0.099],
                    [0, 0],
                    [10.819, 0.993]
                  ],
                  "o": [
                    [-0.397, 3.972],
                    [-0.197, 3.674],
                    [-0.099, 0.794],
                    [0, 0],
                    [-0.499, 0.993],
                    [-0.197, 2.184],
                    [-9.433, -1.191],
                    [35.338, 10.722],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.099],
                    [0.101, -1.489],
                    [0.199, 0],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.1],
                    [0.101, -1.49],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.1],
                    [0.099, -1.488],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.49],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.49, -0.099],
                    [0.101, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.49, -0.1],
                    [0.101, -1.49],
                    [0, 0],
                    [-12.508, 2.78],
                    [-0.397, 4.865]
                  ],
                  "v": [
                    [-1.241, -12.56],
                    [-1.937, -0.744],
                    [-3.128, 10.077],
                    [-3.325, 12.361],
                    [-3.325, 14.844],
                    [-3.525, 19.41],
                    [-4.119, 25.963],
                    [-34.991, 19.41],
                    [32.211, 27.452],
                    [32.312, 25.864],
                    [31.814, 25.864],
                    [29.333, 23.083],
                    [32.113, 20.601],
                    [32.509, 20.7],
                    [32.608, 18.716],
                    [32.211, 18.716],
                    [29.73, 15.935],
                    [32.509, 13.453],
                    [32.907, 13.552],
                    [33.006, 11.666],
                    [32.608, 11.666],
                    [30.127, 8.885],
                    [32.907, 6.404],
                    [33.205, 6.504],
                    [33.304, 4.616],
                    [33.006, 4.616],
                    [30.524, 1.837],
                    [33.304, -0.646],
                    [33.602, -0.646],
                    [33.701, -2.531],
                    [33.403, -2.531],
                    [30.921, -5.312],
                    [33.701, -7.794],
                    [33.901, -7.794],
                    [34, -9.68],
                    [33.8, -9.68],
                    [31.318, -12.46],
                    [34.098, -14.943],
                    [34.298, -14.943],
                    [34.397, -16.828],
                    [34.298, -16.828],
                    [31.814, -19.609],
                    [34.594, -22.091],
                    [34.695, -22.091],
                    [34.794, -23.977],
                    [34.695, -23.977],
                    [32.211, -26.757],
                    [34.991, -29.24],
                    [34.991, -30.133],
                    [-0.05, -27.849]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.184, 64.884],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 11",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 11,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Layer 10 Outlines 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 0,
              "s": [26]
            },
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 72,
              "s": [-45]
            },
            {
              "t": 138,
              "s": [19]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.458,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [993.5, -439, 0],
              "to": [-8, 172.667, 0],
              "ti": [8, -172.667, 0]
            },
            {
              "t": 143,
              "s": [945.5, 597, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [119.5, -146, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [100, 100, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.696, 0.794],
                    [-0.2, 0.298],
                    [-0.893, -0.099],
                    [0, 0.695],
                    [-0.296, 2.482],
                    [-1.589, -0.199],
                    [-0.496, -0.595],
                    [0.197, -0.298],
                    [0.794, 0.099],
                    [0.099, -0.596],
                    [0.098, -2.681],
                    [1.785, 0.198]
                  ],
                  "o": [
                    [0.2, -0.298],
                    [0.397, 0.595],
                    [1.093, 0.1],
                    [0.098, -1.588],
                    [0.101, -0.992],
                    [1.093, 0.099],
                    [-0.2, 0.298],
                    [-0.397, -0.497],
                    [-0.893, -0.099],
                    [-0.098, 1.489],
                    [0, 1.092],
                    [-1.093, -0.099]
                  ],
                  "v": [
                    [-2.829, 2.135],
                    [-2.232, 1.44],
                    [-0.049, 2.631],
                    [1.638, 1.638],
                    [-2.333, -1.936],
                    [0.348, -3.524],
                    [2.731, -2.333],
                    [2.235, -1.638],
                    [0.348, -2.73],
                    [-1.241, -1.836],
                    [2.731, 1.738],
                    [-0.049, 3.525]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [67.101, 60.714],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.1],
                    [-0.2, 1.687],
                    [0.896, 0.099],
                    [0.495, -0.397],
                    [0.199, -1.986],
                    [0.397, 0.1],
                    [-0.397, 2.581],
                    [-0.498, -0.099],
                    [0.098, -0.397],
                    [-0.994, -0.099],
                    [0.2, -1.39],
                    [0.099, -1.887]
                  ],
                  "o": [
                    [0.099, -1.787],
                    [0.099, -1.192],
                    [-0.793, -0.199],
                    [-0.299, 1.986],
                    [-0.397, -0.099],
                    [0.298, -2.68],
                    [0.397, 0.099],
                    [-0.101, 0.397],
                    [0.596, -0.497],
                    [1.389, 0.298],
                    [-0.197, 1.886],
                    [-0.495, 0]
                  ],
                  "v": [
                    [1.539, 3.722],
                    [1.936, -0.645],
                    [0.643, -2.432],
                    [-1.539, -1.837],
                    [-2.136, 3.028],
                    [-3.226, 2.829],
                    [-2.334, -3.823],
                    [-1.241, -3.624],
                    [-1.44, -2.631],
                    [1.142, -3.326],
                    [3.026, -0.844],
                    [2.629, 3.823]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.451, 59.622],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.2, 1.39],
                    [1.392, 0.397],
                    [0.298, -1.29],
                    [-1.49, -0.398]
                  ],
                  "o": [
                    [0.197, -1.39],
                    [-1.487, -0.397],
                    [-0.296, 1.39],
                    [1.49, 0.397]
                  ],
                  "v": [
                    [2.384, 0.546],
                    [0.595, -2.63],
                    [-2.184, -0.744],
                    [-0.297, 2.533]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.397, 1.985],
                    [-2.087, -0.596],
                    [0.299, -1.986],
                    [2.182, 0.595]
                  ],
                  "o": [
                    [0.397, -1.986],
                    [2.084, 0.596],
                    [-0.296, 1.986],
                    [-2.087, -0.596]
                  ],
                  "v": [
                    [-3.376, -1.042],
                    [0.697, -3.524],
                    [3.474, 0.845],
                    [-0.494, 3.525]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.757, 58.032],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.296, 1.39],
                    [1.293, 0.397],
                    [0.495, -0.397],
                    [0.298, -1.191],
                    [-0.895, -0.298]
                  ],
                  "o": [
                    [0.298, -1.489],
                    [-0.794, -0.298],
                    [-0.299, 1.192],
                    [0.2, 0.695],
                    [1.389, 0.397]
                  ],
                  "v": [
                    [2.433, 0.397],
                    [0.844, -2.879],
                    [-1.437, -2.582],
                    [-2.134, 0.397],
                    [-0.246, 2.283]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.993],
                    [0.197, -1.489],
                    [0.398, 0.199],
                    [-0.994, 3.673],
                    [-0.495, -0.099],
                    [0.101, -0.397],
                    [-0.994, -0.298],
                    [0.395, -2.185],
                    [1.788, 0.695]
                  ],
                  "o": [
                    [-0.299, 1.39],
                    [-0.496, -0.199],
                    [0.696, -3.772],
                    [0.397, 0.199],
                    [-0.099, 0.397],
                    [0.695, -0.497],
                    [1.786, 0.596],
                    [-0.396, 2.184],
                    [-1.093, -0.298]
                  ],
                  "v": [
                    [-2.33, 1.191],
                    [-3.027, 4.865],
                    [-4.119, 4.467],
                    [-1.933, -4.865],
                    [-0.844, -4.468],
                    [-1.141, -3.475],
                    [1.441, -3.773],
                    [3.725, 0.695],
                    [-0.049, 3.177]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [44.865, 55.998],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.199],
                    [-0.098, 0.397],
                    [1.09, 0.496],
                    [-0.397, 1.489],
                    [-0.597, 1.787],
                    [-0.495, -0.199],
                    [0.499, -1.788],
                    [-0.992, -0.496],
                    [-0.496, 0.298],
                    [-0.496, 1.886],
                    [-0.496, -0.099],
                    [0.595, -2.681]
                  ],
                  "o": [
                    [0.099, -0.397],
                    [-0.693, 0.397],
                    [-1.49, -0.695],
                    [0.499, -1.886],
                    [0.398, 0.198],
                    [-0.594, 1.688],
                    [-0.296, 1.191],
                    [0.893, 0.397],
                    [0.496, -1.985],
                    [0.397, 0.198],
                    [-0.795, 2.681],
                    [-0.397, -0.099]
                  ],
                  "v": [
                    [0.944, 4.219],
                    [1.141, 3.227],
                    [-1.636, 3.227],
                    [-3.326, 0.049],
                    [-1.936, -4.617],
                    [-0.845, -4.121],
                    [-2.135, 0.249],
                    [-0.943, 2.531],
                    [1.341, 2.433],
                    [2.63, -2.433],
                    [3.724, -2.036],
                    [2.036, 4.617]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.321, 52.374],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.397, 1.39],
                    [1.389, 0.794],
                    [0.497, -1.39],
                    [-1.489, -0.794]
                  ],
                  "o": [
                    [0.397, -1.39],
                    [-1.39, -0.794],
                    [-0.496, 1.39],
                    [1.489, 0.794]
                  ],
                  "v": [
                    [2.232, 1.192],
                    [0.843, -2.581],
                    [-2.334, -1.29],
                    [-0.845, 2.582]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.694, 1.887],
                    [-2.085, -1.092],
                    [0.598, -1.886],
                    [2.085, 1.091]
                  ],
                  "o": [
                    [0.696, -1.886],
                    [1.986, 1.093],
                    [-0.594, 1.887],
                    [-2.184, -1.093]
                  ],
                  "v": [
                    [-3.327, -1.886],
                    [1.24, -3.475],
                    [3.423, 1.688],
                    [-1.043, 3.476]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [29.678, 48.75],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.191, 2.78],
                    [-2.581, -1.688],
                    [-0.298, -1.489],
                    [0.496, 0.099],
                    [0.994, 0.694],
                    [0.993, -2.184],
                    [-2.085, -1.291],
                    [-0.794, 0.397],
                    [-0.298, -0.397],
                    [1.688, 1.093]
                  ],
                  "o": [
                    [1.191, -2.78],
                    [1.588, 1.092],
                    [-0.497, 0],
                    [-0.199, -1.092],
                    [-1.985, -1.291],
                    [-0.894, 2.185],
                    [1.092, 0.695],
                    [0.298, 0.496],
                    [-1.191, 0.596],
                    [-2.68, -1.687]
                  ],
                  "v": [
                    [-4.07, -2.979],
                    [2.581, -4.368],
                    [5.261, -0.398],
                    [4.07, -0.496],
                    [2.183, -3.376],
                    [-2.879, -2.086],
                    [-0.794, 3.971],
                    [2.283, 4.269],
                    [3.077, 5.361],
                    [-1.192, 4.964]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.984, 42.793],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.102, -0.099],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, -0.099]
                  ],
                  "v": [
                    [0.051, 0.049],
                    [-0.051, 0.049]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [48.142, 84.443],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.945, -24.971],
                    [1.142, -27.253],
                    [2.83, -27.154],
                    [2.631, -24.871]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.547, -20.502],
                    [0.745, -22.786],
                    [2.432, -22.687],
                    [2.234, -20.403]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.25, -16.035],
                    [0.447, -18.318],
                    [2.136, -18.219],
                    [1.937, -15.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.049, -11.467],
                    [0.15, -13.751],
                    [1.837, -13.651],
                    [1.638, -11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.348, -7],
                    [-0.148, -9.284],
                    [1.54, -9.184],
                    [1.342, -6.9]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.644, -2.532],
                    [-0.446, -4.815],
                    [1.241, -4.716],
                    [1.043, -2.433]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.041, 1.936],
                    [-0.843, -0.348],
                    [0.844, -0.249],
                    [0.646, 2.035]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.339, 6.502],
                    [-1.14, 4.22],
                    [0.547, 4.318],
                    [0.348, 6.603]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.638, 10.971],
                    [-1.438, 8.688],
                    [0.25, 8.787],
                    [0.048, 11.07]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.934, 15.438],
                    [-1.736, 13.154],
                    [-0.049, 13.254],
                    [-0.247, 15.538]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.232, 19.907],
                    [-2.034, 17.623],
                    [-0.348, 17.722],
                    [-0.545, 20.005]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.629, 24.474],
                    [-2.433, 22.189],
                    [-0.745, 22.289],
                    [-0.942, 24.573]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.83, 27.154],
                    [-2.83, 26.757],
                    [-1.14, 26.856],
                    [-1.14, 27.253]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [81.297, 63.891],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.596, -0.397],
                    [-0.298, -0.298],
                    [-0.496, -0.298],
                    [-0.297, -0.198],
                    [-0.497, -0.297],
                    [-0.397, -0.199],
                    [-0.397, -0.298],
                    [-0.397, -0.298],
                    [-0.397, -0.297],
                    [-0.397, -0.299],
                    [-0.397, -0.298],
                    [-0.298, -0.198],
                    [-0.397, -0.198],
                    [-0.298, -0.199],
                    [-0.397, -0.198],
                    [-0.298, -0.199],
                    [-0.497, -0.199],
                    [-0.297, -0.099],
                    [-0.496, -0.298],
                    [-0.397, -0.199],
                    [-0.497, -0.199],
                    [-0.397, -0.199],
                    [-0.397, -0.198],
                    [-0.397, -0.1],
                    [-0.498, -0.198],
                    [-0.299, -0.099],
                    [-0.595, -0.199],
                    [-0.398, -0.198],
                    [-0.496, -0.198],
                    [-0.299, -0.099],
                    [-0.595, -0.199],
                    [-0.2, 0],
                    [-0.696, -0.297],
                    [-0.199, -0.099],
                    [-0.696, -0.199],
                    [0, 0],
                    [-9.429, -1.191],
                    [-0.197, 2.184],
                    [-0.496, 0.992],
                    [0, 0],
                    [-0.099, 0.695],
                    [-0.098, 3.674],
                    [-0.397, 3.971],
                    [-0.696, 5.163],
                    [5.46, 5.461],
                    [0.199, 0.198],
                    [0, 0],
                    [0, 0],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0.199],
                    [0, 0],
                    [0.199, -1.39],
                    [1.489, 0.199],
                    [0, 0],
                    [0.198, -1.39],
                    [1.39, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.389, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0],
                    [0, 0],
                    [0.198, -1.39],
                    [1.291, 0],
                    [0, 0],
                    [0.199, -1.389],
                    [1.29, 0],
                    [0, 0],
                    [-0.794, -0.595],
                    [-0.299, -0.199]
                  ],
                  "o": [
                    [0.297, 0.199],
                    [0.497, 0.298],
                    [0.298, 0.199],
                    [0.497, 0.298],
                    [0.396, 0.199],
                    [0.397, 0.298],
                    [0.397, 0.198],
                    [0.397, 0.298],
                    [0.397, 0.199],
                    [0.397, 0.297],
                    [0.397, 0.198],
                    [0.397, 0.199],
                    [0.397, 0.199],
                    [0.398, 0.199],
                    [0.397, 0.199],
                    [0.496, 0.198],
                    [0.397, 0.199],
                    [0.496, 0.199],
                    [0.397, 0.199],
                    [0.496, 0.198],
                    [0.397, 0.198],
                    [0.496, 0.198],
                    [0.398, 0.1],
                    [0.496, 0.198],
                    [0.296, 0.1],
                    [0.496, 0.199],
                    [0.298, 0.099],
                    [0.495, 0.199],
                    [0.299, 0.099],
                    [0.594, 0.198],
                    [0.199, 0.099],
                    [0.693, 0.199],
                    [0.197, 0.1],
                    [0.795, 0.298],
                    [0, 0],
                    [10.92, 3.276],
                    [0.198, -2.184],
                    [0.101, -1.092],
                    [0, 0],
                    [0, -0.795],
                    [0.397, -3.673],
                    [0.2, -3.971],
                    [0.597, -5.262],
                    [-40.998, -3.772],
                    [-0.298, -0.298],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.49, 0.199],
                    [-0.198, 1.49],
                    [0, 0],
                    [1.489, 0.199],
                    [-0.198, 1.489],
                    [0, 0],
                    [1.39, 0.198],
                    [-0.199, 1.39],
                    [0, 0],
                    [1.39, 0.298],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.389, 0.297],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.291, 0.298],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.291, 0.298],
                    [-0.199, 1.39],
                    [0, 0],
                    [1.29, 0.397],
                    [-0.198, 1.291],
                    [0, 0],
                    [0.794, 0.596],
                    [0.298, 0.199],
                    [0.893, 0]
                  ],
                  "v": [
                    [-36.332, 17.623],
                    [-35.439, 18.318],
                    [-34.049, 19.311],
                    [-33.057, 20.006],
                    [-31.667, 20.899],
                    [-30.575, 21.595],
                    [-29.284, 22.488],
                    [-28.192, 23.183],
                    [-26.902, 23.977],
                    [-25.81, 24.673],
                    [-24.519, 25.467],
                    [-23.427, 26.062],
                    [-22.137, 26.757],
                    [-21.045, 27.353],
                    [-19.754, 28.048],
                    [-18.662, 28.644],
                    [-17.272, 29.339],
                    [-16.181, 29.835],
                    [-14.792, 30.53],
                    [-13.699, 31.027],
                    [-12.309, 31.623],
                    [-11.217, 32.119],
                    [-9.829, 32.714],
                    [-8.736, 33.112],
                    [-7.246, 33.707],
                    [-6.254, 34.104],
                    [-4.665, 34.7],
                    [-3.671, 35.097],
                    [-2.086, 35.693],
                    [-1.19, 35.991],
                    [0.596, 36.587],
                    [1.291, 36.785],
                    [3.277, 37.48],
                    [3.771, 37.679],
                    [6.057, 38.374],
                    [6.155, 38.374],
                    [37.027, 44.926],
                    [37.622, 38.374],
                    [37.822, 33.807],
                    [37.822, 31.325],
                    [38.019, 29.041],
                    [39.21, 18.219],
                    [39.906, 6.404],
                    [41.396, -9.184],
                    [-32.262, -43.933],
                    [-32.957, -44.628],
                    [-33.057, -44.727],
                    [-33.156, -44.827],
                    [-33.255, -44.926],
                    [-33.652, -42.245],
                    [-33.553, -42.245],
                    [-31.271, -39.267],
                    [-34.248, -36.983],
                    [-34.446, -35.097],
                    [-32.163, -32.118],
                    [-35.141, -29.835],
                    [-35.439, -27.948],
                    [-33.255, -24.97],
                    [-36.134, -22.686],
                    [-36.432, -20.8],
                    [-34.248, -17.821],
                    [-37.126, -15.538],
                    [-37.424, -13.651],
                    [-35.34, -10.673],
                    [-38.119, -8.389],
                    [-38.417, -6.503],
                    [-36.432, -3.524],
                    [-39.211, -1.241],
                    [-39.509, 0.645],
                    [-37.523, 3.624],
                    [-40.204, 5.908],
                    [-40.501, 7.794],
                    [-38.616, 10.772],
                    [-41.196, 13.056],
                    [-41.396, 14.446],
                    [-39.112, 16.233],
                    [-38.317, 16.829]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [41.739, 46.019],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.496, -5.262],
                    [0.2, -3.971],
                    [0.397, -3.574],
                    [0.098, -0.794],
                    [0, 0],
                    [0.098, -1.092],
                    [0.197, -2.184],
                    [10.917, 3.276],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.389, -0.099],
                    [-0.098, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.388, -0.099],
                    [-0.099, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [-0.098, -0.1],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.389],
                    [-1.388, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.389],
                    [-1.389, -0.099],
                    [0, 0],
                    [10.819, 0.993]
                  ],
                  "o": [
                    [-0.397, 3.972],
                    [-0.197, 3.674],
                    [-0.099, 0.794],
                    [0, 0],
                    [-0.499, 0.993],
                    [-0.197, 2.184],
                    [-9.433, -1.191],
                    [35.338, 10.722],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.099],
                    [0.101, -1.489],
                    [0.199, 0],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.1],
                    [0.101, -1.49],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.1],
                    [0.099, -1.488],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.49],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.49, -0.099],
                    [0.101, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.49, -0.1],
                    [0.101, -1.49],
                    [0, 0],
                    [-12.508, 2.78],
                    [-0.397, 4.865]
                  ],
                  "v": [
                    [-1.241, -12.56],
                    [-1.937, -0.744],
                    [-3.128, 10.077],
                    [-3.325, 12.361],
                    [-3.325, 14.844],
                    [-3.525, 19.41],
                    [-4.119, 25.963],
                    [-34.991, 19.41],
                    [32.211, 27.452],
                    [32.312, 25.864],
                    [31.814, 25.864],
                    [29.333, 23.083],
                    [32.113, 20.601],
                    [32.509, 20.7],
                    [32.608, 18.716],
                    [32.211, 18.716],
                    [29.73, 15.935],
                    [32.509, 13.453],
                    [32.907, 13.552],
                    [33.006, 11.666],
                    [32.608, 11.666],
                    [30.127, 8.885],
                    [32.907, 6.404],
                    [33.205, 6.504],
                    [33.304, 4.616],
                    [33.006, 4.616],
                    [30.524, 1.837],
                    [33.304, -0.646],
                    [33.602, -0.646],
                    [33.701, -2.531],
                    [33.403, -2.531],
                    [30.921, -5.312],
                    [33.701, -7.794],
                    [33.901, -7.794],
                    [34, -9.68],
                    [33.8, -9.68],
                    [31.318, -12.46],
                    [34.098, -14.943],
                    [34.298, -14.943],
                    [34.397, -16.828],
                    [34.298, -16.828],
                    [31.814, -19.609],
                    [34.594, -22.091],
                    [34.695, -22.091],
                    [34.794, -23.977],
                    [34.695, -23.977],
                    [32.211, -26.757],
                    [34.991, -29.24],
                    [34.991, -30.133],
                    [-0.05, -27.849]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.184, 64.884],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 11",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 11,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Layer 9 Outlines 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [1]
              },
              "o": {
                "x": [0.167],
                "y": [0]
              },
              "t": 99,
              "s": [456]
            },
            {
              "t": 143,
              "s": [373]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [1010.5, 163, 0],
              "to": [15.333, 100, 0],
              "ti": [-15.333, -100, 0]
            },
            {
              "t": 143,
              "s": [932.5, 1477, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [8.5, -7, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [100, 100, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.093, -0.099],
                    [0.098, 0.397],
                    [-0.598, 0.695],
                    [0.495, 0.398],
                    [1.887, 1.589],
                    [-0.991, 1.191],
                    [-0.695, 0.099],
                    [-0.101, -0.298],
                    [0.497, -0.596],
                    [-0.499, -0.397],
                    [-2.183, -1.489],
                    [1.093, -1.39]
                  ],
                  "o": [
                    [-0.099, -0.397],
                    [0.695, 0],
                    [0.692, -0.794],
                    [-1.29, -0.992],
                    [-0.793, -0.695],
                    [0.695, -0.894],
                    [0.099, 0.298],
                    [-0.598, 0],
                    [-0.596, 0.695],
                    [1.19, 0.893],
                    [0.895, 0.695],
                    [-0.893, 0.894]
                  ],
                  "v": [
                    [-0.05, 3.524],
                    [-0.248, 2.631],
                    [2.037, 1.439],
                    [2.135, -0.546],
                    [-3.028, 0.844],
                    [-2.93, -2.233],
                    [-0.646, -3.524],
                    [-0.347, -2.73],
                    [-2.234, -1.737],
                    [-2.332, 0.05],
                    [2.828, -1.34],
                    [2.828, 1.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.541, 57.811],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.299, -0.397],
                    [1.389, 1.191],
                    [0.696, -0.695],
                    [-0.2, -0.694],
                    [-1.489, -1.291],
                    [0.299, -0.298],
                    [1.885, 1.788],
                    [-0.295, 0.298],
                    [-0.298, -0.298],
                    [-0.693, 0.695],
                    [-1.092, -0.894],
                    [-1.49, -1.093]
                  ],
                  "o": [
                    [-1.389, -1.092],
                    [-0.892, -0.794],
                    [-0.594, 0.596],
                    [1.488, 1.291],
                    [-0.298, 0.298],
                    [-2.084, -1.688],
                    [0.296, -0.297],
                    [0.299, 0.298],
                    [-0.099, -0.695],
                    [0.994, -0.993],
                    [1.491, 1.191],
                    [-0.197, 0.297]
                  ],
                  "v": [
                    [3.87, 0.546],
                    [0.397, -2.234],
                    [-1.887, -2.135],
                    [-2.481, 0.049],
                    [1.29, 3.227],
                    [0.496, 4.021],
                    [-4.566, -0.348],
                    [-3.774, -1.142],
                    [-3.078, -0.447],
                    [-2.185, -2.929],
                    [0.893, -3.127],
                    [4.566, -0.248]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [78.825, 63.073],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.894],
                    [1.192, -0.992],
                    [-0.994, -0.993],
                    [-1.191, 0.993]
                  ],
                  "o": [
                    [-0.991, -0.894],
                    [-1.09, 0.993],
                    [0.991, 0.993],
                    [1.192, -1.091]
                  ],
                  "v": [
                    [1.686, -1.638],
                    [-1.988, -1.837],
                    [-1.885, 1.539],
                    [1.885, 1.737]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.489, 1.39],
                    [-1.588, 1.39],
                    [-1.487, -1.291],
                    [1.687, -1.489]
                  ],
                  "o": [
                    [-1.388, -1.389],
                    [1.589, -1.39],
                    [1.49, 1.29],
                    [-1.589, 1.489]
                  ],
                  "v": [
                    [-2.781, 2.333],
                    [-2.68, -2.432],
                    [2.48, -2.432],
                    [2.582, 2.333]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [73.267, 68.335],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.09, 1.092],
                    [1.192, -0.894],
                    [-0.099, -0.694],
                    [-0.896, -0.893],
                    [-0.696, 0.596]
                  ],
                  "o": [
                    [-1.093, -1.092],
                    [-0.695, 0.496],
                    [0.893, 0.894],
                    [0.693, 0.199],
                    [1.191, -0.992]
                  ],
                  "v": [
                    [2.135, -2.631],
                    [-1.538, -3.028],
                    [-2.532, -0.944],
                    [-0.346, 1.34],
                    [2.234, 0.744]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.199],
                    [-1.093, -0.993],
                    [0.397, -0.298],
                    [2.58, 2.779],
                    [-0.299, 0.298],
                    [-0.298, -0.298],
                    [-0.794, 0.596],
                    [-1.588, -1.589],
                    [1.589, -1.191]
                  ],
                  "o": [
                    [0.994, 0.992],
                    [-0.397, 0.298],
                    [-2.779, -2.681],
                    [0.397, -0.298],
                    [0.299, 0.298],
                    [0, -0.795],
                    [1.487, -1.191],
                    [1.589, 1.489],
                    [-0.794, 0.596]
                  ],
                  "v": [
                    [0.248, 1.837],
                    [2.929, 4.418],
                    [1.935, 5.113],
                    [-4.715, -1.737],
                    [-3.822, -2.433],
                    [-3.127, -1.638],
                    [-1.935, -3.922],
                    [3.126, -3.326],
                    [3.126, 1.241]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [66.664, 74.689],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, -0.298],
                    [0.296, 0.298],
                    [0.992, -0.694],
                    [0.994, 1.092],
                    [1.29, 1.589],
                    [-0.398, 0.199],
                    [-1.191, -1.39],
                    [-0.794, 0.497],
                    [0, 0.595],
                    [1.29, 1.489],
                    [-0.396, 0.198],
                    [-1.887, -1.985]
                  ],
                  "o": [
                    [-0.296, -0.298],
                    [-0.101, 0.794],
                    [-1.388, 0.894],
                    [-1.29, -1.49],
                    [0.397, -0.199],
                    [1.191, 1.39],
                    [0.794, 0.894],
                    [0.794, -0.497],
                    [-1.389, -1.49],
                    [0.396, -0.298],
                    [1.788, 2.085],
                    [-0.397, 0.1]
                  ],
                  "v": [
                    [3.97, 1.489],
                    [3.277, 0.794],
                    [1.787, 3.176],
                    [-1.787, 2.879],
                    [-4.964, -0.894],
                    [-3.969, -1.489],
                    [-0.993, 1.985],
                    [1.489, 2.284],
                    [2.68, 0.298],
                    [-0.694, -3.475],
                    [0.297, -4.07],
                    [4.964, 0.993]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.162, 78.313],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.893, 1.092],
                    [1.392, -0.695],
                    [-0.892, -1.191],
                    [-1.392, 0.794]
                  ],
                  "o": [
                    [-0.894, -1.092],
                    [-1.389, 0.794],
                    [0.894, 1.093],
                    [1.389, -0.894]
                  ],
                  "v": [
                    [2.283, -1.241],
                    [-1.59, -2.134],
                    [-2.185, 1.241],
                    [1.787, 2.135]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.191, 1.588],
                    [-2.084, 1.091],
                    [-1.293, -1.588],
                    [2.185, -1.192]
                  ],
                  "o": [
                    [-1.29, -1.589],
                    [2.085, -1.093],
                    [1.29, 1.589],
                    [-2.085, 1.191]
                  ],
                  "v": [
                    [-3.376, 1.738],
                    [-2.185, -2.928],
                    [3.376, -1.936],
                    [2.382, 2.83]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.816, 82.73],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.687, 2.482],
                    [-2.779, 1.291],
                    [-1.388, -0.496],
                    [0.298, -0.298],
                    [1.091, -0.397],
                    [-1.29, -1.887],
                    [-2.184, 0.992],
                    [-0.102, 0.893],
                    [-0.594, 0.099],
                    [1.786, -0.893]
                  ],
                  "o": [
                    [-1.687, -2.482],
                    [1.687, -0.695],
                    [-0.298, 0.398],
                    [-0.992, -0.397],
                    [-2.184, 0.893],
                    [1.293, 1.886],
                    [1.191, -0.497],
                    [0.594, 0],
                    [-0.098, 1.29],
                    [-2.879, 1.39]
                  ],
                  "v": [
                    [-4.567, 1.936],
                    [-2.184, -4.418],
                    [2.581, -4.518],
                    [1.886, -3.624],
                    [-1.588, -3.624],
                    [-3.277, 1.241],
                    [2.979, 2.83],
                    [4.866, 0.447],
                    [6.254, 0.348],
                    [3.674, 3.723]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [43.485, 85.809],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-20.449, -14.347],
                    [-22.237, -15.736],
                    [-21.243, -17.126],
                    [-19.457, -15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-16.776, -11.666],
                    [-18.564, -13.056],
                    [-17.57, -14.445],
                    [-15.784, -13.056]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-13.204, -8.985],
                    [-14.99, -10.375],
                    [-13.999, -11.765],
                    [-12.211, -10.375]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-9.631, -6.205],
                    [-11.416, -7.595],
                    [-10.425, -8.985],
                    [-8.636, -7.595]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-6.056, -3.524],
                    [-7.842, -4.915],
                    [-6.85, -6.304],
                    [-5.064, -4.915]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.482, -0.843],
                    [-4.27, -2.233],
                    [-3.276, -3.624],
                    [-1.49, -2.233]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [1.191, 1.937],
                    [-0.595, 0.546],
                    [0.397, -0.843],
                    [2.183, 0.546]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.765, 4.617],
                    [2.977, 3.227],
                    [3.971, 1.837],
                    [5.756, 3.227]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [8.339, 7.297],
                    [6.551, 5.908],
                    [7.545, 4.518],
                    [9.33, 5.908]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [11.91, 10.078],
                    [10.125, 8.688],
                    [11.116, 7.297],
                    [12.905, 8.688]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [15.485, 12.757],
                    [13.699, 11.369],
                    [14.691, 9.979],
                    [16.479, 11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [19.059, 15.439],
                    [17.274, 14.05],
                    [18.265, 12.659],
                    [20.051, 14.05]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [21.242, 17.126],
                    [20.845, 16.829],
                    [21.839, 15.439],
                    [22.237, 15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [93.616, 47.684],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.597, 0.298],
                    [-0.398, 0.1],
                    [-0.496, 0.199],
                    [-0.298, 0.198],
                    [-0.496, 0.198],
                    [-0.397, 0.198],
                    [-0.496, 0.297],
                    [-0.397, 0.199],
                    [-0.496, 0.298],
                    [0, 0],
                    [-0.497, 0.198],
                    [-0.299, 0.198],
                    [-0.397, 0.198],
                    [-0.299, 0.199],
                    [-0.397, 0.199],
                    [-0.398, 0.199],
                    [-0.397, 0.298],
                    [-0.398, 0.199],
                    [-0.398, 0.298],
                    [-0.298, 0.298],
                    [-0.396, 0.198],
                    [-0.298, 0.298],
                    [-0.396, 0.298],
                    [-0.397, 0.199],
                    [-0.396, 0.298],
                    [-0.298, 0.199],
                    [-0.396, 0.397],
                    [-0.2, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.198],
                    [-0.496, 0.397],
                    [-0.098, 0.099],
                    [-0.597, 0.595],
                    [0, 0],
                    [-6.155, 7.248],
                    [1.69, 1.29],
                    [0.597, 0.993],
                    [0.696, 0.496],
                    [0.597, 0.496],
                    [2.976, 2.085],
                    [3.079, 2.482],
                    [3.969, 3.376],
                    [7.542, -1.49],
                    [0.2, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.09, -0.894],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.093, -0.893],
                    [0.892, -1.191],
                    [0, 0],
                    [-1.191, -0.993],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.092, -0.894],
                    [0.794, -1.191],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.795, -1.092],
                    [0, 0],
                    [-0.994, -0.894],
                    [0.794, -1.192],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.697, -1.093],
                    [0, 0],
                    [-0.994, -0.893],
                    [0.694, -1.092],
                    [0, 0],
                    [-0.893, 0.397],
                    [-0.299, 0.099]
                  ],
                  "o": [
                    [0.397, -0.099],
                    [0.496, -0.199],
                    [0.397, -0.198],
                    [0.497, -0.198],
                    [0.396, -0.199],
                    [0.495, -0.199],
                    [0.397, -0.199],
                    [0.499, -0.199],
                    [0, 0],
                    [0.496, -0.198],
                    [0.397, -0.199],
                    [0.496, -0.199],
                    [0.398, -0.199],
                    [0.398, -0.198],
                    [0.398, -0.199],
                    [0.397, -0.298],
                    [0.397, -0.198],
                    [0.397, -0.298],
                    [0.296, -0.198],
                    [0.397, -0.298],
                    [0.299, -0.199],
                    [0.398, -0.298],
                    [0.299, -0.198],
                    [0.397, -0.297],
                    [0.296, -0.199],
                    [0.496, -0.298],
                    [0.299, -0.198],
                    [0.495, -0.298],
                    [0.199, -0.199],
                    [0.496, -0.397],
                    [0.197, -0.199],
                    [0.499, -0.397],
                    [0.098, -0.099],
                    [0.597, -0.496],
                    [0, 0],
                    [8.736, -7.347],
                    [-1.786, -1.39],
                    [-0.893, -0.695],
                    [-0.696, -0.397],
                    [-0.594, -0.397],
                    [-2.879, -2.284],
                    [-3.279, -2.283],
                    [-4.168, -3.375],
                    [-25.512, 32.267],
                    [-0.398, 0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.994, -1.093],
                    [1.093, 0.993],
                    [0, 0],
                    [0.992, -1.092],
                    [1.093, 0.994],
                    [0, 0],
                    [0.995, -1.092],
                    [1.093, 0.993],
                    [0, 0],
                    [0.993, -0.993],
                    [1.091, 0.893],
                    [0, 0],
                    [0.992, -0.992],
                    [1.093, 0.894],
                    [0, 0],
                    [0.991, -0.993],
                    [0.991, 0.893],
                    [0, 0],
                    [0.994, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.991, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.893, -0.298],
                    [0.299, -0.1],
                    [0.597, -0.099]
                  ],
                  "v": [
                    [-5.956, 39.068],
                    [-4.863, 38.671],
                    [-3.277, 38.075],
                    [-2.185, 37.579],
                    [-0.694, 36.984],
                    [0.497, 36.487],
                    [1.984, 35.792],
                    [3.175, 35.196],
                    [4.566, 34.501],
                    [5.758, 33.905],
                    [7.147, 33.211],
                    [8.239, 32.615],
                    [9.529, 31.92],
                    [10.622, 31.324],
                    [11.912, 30.629],
                    [13.005, 30.033],
                    [14.295, 29.239],
                    [15.388, 28.643],
                    [16.678, 27.849],
                    [17.669, 27.154],
                    [18.959, 26.36],
                    [19.953, 25.665],
                    [21.243, 24.771],
                    [22.235, 24.175],
                    [23.527, 23.282],
                    [24.42, 22.686],
                    [25.71, 21.693],
                    [26.505, 21.098],
                    [27.894, 20.105],
                    [28.589, 19.509],
                    [30.079, 18.417],
                    [30.673, 17.921],
                    [32.262, 16.63],
                    [32.659, 16.332],
                    [34.546, 14.744],
                    [34.645, 14.644],
                    [56.98, -7.695],
                    [51.817, -11.765],
                    [48.046, -14.446],
                    [45.961, -15.836],
                    [44.074, -17.226],
                    [35.639, -24.176],
                    [26.107, -31.225],
                    [13.799, -40.955],
                    [-55.49, 1.837],
                    [-56.386, 2.035],
                    [-56.484, 2.035],
                    [-56.682, 2.035],
                    [-56.78, 2.035],
                    [-56.882, 2.035],
                    [-56.98, 2.035],
                    [-54.896, 3.822],
                    [-54.896, 3.723],
                    [-51.125, 3.425],
                    [-50.826, 7.198],
                    [-49.435, 8.389],
                    [-45.664, 8.091],
                    [-45.365, 11.864],
                    [-43.977, 13.056],
                    [-40.205, 12.857],
                    [-39.906, 16.531],
                    [-38.516, 17.722],
                    [-34.843, 17.524],
                    [-34.445, 21.197],
                    [-33.057, 22.388],
                    [-29.384, 22.289],
                    [-28.987, 25.863],
                    [-27.497, 27.055],
                    [-23.923, 26.956],
                    [-23.525, 30.53],
                    [-22.038, 31.82],
                    [-18.464, 31.82],
                    [-17.969, 35.296],
                    [-16.478, 36.586],
                    [-13.003, 36.586],
                    [-12.508, 40.061],
                    [-11.516, 40.955],
                    [-8.736, 39.962],
                    [-7.843, 39.664]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [58.078, 72.108],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-4.169, -3.375],
                    [-3.275, -2.283],
                    [-2.879, -2.284],
                    [-0.696, -0.397],
                    [-0.695, -0.496],
                    [-0.893, -0.694],
                    [-1.687, -1.29],
                    [8.734, -7.347],
                    [0, 0],
                    [0, 0],
                    [0.101, -0.099],
                    [1.192, 0.795],
                    [-0.794, 1.191],
                    [-0.098, 0.099],
                    [0, 0],
                    [0.099, -0.199],
                    [1.189, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0.099],
                    [0, 0],
                    [0.101, -0.1],
                    [1.192, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0],
                    [0, 0],
                    [0.098, -0.099],
                    [1.192, 0.794],
                    [-0.794, 1.191],
                    [-0.099, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.191, 0.794],
                    [-0.792, 1.192],
                    [0, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.189, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0.101, 0],
                    [1.191, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.192, 0.795],
                    [-0.795, 1.191],
                    [0, 0],
                    [6.751, -8.538]
                  ],
                  "o": [
                    [3.075, 2.482],
                    [2.98, 2.085],
                    [0.596, 0.496],
                    [0.695, 0.497],
                    [0.497, 0.993],
                    [1.789, 1.291],
                    [-6.154, 7.248],
                    [28.292, -23.828],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.1],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.892, 1.191],
                    [-1.192, -0.893],
                    [0.099, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.794],
                    [0.098, -0.1],
                    [0, 0],
                    [0, 0.099],
                    [-0.892, 1.192],
                    [-1.192, -0.893],
                    [0, -0.099],
                    [0, 0],
                    [0, 0.099],
                    [-0.893, 1.192],
                    [-1.191, -0.894],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.192],
                    [-1.191, -0.795],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0, 0],
                    [-4.467, 12.014],
                    [4.369, 2.979]
                  ],
                  "v": [
                    [-19.555, -2.929],
                    [-10.027, 4.121],
                    [-1.588, 11.07],
                    [0.299, 12.46],
                    [2.382, 13.851],
                    [6.154, 16.531],
                    [11.317, 20.602],
                    [-11.018, 42.94],
                    [32.362, -9.084],
                    [31.072, -9.978],
                    [30.872, -9.581],
                    [27.101, -8.985],
                    [26.507, -12.757],
                    [26.802, -13.056],
                    [25.214, -14.147],
                    [25.016, -13.75],
                    [21.245, -13.155],
                    [20.648, -16.929],
                    [20.947, -17.226],
                    [19.358, -18.317],
                    [19.158, -18.02],
                    [15.386, -17.424],
                    [14.793, -21.197],
                    [14.99, -21.396],
                    [13.401, -22.487],
                    [13.204, -22.189],
                    [9.43, -21.594],
                    [8.836, -25.367],
                    [9.033, -25.565],
                    [7.444, -26.657],
                    [7.345, -26.459],
                    [3.574, -25.863],
                    [2.977, -29.636],
                    [3.079, -29.834],
                    [1.589, -30.926],
                    [1.49, -30.729],
                    [-2.282, -30.132],
                    [-2.878, -33.905],
                    [-2.78, -34.004],
                    [-4.267, -35.097],
                    [-4.368, -34.998],
                    [-8.14, -34.401],
                    [-8.734, -38.174],
                    [-8.635, -38.273],
                    [-10.125, -39.367],
                    [-10.125, -39.267],
                    [-13.897, -38.671],
                    [-14.493, -42.443],
                    [-15.187, -42.94],
                    [-32.362, -12.261]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [103.941, 43.812],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Layer 9 Outlines 6",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": -8,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 10,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 79,
              "s": [100]
            },
            {
              "t": 135,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": -8,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [1]
              },
              "o": {
                "x": [0.167],
                "y": [0]
              },
              "t": 91,
              "s": [456]
            },
            {
              "t": 135,
              "s": [373]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": -8,
              "s": [534.5, -9, 0],
              "to": [15.333, 100, 0],
              "ti": [-15.333, -100, 0]
            },
            {
              "t": 135,
              "s": [516.5, 1145, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [8.5, -7, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [100, 100, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.093, -0.099],
                    [0.098, 0.397],
                    [-0.598, 0.695],
                    [0.495, 0.398],
                    [1.887, 1.589],
                    [-0.991, 1.191],
                    [-0.695, 0.099],
                    [-0.101, -0.298],
                    [0.497, -0.596],
                    [-0.499, -0.397],
                    [-2.183, -1.489],
                    [1.093, -1.39]
                  ],
                  "o": [
                    [-0.099, -0.397],
                    [0.695, 0],
                    [0.692, -0.794],
                    [-1.29, -0.992],
                    [-0.793, -0.695],
                    [0.695, -0.894],
                    [0.099, 0.298],
                    [-0.598, 0],
                    [-0.596, 0.695],
                    [1.19, 0.893],
                    [0.895, 0.695],
                    [-0.893, 0.894]
                  ],
                  "v": [
                    [-0.05, 3.524],
                    [-0.248, 2.631],
                    [2.037, 1.439],
                    [2.135, -0.546],
                    [-3.028, 0.844],
                    [-2.93, -2.233],
                    [-0.646, -3.524],
                    [-0.347, -2.73],
                    [-2.234, -1.737],
                    [-2.332, 0.05],
                    [2.828, -1.34],
                    [2.828, 1.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.541, 57.811],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.299, -0.397],
                    [1.389, 1.191],
                    [0.696, -0.695],
                    [-0.2, -0.694],
                    [-1.489, -1.291],
                    [0.299, -0.298],
                    [1.885, 1.788],
                    [-0.295, 0.298],
                    [-0.298, -0.298],
                    [-0.693, 0.695],
                    [-1.092, -0.894],
                    [-1.49, -1.093]
                  ],
                  "o": [
                    [-1.389, -1.092],
                    [-0.892, -0.794],
                    [-0.594, 0.596],
                    [1.488, 1.291],
                    [-0.298, 0.298],
                    [-2.084, -1.688],
                    [0.296, -0.297],
                    [0.299, 0.298],
                    [-0.099, -0.695],
                    [0.994, -0.993],
                    [1.491, 1.191],
                    [-0.197, 0.297]
                  ],
                  "v": [
                    [3.87, 0.546],
                    [0.397, -2.234],
                    [-1.887, -2.135],
                    [-2.481, 0.049],
                    [1.29, 3.227],
                    [0.496, 4.021],
                    [-4.566, -0.348],
                    [-3.774, -1.142],
                    [-3.078, -0.447],
                    [-2.185, -2.929],
                    [0.893, -3.127],
                    [4.566, -0.248]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [78.825, 63.073],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.894],
                    [1.192, -0.992],
                    [-0.994, -0.993],
                    [-1.191, 0.993]
                  ],
                  "o": [
                    [-0.991, -0.894],
                    [-1.09, 0.993],
                    [0.991, 0.993],
                    [1.192, -1.091]
                  ],
                  "v": [
                    [1.686, -1.638],
                    [-1.988, -1.837],
                    [-1.885, 1.539],
                    [1.885, 1.737]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.489, 1.39],
                    [-1.588, 1.39],
                    [-1.487, -1.291],
                    [1.687, -1.489]
                  ],
                  "o": [
                    [-1.388, -1.389],
                    [1.589, -1.39],
                    [1.49, 1.29],
                    [-1.589, 1.489]
                  ],
                  "v": [
                    [-2.781, 2.333],
                    [-2.68, -2.432],
                    [2.48, -2.432],
                    [2.582, 2.333]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [73.267, 68.335],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.09, 1.092],
                    [1.192, -0.894],
                    [-0.099, -0.694],
                    [-0.896, -0.893],
                    [-0.696, 0.596]
                  ],
                  "o": [
                    [-1.093, -1.092],
                    [-0.695, 0.496],
                    [0.893, 0.894],
                    [0.693, 0.199],
                    [1.191, -0.992]
                  ],
                  "v": [
                    [2.135, -2.631],
                    [-1.538, -3.028],
                    [-2.532, -0.944],
                    [-0.346, 1.34],
                    [2.234, 0.744]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.199],
                    [-1.093, -0.993],
                    [0.397, -0.298],
                    [2.58, 2.779],
                    [-0.299, 0.298],
                    [-0.298, -0.298],
                    [-0.794, 0.596],
                    [-1.588, -1.589],
                    [1.589, -1.191]
                  ],
                  "o": [
                    [0.994, 0.992],
                    [-0.397, 0.298],
                    [-2.779, -2.681],
                    [0.397, -0.298],
                    [0.299, 0.298],
                    [0, -0.795],
                    [1.487, -1.191],
                    [1.589, 1.489],
                    [-0.794, 0.596]
                  ],
                  "v": [
                    [0.248, 1.837],
                    [2.929, 4.418],
                    [1.935, 5.113],
                    [-4.715, -1.737],
                    [-3.822, -2.433],
                    [-3.127, -1.638],
                    [-1.935, -3.922],
                    [3.126, -3.326],
                    [3.126, 1.241]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [66.664, 74.689],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, -0.298],
                    [0.296, 0.298],
                    [0.992, -0.694],
                    [0.994, 1.092],
                    [1.29, 1.589],
                    [-0.398, 0.199],
                    [-1.191, -1.39],
                    [-0.794, 0.497],
                    [0, 0.595],
                    [1.29, 1.489],
                    [-0.396, 0.198],
                    [-1.887, -1.985]
                  ],
                  "o": [
                    [-0.296, -0.298],
                    [-0.101, 0.794],
                    [-1.388, 0.894],
                    [-1.29, -1.49],
                    [0.397, -0.199],
                    [1.191, 1.39],
                    [0.794, 0.894],
                    [0.794, -0.497],
                    [-1.389, -1.49],
                    [0.396, -0.298],
                    [1.788, 2.085],
                    [-0.397, 0.1]
                  ],
                  "v": [
                    [3.97, 1.489],
                    [3.277, 0.794],
                    [1.787, 3.176],
                    [-1.787, 2.879],
                    [-4.964, -0.894],
                    [-3.969, -1.489],
                    [-0.993, 1.985],
                    [1.489, 2.284],
                    [2.68, 0.298],
                    [-0.694, -3.475],
                    [0.297, -4.07],
                    [4.964, 0.993]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.162, 78.313],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.893, 1.092],
                    [1.392, -0.695],
                    [-0.892, -1.191],
                    [-1.392, 0.794]
                  ],
                  "o": [
                    [-0.894, -1.092],
                    [-1.389, 0.794],
                    [0.894, 1.093],
                    [1.389, -0.894]
                  ],
                  "v": [
                    [2.283, -1.241],
                    [-1.59, -2.134],
                    [-2.185, 1.241],
                    [1.787, 2.135]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.191, 1.588],
                    [-2.084, 1.091],
                    [-1.293, -1.588],
                    [2.185, -1.192]
                  ],
                  "o": [
                    [-1.29, -1.589],
                    [2.085, -1.093],
                    [1.29, 1.589],
                    [-2.085, 1.191]
                  ],
                  "v": [
                    [-3.376, 1.738],
                    [-2.185, -2.928],
                    [3.376, -1.936],
                    [2.382, 2.83]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.816, 82.73],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.687, 2.482],
                    [-2.779, 1.291],
                    [-1.388, -0.496],
                    [0.298, -0.298],
                    [1.091, -0.397],
                    [-1.29, -1.887],
                    [-2.184, 0.992],
                    [-0.102, 0.893],
                    [-0.594, 0.099],
                    [1.786, -0.893]
                  ],
                  "o": [
                    [-1.687, -2.482],
                    [1.687, -0.695],
                    [-0.298, 0.398],
                    [-0.992, -0.397],
                    [-2.184, 0.893],
                    [1.293, 1.886],
                    [1.191, -0.497],
                    [0.594, 0],
                    [-0.098, 1.29],
                    [-2.879, 1.39]
                  ],
                  "v": [
                    [-4.567, 1.936],
                    [-2.184, -4.418],
                    [2.581, -4.518],
                    [1.886, -3.624],
                    [-1.588, -3.624],
                    [-3.277, 1.241],
                    [2.979, 2.83],
                    [4.866, 0.447],
                    [6.254, 0.348],
                    [3.674, 3.723]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [43.485, 85.809],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-20.449, -14.347],
                    [-22.237, -15.736],
                    [-21.243, -17.126],
                    [-19.457, -15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-16.776, -11.666],
                    [-18.564, -13.056],
                    [-17.57, -14.445],
                    [-15.784, -13.056]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-13.204, -8.985],
                    [-14.99, -10.375],
                    [-13.999, -11.765],
                    [-12.211, -10.375]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-9.631, -6.205],
                    [-11.416, -7.595],
                    [-10.425, -8.985],
                    [-8.636, -7.595]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-6.056, -3.524],
                    [-7.842, -4.915],
                    [-6.85, -6.304],
                    [-5.064, -4.915]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.482, -0.843],
                    [-4.27, -2.233],
                    [-3.276, -3.624],
                    [-1.49, -2.233]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [1.191, 1.937],
                    [-0.595, 0.546],
                    [0.397, -0.843],
                    [2.183, 0.546]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.765, 4.617],
                    [2.977, 3.227],
                    [3.971, 1.837],
                    [5.756, 3.227]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [8.339, 7.297],
                    [6.551, 5.908],
                    [7.545, 4.518],
                    [9.33, 5.908]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [11.91, 10.078],
                    [10.125, 8.688],
                    [11.116, 7.297],
                    [12.905, 8.688]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [15.485, 12.757],
                    [13.699, 11.369],
                    [14.691, 9.979],
                    [16.479, 11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [19.059, 15.439],
                    [17.274, 14.05],
                    [18.265, 12.659],
                    [20.051, 14.05]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [21.242, 17.126],
                    [20.845, 16.829],
                    [21.839, 15.439],
                    [22.237, 15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [93.616, 47.684],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.597, 0.298],
                    [-0.398, 0.1],
                    [-0.496, 0.199],
                    [-0.298, 0.198],
                    [-0.496, 0.198],
                    [-0.397, 0.198],
                    [-0.496, 0.297],
                    [-0.397, 0.199],
                    [-0.496, 0.298],
                    [0, 0],
                    [-0.497, 0.198],
                    [-0.299, 0.198],
                    [-0.397, 0.198],
                    [-0.299, 0.199],
                    [-0.397, 0.199],
                    [-0.398, 0.199],
                    [-0.397, 0.298],
                    [-0.398, 0.199],
                    [-0.398, 0.298],
                    [-0.298, 0.298],
                    [-0.396, 0.198],
                    [-0.298, 0.298],
                    [-0.396, 0.298],
                    [-0.397, 0.199],
                    [-0.396, 0.298],
                    [-0.298, 0.199],
                    [-0.396, 0.397],
                    [-0.2, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.198],
                    [-0.496, 0.397],
                    [-0.098, 0.099],
                    [-0.597, 0.595],
                    [0, 0],
                    [-6.155, 7.248],
                    [1.69, 1.29],
                    [0.597, 0.993],
                    [0.696, 0.496],
                    [0.597, 0.496],
                    [2.976, 2.085],
                    [3.079, 2.482],
                    [3.969, 3.376],
                    [7.542, -1.49],
                    [0.2, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.09, -0.894],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.093, -0.893],
                    [0.892, -1.191],
                    [0, 0],
                    [-1.191, -0.993],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.092, -0.894],
                    [0.794, -1.191],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.795, -1.092],
                    [0, 0],
                    [-0.994, -0.894],
                    [0.794, -1.192],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.697, -1.093],
                    [0, 0],
                    [-0.994, -0.893],
                    [0.694, -1.092],
                    [0, 0],
                    [-0.893, 0.397],
                    [-0.299, 0.099]
                  ],
                  "o": [
                    [0.397, -0.099],
                    [0.496, -0.199],
                    [0.397, -0.198],
                    [0.497, -0.198],
                    [0.396, -0.199],
                    [0.495, -0.199],
                    [0.397, -0.199],
                    [0.499, -0.199],
                    [0, 0],
                    [0.496, -0.198],
                    [0.397, -0.199],
                    [0.496, -0.199],
                    [0.398, -0.199],
                    [0.398, -0.198],
                    [0.398, -0.199],
                    [0.397, -0.298],
                    [0.397, -0.198],
                    [0.397, -0.298],
                    [0.296, -0.198],
                    [0.397, -0.298],
                    [0.299, -0.199],
                    [0.398, -0.298],
                    [0.299, -0.198],
                    [0.397, -0.297],
                    [0.296, -0.199],
                    [0.496, -0.298],
                    [0.299, -0.198],
                    [0.495, -0.298],
                    [0.199, -0.199],
                    [0.496, -0.397],
                    [0.197, -0.199],
                    [0.499, -0.397],
                    [0.098, -0.099],
                    [0.597, -0.496],
                    [0, 0],
                    [8.736, -7.347],
                    [-1.786, -1.39],
                    [-0.893, -0.695],
                    [-0.696, -0.397],
                    [-0.594, -0.397],
                    [-2.879, -2.284],
                    [-3.279, -2.283],
                    [-4.168, -3.375],
                    [-25.512, 32.267],
                    [-0.398, 0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.994, -1.093],
                    [1.093, 0.993],
                    [0, 0],
                    [0.992, -1.092],
                    [1.093, 0.994],
                    [0, 0],
                    [0.995, -1.092],
                    [1.093, 0.993],
                    [0, 0],
                    [0.993, -0.993],
                    [1.091, 0.893],
                    [0, 0],
                    [0.992, -0.992],
                    [1.093, 0.894],
                    [0, 0],
                    [0.991, -0.993],
                    [0.991, 0.893],
                    [0, 0],
                    [0.994, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.991, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.893, -0.298],
                    [0.299, -0.1],
                    [0.597, -0.099]
                  ],
                  "v": [
                    [-5.956, 39.068],
                    [-4.863, 38.671],
                    [-3.277, 38.075],
                    [-2.185, 37.579],
                    [-0.694, 36.984],
                    [0.497, 36.487],
                    [1.984, 35.792],
                    [3.175, 35.196],
                    [4.566, 34.501],
                    [5.758, 33.905],
                    [7.147, 33.211],
                    [8.239, 32.615],
                    [9.529, 31.92],
                    [10.622, 31.324],
                    [11.912, 30.629],
                    [13.005, 30.033],
                    [14.295, 29.239],
                    [15.388, 28.643],
                    [16.678, 27.849],
                    [17.669, 27.154],
                    [18.959, 26.36],
                    [19.953, 25.665],
                    [21.243, 24.771],
                    [22.235, 24.175],
                    [23.527, 23.282],
                    [24.42, 22.686],
                    [25.71, 21.693],
                    [26.505, 21.098],
                    [27.894, 20.105],
                    [28.589, 19.509],
                    [30.079, 18.417],
                    [30.673, 17.921],
                    [32.262, 16.63],
                    [32.659, 16.332],
                    [34.546, 14.744],
                    [34.645, 14.644],
                    [56.98, -7.695],
                    [51.817, -11.765],
                    [48.046, -14.446],
                    [45.961, -15.836],
                    [44.074, -17.226],
                    [35.639, -24.176],
                    [26.107, -31.225],
                    [13.799, -40.955],
                    [-55.49, 1.837],
                    [-56.386, 2.035],
                    [-56.484, 2.035],
                    [-56.682, 2.035],
                    [-56.78, 2.035],
                    [-56.882, 2.035],
                    [-56.98, 2.035],
                    [-54.896, 3.822],
                    [-54.896, 3.723],
                    [-51.125, 3.425],
                    [-50.826, 7.198],
                    [-49.435, 8.389],
                    [-45.664, 8.091],
                    [-45.365, 11.864],
                    [-43.977, 13.056],
                    [-40.205, 12.857],
                    [-39.906, 16.531],
                    [-38.516, 17.722],
                    [-34.843, 17.524],
                    [-34.445, 21.197],
                    [-33.057, 22.388],
                    [-29.384, 22.289],
                    [-28.987, 25.863],
                    [-27.497, 27.055],
                    [-23.923, 26.956],
                    [-23.525, 30.53],
                    [-22.038, 31.82],
                    [-18.464, 31.82],
                    [-17.969, 35.296],
                    [-16.478, 36.586],
                    [-13.003, 36.586],
                    [-12.508, 40.061],
                    [-11.516, 40.955],
                    [-8.736, 39.962],
                    [-7.843, 39.664]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [58.078, 72.108],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-4.169, -3.375],
                    [-3.275, -2.283],
                    [-2.879, -2.284],
                    [-0.696, -0.397],
                    [-0.695, -0.496],
                    [-0.893, -0.694],
                    [-1.687, -1.29],
                    [8.734, -7.347],
                    [0, 0],
                    [0, 0],
                    [0.101, -0.099],
                    [1.192, 0.795],
                    [-0.794, 1.191],
                    [-0.098, 0.099],
                    [0, 0],
                    [0.099, -0.199],
                    [1.189, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0.099],
                    [0, 0],
                    [0.101, -0.1],
                    [1.192, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0],
                    [0, 0],
                    [0.098, -0.099],
                    [1.192, 0.794],
                    [-0.794, 1.191],
                    [-0.099, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.191, 0.794],
                    [-0.792, 1.192],
                    [0, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.189, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0.101, 0],
                    [1.191, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.192, 0.795],
                    [-0.795, 1.191],
                    [0, 0],
                    [6.751, -8.538]
                  ],
                  "o": [
                    [3.075, 2.482],
                    [2.98, 2.085],
                    [0.596, 0.496],
                    [0.695, 0.497],
                    [0.497, 0.993],
                    [1.789, 1.291],
                    [-6.154, 7.248],
                    [28.292, -23.828],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.1],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.892, 1.191],
                    [-1.192, -0.893],
                    [0.099, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.794],
                    [0.098, -0.1],
                    [0, 0],
                    [0, 0.099],
                    [-0.892, 1.192],
                    [-1.192, -0.893],
                    [0, -0.099],
                    [0, 0],
                    [0, 0.099],
                    [-0.893, 1.192],
                    [-1.191, -0.894],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.192],
                    [-1.191, -0.795],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0, 0],
                    [-4.467, 12.014],
                    [4.369, 2.979]
                  ],
                  "v": [
                    [-19.555, -2.929],
                    [-10.027, 4.121],
                    [-1.588, 11.07],
                    [0.299, 12.46],
                    [2.382, 13.851],
                    [6.154, 16.531],
                    [11.317, 20.602],
                    [-11.018, 42.94],
                    [32.362, -9.084],
                    [31.072, -9.978],
                    [30.872, -9.581],
                    [27.101, -8.985],
                    [26.507, -12.757],
                    [26.802, -13.056],
                    [25.214, -14.147],
                    [25.016, -13.75],
                    [21.245, -13.155],
                    [20.648, -16.929],
                    [20.947, -17.226],
                    [19.358, -18.317],
                    [19.158, -18.02],
                    [15.386, -17.424],
                    [14.793, -21.197],
                    [14.99, -21.396],
                    [13.401, -22.487],
                    [13.204, -22.189],
                    [9.43, -21.594],
                    [8.836, -25.367],
                    [9.033, -25.565],
                    [7.444, -26.657],
                    [7.345, -26.459],
                    [3.574, -25.863],
                    [2.977, -29.636],
                    [3.079, -29.834],
                    [1.589, -30.926],
                    [1.49, -30.729],
                    [-2.282, -30.132],
                    [-2.878, -33.905],
                    [-2.78, -34.004],
                    [-4.267, -35.097],
                    [-4.368, -34.998],
                    [-8.14, -34.401],
                    [-8.734, -38.174],
                    [-8.635, -38.273],
                    [-10.125, -39.367],
                    [-10.125, -39.267],
                    [-13.897, -38.671],
                    [-14.493, -42.443],
                    [-15.187, -42.94],
                    [-32.362, -12.261]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [103.941, 43.812],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": -8,
      "op": 136,
      "st": -8,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "Layer 9 Outlines 4",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [1]
              },
              "o": {
                "x": [0.167],
                "y": [0]
              },
              "t": 99,
              "s": [264]
            },
            {
              "t": 143,
              "s": [373]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [1006.5, -1, 0],
              "to": [15.333, 100, 0],
              "ti": [-15.333, -100, 0]
            },
            {
              "t": 143,
              "s": [996.5, 1021, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [8.5, -7, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [60, 60, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.093, -0.099],
                    [0.098, 0.397],
                    [-0.598, 0.695],
                    [0.495, 0.398],
                    [1.887, 1.589],
                    [-0.991, 1.191],
                    [-0.695, 0.099],
                    [-0.101, -0.298],
                    [0.497, -0.596],
                    [-0.499, -0.397],
                    [-2.183, -1.489],
                    [1.093, -1.39]
                  ],
                  "o": [
                    [-0.099, -0.397],
                    [0.695, 0],
                    [0.692, -0.794],
                    [-1.29, -0.992],
                    [-0.793, -0.695],
                    [0.695, -0.894],
                    [0.099, 0.298],
                    [-0.598, 0],
                    [-0.596, 0.695],
                    [1.19, 0.893],
                    [0.895, 0.695],
                    [-0.893, 0.894]
                  ],
                  "v": [
                    [-0.05, 3.524],
                    [-0.248, 2.631],
                    [2.037, 1.439],
                    [2.135, -0.546],
                    [-3.028, 0.844],
                    [-2.93, -2.233],
                    [-0.646, -3.524],
                    [-0.347, -2.73],
                    [-2.234, -1.737],
                    [-2.332, 0.05],
                    [2.828, -1.34],
                    [2.828, 1.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.541, 57.811],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.299, -0.397],
                    [1.389, 1.191],
                    [0.696, -0.695],
                    [-0.2, -0.694],
                    [-1.489, -1.291],
                    [0.299, -0.298],
                    [1.885, 1.788],
                    [-0.295, 0.298],
                    [-0.298, -0.298],
                    [-0.693, 0.695],
                    [-1.092, -0.894],
                    [-1.49, -1.093]
                  ],
                  "o": [
                    [-1.389, -1.092],
                    [-0.892, -0.794],
                    [-0.594, 0.596],
                    [1.488, 1.291],
                    [-0.298, 0.298],
                    [-2.084, -1.688],
                    [0.296, -0.297],
                    [0.299, 0.298],
                    [-0.099, -0.695],
                    [0.994, -0.993],
                    [1.491, 1.191],
                    [-0.197, 0.297]
                  ],
                  "v": [
                    [3.87, 0.546],
                    [0.397, -2.234],
                    [-1.887, -2.135],
                    [-2.481, 0.049],
                    [1.29, 3.227],
                    [0.496, 4.021],
                    [-4.566, -0.348],
                    [-3.774, -1.142],
                    [-3.078, -0.447],
                    [-2.185, -2.929],
                    [0.893, -3.127],
                    [4.566, -0.248]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [78.825, 63.073],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.894],
                    [1.192, -0.992],
                    [-0.994, -0.993],
                    [-1.191, 0.993]
                  ],
                  "o": [
                    [-0.991, -0.894],
                    [-1.09, 0.993],
                    [0.991, 0.993],
                    [1.192, -1.091]
                  ],
                  "v": [
                    [1.686, -1.638],
                    [-1.988, -1.837],
                    [-1.885, 1.539],
                    [1.885, 1.737]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.489, 1.39],
                    [-1.588, 1.39],
                    [-1.487, -1.291],
                    [1.687, -1.489]
                  ],
                  "o": [
                    [-1.388, -1.389],
                    [1.589, -1.39],
                    [1.49, 1.29],
                    [-1.589, 1.489]
                  ],
                  "v": [
                    [-2.781, 2.333],
                    [-2.68, -2.432],
                    [2.48, -2.432],
                    [2.582, 2.333]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [73.267, 68.335],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.09, 1.092],
                    [1.192, -0.894],
                    [-0.099, -0.694],
                    [-0.896, -0.893],
                    [-0.696, 0.596]
                  ],
                  "o": [
                    [-1.093, -1.092],
                    [-0.695, 0.496],
                    [0.893, 0.894],
                    [0.693, 0.199],
                    [1.191, -0.992]
                  ],
                  "v": [
                    [2.135, -2.631],
                    [-1.538, -3.028],
                    [-2.532, -0.944],
                    [-0.346, 1.34],
                    [2.234, 0.744]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.199],
                    [-1.093, -0.993],
                    [0.397, -0.298],
                    [2.58, 2.779],
                    [-0.299, 0.298],
                    [-0.298, -0.298],
                    [-0.794, 0.596],
                    [-1.588, -1.589],
                    [1.589, -1.191]
                  ],
                  "o": [
                    [0.994, 0.992],
                    [-0.397, 0.298],
                    [-2.779, -2.681],
                    [0.397, -0.298],
                    [0.299, 0.298],
                    [0, -0.795],
                    [1.487, -1.191],
                    [1.589, 1.489],
                    [-0.794, 0.596]
                  ],
                  "v": [
                    [0.248, 1.837],
                    [2.929, 4.418],
                    [1.935, 5.113],
                    [-4.715, -1.737],
                    [-3.822, -2.433],
                    [-3.127, -1.638],
                    [-1.935, -3.922],
                    [3.126, -3.326],
                    [3.126, 1.241]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [66.664, 74.689],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, -0.298],
                    [0.296, 0.298],
                    [0.992, -0.694],
                    [0.994, 1.092],
                    [1.29, 1.589],
                    [-0.398, 0.199],
                    [-1.191, -1.39],
                    [-0.794, 0.497],
                    [0, 0.595],
                    [1.29, 1.489],
                    [-0.396, 0.198],
                    [-1.887, -1.985]
                  ],
                  "o": [
                    [-0.296, -0.298],
                    [-0.101, 0.794],
                    [-1.388, 0.894],
                    [-1.29, -1.49],
                    [0.397, -0.199],
                    [1.191, 1.39],
                    [0.794, 0.894],
                    [0.794, -0.497],
                    [-1.389, -1.49],
                    [0.396, -0.298],
                    [1.788, 2.085],
                    [-0.397, 0.1]
                  ],
                  "v": [
                    [3.97, 1.489],
                    [3.277, 0.794],
                    [1.787, 3.176],
                    [-1.787, 2.879],
                    [-4.964, -0.894],
                    [-3.969, -1.489],
                    [-0.993, 1.985],
                    [1.489, 2.284],
                    [2.68, 0.298],
                    [-0.694, -3.475],
                    [0.297, -4.07],
                    [4.964, 0.993]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.162, 78.313],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.893, 1.092],
                    [1.392, -0.695],
                    [-0.892, -1.191],
                    [-1.392, 0.794]
                  ],
                  "o": [
                    [-0.894, -1.092],
                    [-1.389, 0.794],
                    [0.894, 1.093],
                    [1.389, -0.894]
                  ],
                  "v": [
                    [2.283, -1.241],
                    [-1.59, -2.134],
                    [-2.185, 1.241],
                    [1.787, 2.135]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.191, 1.588],
                    [-2.084, 1.091],
                    [-1.293, -1.588],
                    [2.185, -1.192]
                  ],
                  "o": [
                    [-1.29, -1.589],
                    [2.085, -1.093],
                    [1.29, 1.589],
                    [-2.085, 1.191]
                  ],
                  "v": [
                    [-3.376, 1.738],
                    [-2.185, -2.928],
                    [3.376, -1.936],
                    [2.382, 2.83]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.816, 82.73],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.687, 2.482],
                    [-2.779, 1.291],
                    [-1.388, -0.496],
                    [0.298, -0.298],
                    [1.091, -0.397],
                    [-1.29, -1.887],
                    [-2.184, 0.992],
                    [-0.102, 0.893],
                    [-0.594, 0.099],
                    [1.786, -0.893]
                  ],
                  "o": [
                    [-1.687, -2.482],
                    [1.687, -0.695],
                    [-0.298, 0.398],
                    [-0.992, -0.397],
                    [-2.184, 0.893],
                    [1.293, 1.886],
                    [1.191, -0.497],
                    [0.594, 0],
                    [-0.098, 1.29],
                    [-2.879, 1.39]
                  ],
                  "v": [
                    [-4.567, 1.936],
                    [-2.184, -4.418],
                    [2.581, -4.518],
                    [1.886, -3.624],
                    [-1.588, -3.624],
                    [-3.277, 1.241],
                    [2.979, 2.83],
                    [4.866, 0.447],
                    [6.254, 0.348],
                    [3.674, 3.723]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [43.485, 85.809],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-20.449, -14.347],
                    [-22.237, -15.736],
                    [-21.243, -17.126],
                    [-19.457, -15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-16.776, -11.666],
                    [-18.564, -13.056],
                    [-17.57, -14.445],
                    [-15.784, -13.056]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-13.204, -8.985],
                    [-14.99, -10.375],
                    [-13.999, -11.765],
                    [-12.211, -10.375]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-9.631, -6.205],
                    [-11.416, -7.595],
                    [-10.425, -8.985],
                    [-8.636, -7.595]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-6.056, -3.524],
                    [-7.842, -4.915],
                    [-6.85, -6.304],
                    [-5.064, -4.915]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.482, -0.843],
                    [-4.27, -2.233],
                    [-3.276, -3.624],
                    [-1.49, -2.233]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [1.191, 1.937],
                    [-0.595, 0.546],
                    [0.397, -0.843],
                    [2.183, 0.546]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.765, 4.617],
                    [2.977, 3.227],
                    [3.971, 1.837],
                    [5.756, 3.227]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [8.339, 7.297],
                    [6.551, 5.908],
                    [7.545, 4.518],
                    [9.33, 5.908]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [11.91, 10.078],
                    [10.125, 8.688],
                    [11.116, 7.297],
                    [12.905, 8.688]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [15.485, 12.757],
                    [13.699, 11.369],
                    [14.691, 9.979],
                    [16.479, 11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [19.059, 15.439],
                    [17.274, 14.05],
                    [18.265, 12.659],
                    [20.051, 14.05]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [21.242, 17.126],
                    [20.845, 16.829],
                    [21.839, 15.439],
                    [22.237, 15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [93.616, 47.684],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.597, 0.298],
                    [-0.398, 0.1],
                    [-0.496, 0.199],
                    [-0.298, 0.198],
                    [-0.496, 0.198],
                    [-0.397, 0.198],
                    [-0.496, 0.297],
                    [-0.397, 0.199],
                    [-0.496, 0.298],
                    [0, 0],
                    [-0.497, 0.198],
                    [-0.299, 0.198],
                    [-0.397, 0.198],
                    [-0.299, 0.199],
                    [-0.397, 0.199],
                    [-0.398, 0.199],
                    [-0.397, 0.298],
                    [-0.398, 0.199],
                    [-0.398, 0.298],
                    [-0.298, 0.298],
                    [-0.396, 0.198],
                    [-0.298, 0.298],
                    [-0.396, 0.298],
                    [-0.397, 0.199],
                    [-0.396, 0.298],
                    [-0.298, 0.199],
                    [-0.396, 0.397],
                    [-0.2, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.198],
                    [-0.496, 0.397],
                    [-0.098, 0.099],
                    [-0.597, 0.595],
                    [0, 0],
                    [-6.155, 7.248],
                    [1.69, 1.29],
                    [0.597, 0.993],
                    [0.696, 0.496],
                    [0.597, 0.496],
                    [2.976, 2.085],
                    [3.079, 2.482],
                    [3.969, 3.376],
                    [7.542, -1.49],
                    [0.2, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.09, -0.894],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.093, -0.893],
                    [0.892, -1.191],
                    [0, 0],
                    [-1.191, -0.993],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.092, -0.894],
                    [0.794, -1.191],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.795, -1.092],
                    [0, 0],
                    [-0.994, -0.894],
                    [0.794, -1.192],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.697, -1.093],
                    [0, 0],
                    [-0.994, -0.893],
                    [0.694, -1.092],
                    [0, 0],
                    [-0.893, 0.397],
                    [-0.299, 0.099]
                  ],
                  "o": [
                    [0.397, -0.099],
                    [0.496, -0.199],
                    [0.397, -0.198],
                    [0.497, -0.198],
                    [0.396, -0.199],
                    [0.495, -0.199],
                    [0.397, -0.199],
                    [0.499, -0.199],
                    [0, 0],
                    [0.496, -0.198],
                    [0.397, -0.199],
                    [0.496, -0.199],
                    [0.398, -0.199],
                    [0.398, -0.198],
                    [0.398, -0.199],
                    [0.397, -0.298],
                    [0.397, -0.198],
                    [0.397, -0.298],
                    [0.296, -0.198],
                    [0.397, -0.298],
                    [0.299, -0.199],
                    [0.398, -0.298],
                    [0.299, -0.198],
                    [0.397, -0.297],
                    [0.296, -0.199],
                    [0.496, -0.298],
                    [0.299, -0.198],
                    [0.495, -0.298],
                    [0.199, -0.199],
                    [0.496, -0.397],
                    [0.197, -0.199],
                    [0.499, -0.397],
                    [0.098, -0.099],
                    [0.597, -0.496],
                    [0, 0],
                    [8.736, -7.347],
                    [-1.786, -1.39],
                    [-0.893, -0.695],
                    [-0.696, -0.397],
                    [-0.594, -0.397],
                    [-2.879, -2.284],
                    [-3.279, -2.283],
                    [-4.168, -3.375],
                    [-25.512, 32.267],
                    [-0.398, 0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.994, -1.093],
                    [1.093, 0.993],
                    [0, 0],
                    [0.992, -1.092],
                    [1.093, 0.994],
                    [0, 0],
                    [0.995, -1.092],
                    [1.093, 0.993],
                    [0, 0],
                    [0.993, -0.993],
                    [1.091, 0.893],
                    [0, 0],
                    [0.992, -0.992],
                    [1.093, 0.894],
                    [0, 0],
                    [0.991, -0.993],
                    [0.991, 0.893],
                    [0, 0],
                    [0.994, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.991, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.893, -0.298],
                    [0.299, -0.1],
                    [0.597, -0.099]
                  ],
                  "v": [
                    [-5.956, 39.068],
                    [-4.863, 38.671],
                    [-3.277, 38.075],
                    [-2.185, 37.579],
                    [-0.694, 36.984],
                    [0.497, 36.487],
                    [1.984, 35.792],
                    [3.175, 35.196],
                    [4.566, 34.501],
                    [5.758, 33.905],
                    [7.147, 33.211],
                    [8.239, 32.615],
                    [9.529, 31.92],
                    [10.622, 31.324],
                    [11.912, 30.629],
                    [13.005, 30.033],
                    [14.295, 29.239],
                    [15.388, 28.643],
                    [16.678, 27.849],
                    [17.669, 27.154],
                    [18.959, 26.36],
                    [19.953, 25.665],
                    [21.243, 24.771],
                    [22.235, 24.175],
                    [23.527, 23.282],
                    [24.42, 22.686],
                    [25.71, 21.693],
                    [26.505, 21.098],
                    [27.894, 20.105],
                    [28.589, 19.509],
                    [30.079, 18.417],
                    [30.673, 17.921],
                    [32.262, 16.63],
                    [32.659, 16.332],
                    [34.546, 14.744],
                    [34.645, 14.644],
                    [56.98, -7.695],
                    [51.817, -11.765],
                    [48.046, -14.446],
                    [45.961, -15.836],
                    [44.074, -17.226],
                    [35.639, -24.176],
                    [26.107, -31.225],
                    [13.799, -40.955],
                    [-55.49, 1.837],
                    [-56.386, 2.035],
                    [-56.484, 2.035],
                    [-56.682, 2.035],
                    [-56.78, 2.035],
                    [-56.882, 2.035],
                    [-56.98, 2.035],
                    [-54.896, 3.822],
                    [-54.896, 3.723],
                    [-51.125, 3.425],
                    [-50.826, 7.198],
                    [-49.435, 8.389],
                    [-45.664, 8.091],
                    [-45.365, 11.864],
                    [-43.977, 13.056],
                    [-40.205, 12.857],
                    [-39.906, 16.531],
                    [-38.516, 17.722],
                    [-34.843, 17.524],
                    [-34.445, 21.197],
                    [-33.057, 22.388],
                    [-29.384, 22.289],
                    [-28.987, 25.863],
                    [-27.497, 27.055],
                    [-23.923, 26.956],
                    [-23.525, 30.53],
                    [-22.038, 31.82],
                    [-18.464, 31.82],
                    [-17.969, 35.296],
                    [-16.478, 36.586],
                    [-13.003, 36.586],
                    [-12.508, 40.061],
                    [-11.516, 40.955],
                    [-8.736, 39.962],
                    [-7.843, 39.664]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [58.078, 72.108],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-4.169, -3.375],
                    [-3.275, -2.283],
                    [-2.879, -2.284],
                    [-0.696, -0.397],
                    [-0.695, -0.496],
                    [-0.893, -0.694],
                    [-1.687, -1.29],
                    [8.734, -7.347],
                    [0, 0],
                    [0, 0],
                    [0.101, -0.099],
                    [1.192, 0.795],
                    [-0.794, 1.191],
                    [-0.098, 0.099],
                    [0, 0],
                    [0.099, -0.199],
                    [1.189, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0.099],
                    [0, 0],
                    [0.101, -0.1],
                    [1.192, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0],
                    [0, 0],
                    [0.098, -0.099],
                    [1.192, 0.794],
                    [-0.794, 1.191],
                    [-0.099, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.191, 0.794],
                    [-0.792, 1.192],
                    [0, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.189, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0.101, 0],
                    [1.191, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.192, 0.795],
                    [-0.795, 1.191],
                    [0, 0],
                    [6.751, -8.538]
                  ],
                  "o": [
                    [3.075, 2.482],
                    [2.98, 2.085],
                    [0.596, 0.496],
                    [0.695, 0.497],
                    [0.497, 0.993],
                    [1.789, 1.291],
                    [-6.154, 7.248],
                    [28.292, -23.828],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.1],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.892, 1.191],
                    [-1.192, -0.893],
                    [0.099, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.794],
                    [0.098, -0.1],
                    [0, 0],
                    [0, 0.099],
                    [-0.892, 1.192],
                    [-1.192, -0.893],
                    [0, -0.099],
                    [0, 0],
                    [0, 0.099],
                    [-0.893, 1.192],
                    [-1.191, -0.894],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.192],
                    [-1.191, -0.795],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0, 0],
                    [-4.467, 12.014],
                    [4.369, 2.979]
                  ],
                  "v": [
                    [-19.555, -2.929],
                    [-10.027, 4.121],
                    [-1.588, 11.07],
                    [0.299, 12.46],
                    [2.382, 13.851],
                    [6.154, 16.531],
                    [11.317, 20.602],
                    [-11.018, 42.94],
                    [32.362, -9.084],
                    [31.072, -9.978],
                    [30.872, -9.581],
                    [27.101, -8.985],
                    [26.507, -12.757],
                    [26.802, -13.056],
                    [25.214, -14.147],
                    [25.016, -13.75],
                    [21.245, -13.155],
                    [20.648, -16.929],
                    [20.947, -17.226],
                    [19.358, -18.317],
                    [19.158, -18.02],
                    [15.386, -17.424],
                    [14.793, -21.197],
                    [14.99, -21.396],
                    [13.401, -22.487],
                    [13.204, -22.189],
                    [9.43, -21.594],
                    [8.836, -25.367],
                    [9.033, -25.565],
                    [7.444, -26.657],
                    [7.345, -26.459],
                    [3.574, -25.863],
                    [2.977, -29.636],
                    [3.079, -29.834],
                    [1.589, -30.926],
                    [1.49, -30.729],
                    [-2.282, -30.132],
                    [-2.878, -33.905],
                    [-2.78, -34.004],
                    [-4.267, -35.097],
                    [-4.368, -34.998],
                    [-8.14, -34.401],
                    [-8.734, -38.174],
                    [-8.635, -38.273],
                    [-10.125, -39.367],
                    [-10.125, -39.267],
                    [-13.897, -38.671],
                    [-14.493, -42.443],
                    [-15.187, -42.94],
                    [-32.362, -12.261]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [103.941, 43.812],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "Layer 9 Outlines 5",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [1]
              },
              "o": {
                "x": [0.167],
                "y": [0]
              },
              "t": 99,
              "s": [264]
            },
            {
              "t": 143,
              "s": [373]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [710.5, -65, 0],
              "to": [15.333, 100, 0],
              "ti": [-15.333, -100, 0]
            },
            {
              "t": 143,
              "s": [700.5, 981, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [8.5, -7, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [60, 60, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.093, -0.099],
                    [0.098, 0.397],
                    [-0.598, 0.695],
                    [0.495, 0.398],
                    [1.887, 1.589],
                    [-0.991, 1.191],
                    [-0.695, 0.099],
                    [-0.101, -0.298],
                    [0.497, -0.596],
                    [-0.499, -0.397],
                    [-2.183, -1.489],
                    [1.093, -1.39]
                  ],
                  "o": [
                    [-0.099, -0.397],
                    [0.695, 0],
                    [0.692, -0.794],
                    [-1.29, -0.992],
                    [-0.793, -0.695],
                    [0.695, -0.894],
                    [0.099, 0.298],
                    [-0.598, 0],
                    [-0.596, 0.695],
                    [1.19, 0.893],
                    [0.895, 0.695],
                    [-0.893, 0.894]
                  ],
                  "v": [
                    [-0.05, 3.524],
                    [-0.248, 2.631],
                    [2.037, 1.439],
                    [2.135, -0.546],
                    [-3.028, 0.844],
                    [-2.93, -2.233],
                    [-0.646, -3.524],
                    [-0.347, -2.73],
                    [-2.234, -1.737],
                    [-2.332, 0.05],
                    [2.828, -1.34],
                    [2.828, 1.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.541, 57.811],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.299, -0.397],
                    [1.389, 1.191],
                    [0.696, -0.695],
                    [-0.2, -0.694],
                    [-1.489, -1.291],
                    [0.299, -0.298],
                    [1.885, 1.788],
                    [-0.295, 0.298],
                    [-0.298, -0.298],
                    [-0.693, 0.695],
                    [-1.092, -0.894],
                    [-1.49, -1.093]
                  ],
                  "o": [
                    [-1.389, -1.092],
                    [-0.892, -0.794],
                    [-0.594, 0.596],
                    [1.488, 1.291],
                    [-0.298, 0.298],
                    [-2.084, -1.688],
                    [0.296, -0.297],
                    [0.299, 0.298],
                    [-0.099, -0.695],
                    [0.994, -0.993],
                    [1.491, 1.191],
                    [-0.197, 0.297]
                  ],
                  "v": [
                    [3.87, 0.546],
                    [0.397, -2.234],
                    [-1.887, -2.135],
                    [-2.481, 0.049],
                    [1.29, 3.227],
                    [0.496, 4.021],
                    [-4.566, -0.348],
                    [-3.774, -1.142],
                    [-3.078, -0.447],
                    [-2.185, -2.929],
                    [0.893, -3.127],
                    [4.566, -0.248]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [78.825, 63.073],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.894],
                    [1.192, -0.992],
                    [-0.994, -0.993],
                    [-1.191, 0.993]
                  ],
                  "o": [
                    [-0.991, -0.894],
                    [-1.09, 0.993],
                    [0.991, 0.993],
                    [1.192, -1.091]
                  ],
                  "v": [
                    [1.686, -1.638],
                    [-1.988, -1.837],
                    [-1.885, 1.539],
                    [1.885, 1.737]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.489, 1.39],
                    [-1.588, 1.39],
                    [-1.487, -1.291],
                    [1.687, -1.489]
                  ],
                  "o": [
                    [-1.388, -1.389],
                    [1.589, -1.39],
                    [1.49, 1.29],
                    [-1.589, 1.489]
                  ],
                  "v": [
                    [-2.781, 2.333],
                    [-2.68, -2.432],
                    [2.48, -2.432],
                    [2.582, 2.333]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [73.267, 68.335],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.09, 1.092],
                    [1.192, -0.894],
                    [-0.099, -0.694],
                    [-0.896, -0.893],
                    [-0.696, 0.596]
                  ],
                  "o": [
                    [-1.093, -1.092],
                    [-0.695, 0.496],
                    [0.893, 0.894],
                    [0.693, 0.199],
                    [1.191, -0.992]
                  ],
                  "v": [
                    [2.135, -2.631],
                    [-1.538, -3.028],
                    [-2.532, -0.944],
                    [-0.346, 1.34],
                    [2.234, 0.744]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.199],
                    [-1.093, -0.993],
                    [0.397, -0.298],
                    [2.58, 2.779],
                    [-0.299, 0.298],
                    [-0.298, -0.298],
                    [-0.794, 0.596],
                    [-1.588, -1.589],
                    [1.589, -1.191]
                  ],
                  "o": [
                    [0.994, 0.992],
                    [-0.397, 0.298],
                    [-2.779, -2.681],
                    [0.397, -0.298],
                    [0.299, 0.298],
                    [0, -0.795],
                    [1.487, -1.191],
                    [1.589, 1.489],
                    [-0.794, 0.596]
                  ],
                  "v": [
                    [0.248, 1.837],
                    [2.929, 4.418],
                    [1.935, 5.113],
                    [-4.715, -1.737],
                    [-3.822, -2.433],
                    [-3.127, -1.638],
                    [-1.935, -3.922],
                    [3.126, -3.326],
                    [3.126, 1.241]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [66.664, 74.689],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, -0.298],
                    [0.296, 0.298],
                    [0.992, -0.694],
                    [0.994, 1.092],
                    [1.29, 1.589],
                    [-0.398, 0.199],
                    [-1.191, -1.39],
                    [-0.794, 0.497],
                    [0, 0.595],
                    [1.29, 1.489],
                    [-0.396, 0.198],
                    [-1.887, -1.985]
                  ],
                  "o": [
                    [-0.296, -0.298],
                    [-0.101, 0.794],
                    [-1.388, 0.894],
                    [-1.29, -1.49],
                    [0.397, -0.199],
                    [1.191, 1.39],
                    [0.794, 0.894],
                    [0.794, -0.497],
                    [-1.389, -1.49],
                    [0.396, -0.298],
                    [1.788, 2.085],
                    [-0.397, 0.1]
                  ],
                  "v": [
                    [3.97, 1.489],
                    [3.277, 0.794],
                    [1.787, 3.176],
                    [-1.787, 2.879],
                    [-4.964, -0.894],
                    [-3.969, -1.489],
                    [-0.993, 1.985],
                    [1.489, 2.284],
                    [2.68, 0.298],
                    [-0.694, -3.475],
                    [0.297, -4.07],
                    [4.964, 0.993]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.162, 78.313],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.893, 1.092],
                    [1.392, -0.695],
                    [-0.892, -1.191],
                    [-1.392, 0.794]
                  ],
                  "o": [
                    [-0.894, -1.092],
                    [-1.389, 0.794],
                    [0.894, 1.093],
                    [1.389, -0.894]
                  ],
                  "v": [
                    [2.283, -1.241],
                    [-1.59, -2.134],
                    [-2.185, 1.241],
                    [1.787, 2.135]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.191, 1.588],
                    [-2.084, 1.091],
                    [-1.293, -1.588],
                    [2.185, -1.192]
                  ],
                  "o": [
                    [-1.29, -1.589],
                    [2.085, -1.093],
                    [1.29, 1.589],
                    [-2.085, 1.191]
                  ],
                  "v": [
                    [-3.376, 1.738],
                    [-2.185, -2.928],
                    [3.376, -1.936],
                    [2.382, 2.83]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.816, 82.73],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.687, 2.482],
                    [-2.779, 1.291],
                    [-1.388, -0.496],
                    [0.298, -0.298],
                    [1.091, -0.397],
                    [-1.29, -1.887],
                    [-2.184, 0.992],
                    [-0.102, 0.893],
                    [-0.594, 0.099],
                    [1.786, -0.893]
                  ],
                  "o": [
                    [-1.687, -2.482],
                    [1.687, -0.695],
                    [-0.298, 0.398],
                    [-0.992, -0.397],
                    [-2.184, 0.893],
                    [1.293, 1.886],
                    [1.191, -0.497],
                    [0.594, 0],
                    [-0.098, 1.29],
                    [-2.879, 1.39]
                  ],
                  "v": [
                    [-4.567, 1.936],
                    [-2.184, -4.418],
                    [2.581, -4.518],
                    [1.886, -3.624],
                    [-1.588, -3.624],
                    [-3.277, 1.241],
                    [2.979, 2.83],
                    [4.866, 0.447],
                    [6.254, 0.348],
                    [3.674, 3.723]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [43.485, 85.809],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-20.449, -14.347],
                    [-22.237, -15.736],
                    [-21.243, -17.126],
                    [-19.457, -15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-16.776, -11.666],
                    [-18.564, -13.056],
                    [-17.57, -14.445],
                    [-15.784, -13.056]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-13.204, -8.985],
                    [-14.99, -10.375],
                    [-13.999, -11.765],
                    [-12.211, -10.375]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-9.631, -6.205],
                    [-11.416, -7.595],
                    [-10.425, -8.985],
                    [-8.636, -7.595]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-6.056, -3.524],
                    [-7.842, -4.915],
                    [-6.85, -6.304],
                    [-5.064, -4.915]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.482, -0.843],
                    [-4.27, -2.233],
                    [-3.276, -3.624],
                    [-1.49, -2.233]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [1.191, 1.937],
                    [-0.595, 0.546],
                    [0.397, -0.843],
                    [2.183, 0.546]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.765, 4.617],
                    [2.977, 3.227],
                    [3.971, 1.837],
                    [5.756, 3.227]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [8.339, 7.297],
                    [6.551, 5.908],
                    [7.545, 4.518],
                    [9.33, 5.908]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [11.91, 10.078],
                    [10.125, 8.688],
                    [11.116, 7.297],
                    [12.905, 8.688]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [15.485, 12.757],
                    [13.699, 11.369],
                    [14.691, 9.979],
                    [16.479, 11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [19.059, 15.439],
                    [17.274, 14.05],
                    [18.265, 12.659],
                    [20.051, 14.05]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [21.242, 17.126],
                    [20.845, 16.829],
                    [21.839, 15.439],
                    [22.237, 15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [93.616, 47.684],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.597, 0.298],
                    [-0.398, 0.1],
                    [-0.496, 0.199],
                    [-0.298, 0.198],
                    [-0.496, 0.198],
                    [-0.397, 0.198],
                    [-0.496, 0.297],
                    [-0.397, 0.199],
                    [-0.496, 0.298],
                    [0, 0],
                    [-0.497, 0.198],
                    [-0.299, 0.198],
                    [-0.397, 0.198],
                    [-0.299, 0.199],
                    [-0.397, 0.199],
                    [-0.398, 0.199],
                    [-0.397, 0.298],
                    [-0.398, 0.199],
                    [-0.398, 0.298],
                    [-0.298, 0.298],
                    [-0.396, 0.198],
                    [-0.298, 0.298],
                    [-0.396, 0.298],
                    [-0.397, 0.199],
                    [-0.396, 0.298],
                    [-0.298, 0.199],
                    [-0.396, 0.397],
                    [-0.2, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.198],
                    [-0.496, 0.397],
                    [-0.098, 0.099],
                    [-0.597, 0.595],
                    [0, 0],
                    [-6.155, 7.248],
                    [1.69, 1.29],
                    [0.597, 0.993],
                    [0.696, 0.496],
                    [0.597, 0.496],
                    [2.976, 2.085],
                    [3.079, 2.482],
                    [3.969, 3.376],
                    [7.542, -1.49],
                    [0.2, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.09, -0.894],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.093, -0.893],
                    [0.892, -1.191],
                    [0, 0],
                    [-1.191, -0.993],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.092, -0.894],
                    [0.794, -1.191],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.795, -1.092],
                    [0, 0],
                    [-0.994, -0.894],
                    [0.794, -1.192],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.697, -1.093],
                    [0, 0],
                    [-0.994, -0.893],
                    [0.694, -1.092],
                    [0, 0],
                    [-0.893, 0.397],
                    [-0.299, 0.099]
                  ],
                  "o": [
                    [0.397, -0.099],
                    [0.496, -0.199],
                    [0.397, -0.198],
                    [0.497, -0.198],
                    [0.396, -0.199],
                    [0.495, -0.199],
                    [0.397, -0.199],
                    [0.499, -0.199],
                    [0, 0],
                    [0.496, -0.198],
                    [0.397, -0.199],
                    [0.496, -0.199],
                    [0.398, -0.199],
                    [0.398, -0.198],
                    [0.398, -0.199],
                    [0.397, -0.298],
                    [0.397, -0.198],
                    [0.397, -0.298],
                    [0.296, -0.198],
                    [0.397, -0.298],
                    [0.299, -0.199],
                    [0.398, -0.298],
                    [0.299, -0.198],
                    [0.397, -0.297],
                    [0.296, -0.199],
                    [0.496, -0.298],
                    [0.299, -0.198],
                    [0.495, -0.298],
                    [0.199, -0.199],
                    [0.496, -0.397],
                    [0.197, -0.199],
                    [0.499, -0.397],
                    [0.098, -0.099],
                    [0.597, -0.496],
                    [0, 0],
                    [8.736, -7.347],
                    [-1.786, -1.39],
                    [-0.893, -0.695],
                    [-0.696, -0.397],
                    [-0.594, -0.397],
                    [-2.879, -2.284],
                    [-3.279, -2.283],
                    [-4.168, -3.375],
                    [-25.512, 32.267],
                    [-0.398, 0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.994, -1.093],
                    [1.093, 0.993],
                    [0, 0],
                    [0.992, -1.092],
                    [1.093, 0.994],
                    [0, 0],
                    [0.995, -1.092],
                    [1.093, 0.993],
                    [0, 0],
                    [0.993, -0.993],
                    [1.091, 0.893],
                    [0, 0],
                    [0.992, -0.992],
                    [1.093, 0.894],
                    [0, 0],
                    [0.991, -0.993],
                    [0.991, 0.893],
                    [0, 0],
                    [0.994, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.991, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.893, -0.298],
                    [0.299, -0.1],
                    [0.597, -0.099]
                  ],
                  "v": [
                    [-5.956, 39.068],
                    [-4.863, 38.671],
                    [-3.277, 38.075],
                    [-2.185, 37.579],
                    [-0.694, 36.984],
                    [0.497, 36.487],
                    [1.984, 35.792],
                    [3.175, 35.196],
                    [4.566, 34.501],
                    [5.758, 33.905],
                    [7.147, 33.211],
                    [8.239, 32.615],
                    [9.529, 31.92],
                    [10.622, 31.324],
                    [11.912, 30.629],
                    [13.005, 30.033],
                    [14.295, 29.239],
                    [15.388, 28.643],
                    [16.678, 27.849],
                    [17.669, 27.154],
                    [18.959, 26.36],
                    [19.953, 25.665],
                    [21.243, 24.771],
                    [22.235, 24.175],
                    [23.527, 23.282],
                    [24.42, 22.686],
                    [25.71, 21.693],
                    [26.505, 21.098],
                    [27.894, 20.105],
                    [28.589, 19.509],
                    [30.079, 18.417],
                    [30.673, 17.921],
                    [32.262, 16.63],
                    [32.659, 16.332],
                    [34.546, 14.744],
                    [34.645, 14.644],
                    [56.98, -7.695],
                    [51.817, -11.765],
                    [48.046, -14.446],
                    [45.961, -15.836],
                    [44.074, -17.226],
                    [35.639, -24.176],
                    [26.107, -31.225],
                    [13.799, -40.955],
                    [-55.49, 1.837],
                    [-56.386, 2.035],
                    [-56.484, 2.035],
                    [-56.682, 2.035],
                    [-56.78, 2.035],
                    [-56.882, 2.035],
                    [-56.98, 2.035],
                    [-54.896, 3.822],
                    [-54.896, 3.723],
                    [-51.125, 3.425],
                    [-50.826, 7.198],
                    [-49.435, 8.389],
                    [-45.664, 8.091],
                    [-45.365, 11.864],
                    [-43.977, 13.056],
                    [-40.205, 12.857],
                    [-39.906, 16.531],
                    [-38.516, 17.722],
                    [-34.843, 17.524],
                    [-34.445, 21.197],
                    [-33.057, 22.388],
                    [-29.384, 22.289],
                    [-28.987, 25.863],
                    [-27.497, 27.055],
                    [-23.923, 26.956],
                    [-23.525, 30.53],
                    [-22.038, 31.82],
                    [-18.464, 31.82],
                    [-17.969, 35.296],
                    [-16.478, 36.586],
                    [-13.003, 36.586],
                    [-12.508, 40.061],
                    [-11.516, 40.955],
                    [-8.736, 39.962],
                    [-7.843, 39.664]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [58.078, 72.108],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-4.169, -3.375],
                    [-3.275, -2.283],
                    [-2.879, -2.284],
                    [-0.696, -0.397],
                    [-0.695, -0.496],
                    [-0.893, -0.694],
                    [-1.687, -1.29],
                    [8.734, -7.347],
                    [0, 0],
                    [0, 0],
                    [0.101, -0.099],
                    [1.192, 0.795],
                    [-0.794, 1.191],
                    [-0.098, 0.099],
                    [0, 0],
                    [0.099, -0.199],
                    [1.189, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0.099],
                    [0, 0],
                    [0.101, -0.1],
                    [1.192, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0],
                    [0, 0],
                    [0.098, -0.099],
                    [1.192, 0.794],
                    [-0.794, 1.191],
                    [-0.099, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.191, 0.794],
                    [-0.792, 1.192],
                    [0, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.189, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0.101, 0],
                    [1.191, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.192, 0.795],
                    [-0.795, 1.191],
                    [0, 0],
                    [6.751, -8.538]
                  ],
                  "o": [
                    [3.075, 2.482],
                    [2.98, 2.085],
                    [0.596, 0.496],
                    [0.695, 0.497],
                    [0.497, 0.993],
                    [1.789, 1.291],
                    [-6.154, 7.248],
                    [28.292, -23.828],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.1],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.892, 1.191],
                    [-1.192, -0.893],
                    [0.099, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.794],
                    [0.098, -0.1],
                    [0, 0],
                    [0, 0.099],
                    [-0.892, 1.192],
                    [-1.192, -0.893],
                    [0, -0.099],
                    [0, 0],
                    [0, 0.099],
                    [-0.893, 1.192],
                    [-1.191, -0.894],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.192],
                    [-1.191, -0.795],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0, 0],
                    [-4.467, 12.014],
                    [4.369, 2.979]
                  ],
                  "v": [
                    [-19.555, -2.929],
                    [-10.027, 4.121],
                    [-1.588, 11.07],
                    [0.299, 12.46],
                    [2.382, 13.851],
                    [6.154, 16.531],
                    [11.317, 20.602],
                    [-11.018, 42.94],
                    [32.362, -9.084],
                    [31.072, -9.978],
                    [30.872, -9.581],
                    [27.101, -8.985],
                    [26.507, -12.757],
                    [26.802, -13.056],
                    [25.214, -14.147],
                    [25.016, -13.75],
                    [21.245, -13.155],
                    [20.648, -16.929],
                    [20.947, -17.226],
                    [19.358, -18.317],
                    [19.158, -18.02],
                    [15.386, -17.424],
                    [14.793, -21.197],
                    [14.99, -21.396],
                    [13.401, -22.487],
                    [13.204, -22.189],
                    [9.43, -21.594],
                    [8.836, -25.367],
                    [9.033, -25.565],
                    [7.444, -26.657],
                    [7.345, -26.459],
                    [3.574, -25.863],
                    [2.977, -29.636],
                    [3.079, -29.834],
                    [1.589, -30.926],
                    [1.49, -30.729],
                    [-2.282, -30.132],
                    [-2.878, -33.905],
                    [-2.78, -34.004],
                    [-4.267, -35.097],
                    [-4.368, -34.998],
                    [-8.14, -34.401],
                    [-8.734, -38.174],
                    [-8.635, -38.273],
                    [-10.125, -39.367],
                    [-10.125, -39.267],
                    [-13.897, -38.671],
                    [-14.493, -42.443],
                    [-15.187, -42.94],
                    [-32.362, -12.261]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [103.941, 43.812],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 4,
      "nm": "Layer 9 Outlines 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [1]
              },
              "o": {
                "x": [0.167],
                "y": [0]
              },
              "t": 99,
              "s": [264]
            },
            {
              "t": 143,
              "s": [373]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [66.5, 45, 0],
              "to": [15.333, 100, 0],
              "ti": [-15.333, -100, 0]
            },
            {
              "t": 143,
              "s": [56.5, 1367, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [8.5, -7, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [60, 60, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.093, -0.099],
                    [0.098, 0.397],
                    [-0.598, 0.695],
                    [0.495, 0.398],
                    [1.887, 1.589],
                    [-0.991, 1.191],
                    [-0.695, 0.099],
                    [-0.101, -0.298],
                    [0.497, -0.596],
                    [-0.499, -0.397],
                    [-2.183, -1.489],
                    [1.093, -1.39]
                  ],
                  "o": [
                    [-0.099, -0.397],
                    [0.695, 0],
                    [0.692, -0.794],
                    [-1.29, -0.992],
                    [-0.793, -0.695],
                    [0.695, -0.894],
                    [0.099, 0.298],
                    [-0.598, 0],
                    [-0.596, 0.695],
                    [1.19, 0.893],
                    [0.895, 0.695],
                    [-0.893, 0.894]
                  ],
                  "v": [
                    [-0.05, 3.524],
                    [-0.248, 2.631],
                    [2.037, 1.439],
                    [2.135, -0.546],
                    [-3.028, 0.844],
                    [-2.93, -2.233],
                    [-0.646, -3.524],
                    [-0.347, -2.73],
                    [-2.234, -1.737],
                    [-2.332, 0.05],
                    [2.828, -1.34],
                    [2.828, 1.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.541, 57.811],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.299, -0.397],
                    [1.389, 1.191],
                    [0.696, -0.695],
                    [-0.2, -0.694],
                    [-1.489, -1.291],
                    [0.299, -0.298],
                    [1.885, 1.788],
                    [-0.295, 0.298],
                    [-0.298, -0.298],
                    [-0.693, 0.695],
                    [-1.092, -0.894],
                    [-1.49, -1.093]
                  ],
                  "o": [
                    [-1.389, -1.092],
                    [-0.892, -0.794],
                    [-0.594, 0.596],
                    [1.488, 1.291],
                    [-0.298, 0.298],
                    [-2.084, -1.688],
                    [0.296, -0.297],
                    [0.299, 0.298],
                    [-0.099, -0.695],
                    [0.994, -0.993],
                    [1.491, 1.191],
                    [-0.197, 0.297]
                  ],
                  "v": [
                    [3.87, 0.546],
                    [0.397, -2.234],
                    [-1.887, -2.135],
                    [-2.481, 0.049],
                    [1.29, 3.227],
                    [0.496, 4.021],
                    [-4.566, -0.348],
                    [-3.774, -1.142],
                    [-3.078, -0.447],
                    [-2.185, -2.929],
                    [0.893, -3.127],
                    [4.566, -0.248]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [78.825, 63.073],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.894],
                    [1.192, -0.992],
                    [-0.994, -0.993],
                    [-1.191, 0.993]
                  ],
                  "o": [
                    [-0.991, -0.894],
                    [-1.09, 0.993],
                    [0.991, 0.993],
                    [1.192, -1.091]
                  ],
                  "v": [
                    [1.686, -1.638],
                    [-1.988, -1.837],
                    [-1.885, 1.539],
                    [1.885, 1.737]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.489, 1.39],
                    [-1.588, 1.39],
                    [-1.487, -1.291],
                    [1.687, -1.489]
                  ],
                  "o": [
                    [-1.388, -1.389],
                    [1.589, -1.39],
                    [1.49, 1.29],
                    [-1.589, 1.489]
                  ],
                  "v": [
                    [-2.781, 2.333],
                    [-2.68, -2.432],
                    [2.48, -2.432],
                    [2.582, 2.333]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [73.267, 68.335],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.09, 1.092],
                    [1.192, -0.894],
                    [-0.099, -0.694],
                    [-0.896, -0.893],
                    [-0.696, 0.596]
                  ],
                  "o": [
                    [-1.093, -1.092],
                    [-0.695, 0.496],
                    [0.893, 0.894],
                    [0.693, 0.199],
                    [1.191, -0.992]
                  ],
                  "v": [
                    [2.135, -2.631],
                    [-1.538, -3.028],
                    [-2.532, -0.944],
                    [-0.346, 1.34],
                    [2.234, 0.744]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.199],
                    [-1.093, -0.993],
                    [0.397, -0.298],
                    [2.58, 2.779],
                    [-0.299, 0.298],
                    [-0.298, -0.298],
                    [-0.794, 0.596],
                    [-1.588, -1.589],
                    [1.589, -1.191]
                  ],
                  "o": [
                    [0.994, 0.992],
                    [-0.397, 0.298],
                    [-2.779, -2.681],
                    [0.397, -0.298],
                    [0.299, 0.298],
                    [0, -0.795],
                    [1.487, -1.191],
                    [1.589, 1.489],
                    [-0.794, 0.596]
                  ],
                  "v": [
                    [0.248, 1.837],
                    [2.929, 4.418],
                    [1.935, 5.113],
                    [-4.715, -1.737],
                    [-3.822, -2.433],
                    [-3.127, -1.638],
                    [-1.935, -3.922],
                    [3.126, -3.326],
                    [3.126, 1.241]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [66.664, 74.689],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, -0.298],
                    [0.296, 0.298],
                    [0.992, -0.694],
                    [0.994, 1.092],
                    [1.29, 1.589],
                    [-0.398, 0.199],
                    [-1.191, -1.39],
                    [-0.794, 0.497],
                    [0, 0.595],
                    [1.29, 1.489],
                    [-0.396, 0.198],
                    [-1.887, -1.985]
                  ],
                  "o": [
                    [-0.296, -0.298],
                    [-0.101, 0.794],
                    [-1.388, 0.894],
                    [-1.29, -1.49],
                    [0.397, -0.199],
                    [1.191, 1.39],
                    [0.794, 0.894],
                    [0.794, -0.497],
                    [-1.389, -1.49],
                    [0.396, -0.298],
                    [1.788, 2.085],
                    [-0.397, 0.1]
                  ],
                  "v": [
                    [3.97, 1.489],
                    [3.277, 0.794],
                    [1.787, 3.176],
                    [-1.787, 2.879],
                    [-4.964, -0.894],
                    [-3.969, -1.489],
                    [-0.993, 1.985],
                    [1.489, 2.284],
                    [2.68, 0.298],
                    [-0.694, -3.475],
                    [0.297, -4.07],
                    [4.964, 0.993]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.162, 78.313],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.893, 1.092],
                    [1.392, -0.695],
                    [-0.892, -1.191],
                    [-1.392, 0.794]
                  ],
                  "o": [
                    [-0.894, -1.092],
                    [-1.389, 0.794],
                    [0.894, 1.093],
                    [1.389, -0.894]
                  ],
                  "v": [
                    [2.283, -1.241],
                    [-1.59, -2.134],
                    [-2.185, 1.241],
                    [1.787, 2.135]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.191, 1.588],
                    [-2.084, 1.091],
                    [-1.293, -1.588],
                    [2.185, -1.192]
                  ],
                  "o": [
                    [-1.29, -1.589],
                    [2.085, -1.093],
                    [1.29, 1.589],
                    [-2.085, 1.191]
                  ],
                  "v": [
                    [-3.376, 1.738],
                    [-2.185, -2.928],
                    [3.376, -1.936],
                    [2.382, 2.83]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.816, 82.73],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.687, 2.482],
                    [-2.779, 1.291],
                    [-1.388, -0.496],
                    [0.298, -0.298],
                    [1.091, -0.397],
                    [-1.29, -1.887],
                    [-2.184, 0.992],
                    [-0.102, 0.893],
                    [-0.594, 0.099],
                    [1.786, -0.893]
                  ],
                  "o": [
                    [-1.687, -2.482],
                    [1.687, -0.695],
                    [-0.298, 0.398],
                    [-0.992, -0.397],
                    [-2.184, 0.893],
                    [1.293, 1.886],
                    [1.191, -0.497],
                    [0.594, 0],
                    [-0.098, 1.29],
                    [-2.879, 1.39]
                  ],
                  "v": [
                    [-4.567, 1.936],
                    [-2.184, -4.418],
                    [2.581, -4.518],
                    [1.886, -3.624],
                    [-1.588, -3.624],
                    [-3.277, 1.241],
                    [2.979, 2.83],
                    [4.866, 0.447],
                    [6.254, 0.348],
                    [3.674, 3.723]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [43.485, 85.809],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-20.449, -14.347],
                    [-22.237, -15.736],
                    [-21.243, -17.126],
                    [-19.457, -15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-16.776, -11.666],
                    [-18.564, -13.056],
                    [-17.57, -14.445],
                    [-15.784, -13.056]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-13.204, -8.985],
                    [-14.99, -10.375],
                    [-13.999, -11.765],
                    [-12.211, -10.375]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-9.631, -6.205],
                    [-11.416, -7.595],
                    [-10.425, -8.985],
                    [-8.636, -7.595]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-6.056, -3.524],
                    [-7.842, -4.915],
                    [-6.85, -6.304],
                    [-5.064, -4.915]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.482, -0.843],
                    [-4.27, -2.233],
                    [-3.276, -3.624],
                    [-1.49, -2.233]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [1.191, 1.937],
                    [-0.595, 0.546],
                    [0.397, -0.843],
                    [2.183, 0.546]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.765, 4.617],
                    [2.977, 3.227],
                    [3.971, 1.837],
                    [5.756, 3.227]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [8.339, 7.297],
                    [6.551, 5.908],
                    [7.545, 4.518],
                    [9.33, 5.908]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [11.91, 10.078],
                    [10.125, 8.688],
                    [11.116, 7.297],
                    [12.905, 8.688]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [15.485, 12.757],
                    [13.699, 11.369],
                    [14.691, 9.979],
                    [16.479, 11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [19.059, 15.439],
                    [17.274, 14.05],
                    [18.265, 12.659],
                    [20.051, 14.05]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [21.242, 17.126],
                    [20.845, 16.829],
                    [21.839, 15.439],
                    [22.237, 15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [93.616, 47.684],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.597, 0.298],
                    [-0.398, 0.1],
                    [-0.496, 0.199],
                    [-0.298, 0.198],
                    [-0.496, 0.198],
                    [-0.397, 0.198],
                    [-0.496, 0.297],
                    [-0.397, 0.199],
                    [-0.496, 0.298],
                    [0, 0],
                    [-0.497, 0.198],
                    [-0.299, 0.198],
                    [-0.397, 0.198],
                    [-0.299, 0.199],
                    [-0.397, 0.199],
                    [-0.398, 0.199],
                    [-0.397, 0.298],
                    [-0.398, 0.199],
                    [-0.398, 0.298],
                    [-0.298, 0.298],
                    [-0.396, 0.198],
                    [-0.298, 0.298],
                    [-0.396, 0.298],
                    [-0.397, 0.199],
                    [-0.396, 0.298],
                    [-0.298, 0.199],
                    [-0.396, 0.397],
                    [-0.2, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.198],
                    [-0.496, 0.397],
                    [-0.098, 0.099],
                    [-0.597, 0.595],
                    [0, 0],
                    [-6.155, 7.248],
                    [1.69, 1.29],
                    [0.597, 0.993],
                    [0.696, 0.496],
                    [0.597, 0.496],
                    [2.976, 2.085],
                    [3.079, 2.482],
                    [3.969, 3.376],
                    [7.542, -1.49],
                    [0.2, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.09, -0.894],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.093, -0.893],
                    [0.892, -1.191],
                    [0, 0],
                    [-1.191, -0.993],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.092, -0.894],
                    [0.794, -1.191],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.795, -1.092],
                    [0, 0],
                    [-0.994, -0.894],
                    [0.794, -1.192],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.697, -1.093],
                    [0, 0],
                    [-0.994, -0.893],
                    [0.694, -1.092],
                    [0, 0],
                    [-0.893, 0.397],
                    [-0.299, 0.099]
                  ],
                  "o": [
                    [0.397, -0.099],
                    [0.496, -0.199],
                    [0.397, -0.198],
                    [0.497, -0.198],
                    [0.396, -0.199],
                    [0.495, -0.199],
                    [0.397, -0.199],
                    [0.499, -0.199],
                    [0, 0],
                    [0.496, -0.198],
                    [0.397, -0.199],
                    [0.496, -0.199],
                    [0.398, -0.199],
                    [0.398, -0.198],
                    [0.398, -0.199],
                    [0.397, -0.298],
                    [0.397, -0.198],
                    [0.397, -0.298],
                    [0.296, -0.198],
                    [0.397, -0.298],
                    [0.299, -0.199],
                    [0.398, -0.298],
                    [0.299, -0.198],
                    [0.397, -0.297],
                    [0.296, -0.199],
                    [0.496, -0.298],
                    [0.299, -0.198],
                    [0.495, -0.298],
                    [0.199, -0.199],
                    [0.496, -0.397],
                    [0.197, -0.199],
                    [0.499, -0.397],
                    [0.098, -0.099],
                    [0.597, -0.496],
                    [0, 0],
                    [8.736, -7.347],
                    [-1.786, -1.39],
                    [-0.893, -0.695],
                    [-0.696, -0.397],
                    [-0.594, -0.397],
                    [-2.879, -2.284],
                    [-3.279, -2.283],
                    [-4.168, -3.375],
                    [-25.512, 32.267],
                    [-0.398, 0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.994, -1.093],
                    [1.093, 0.993],
                    [0, 0],
                    [0.992, -1.092],
                    [1.093, 0.994],
                    [0, 0],
                    [0.995, -1.092],
                    [1.093, 0.993],
                    [0, 0],
                    [0.993, -0.993],
                    [1.091, 0.893],
                    [0, 0],
                    [0.992, -0.992],
                    [1.093, 0.894],
                    [0, 0],
                    [0.991, -0.993],
                    [0.991, 0.893],
                    [0, 0],
                    [0.994, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.991, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.893, -0.298],
                    [0.299, -0.1],
                    [0.597, -0.099]
                  ],
                  "v": [
                    [-5.956, 39.068],
                    [-4.863, 38.671],
                    [-3.277, 38.075],
                    [-2.185, 37.579],
                    [-0.694, 36.984],
                    [0.497, 36.487],
                    [1.984, 35.792],
                    [3.175, 35.196],
                    [4.566, 34.501],
                    [5.758, 33.905],
                    [7.147, 33.211],
                    [8.239, 32.615],
                    [9.529, 31.92],
                    [10.622, 31.324],
                    [11.912, 30.629],
                    [13.005, 30.033],
                    [14.295, 29.239],
                    [15.388, 28.643],
                    [16.678, 27.849],
                    [17.669, 27.154],
                    [18.959, 26.36],
                    [19.953, 25.665],
                    [21.243, 24.771],
                    [22.235, 24.175],
                    [23.527, 23.282],
                    [24.42, 22.686],
                    [25.71, 21.693],
                    [26.505, 21.098],
                    [27.894, 20.105],
                    [28.589, 19.509],
                    [30.079, 18.417],
                    [30.673, 17.921],
                    [32.262, 16.63],
                    [32.659, 16.332],
                    [34.546, 14.744],
                    [34.645, 14.644],
                    [56.98, -7.695],
                    [51.817, -11.765],
                    [48.046, -14.446],
                    [45.961, -15.836],
                    [44.074, -17.226],
                    [35.639, -24.176],
                    [26.107, -31.225],
                    [13.799, -40.955],
                    [-55.49, 1.837],
                    [-56.386, 2.035],
                    [-56.484, 2.035],
                    [-56.682, 2.035],
                    [-56.78, 2.035],
                    [-56.882, 2.035],
                    [-56.98, 2.035],
                    [-54.896, 3.822],
                    [-54.896, 3.723],
                    [-51.125, 3.425],
                    [-50.826, 7.198],
                    [-49.435, 8.389],
                    [-45.664, 8.091],
                    [-45.365, 11.864],
                    [-43.977, 13.056],
                    [-40.205, 12.857],
                    [-39.906, 16.531],
                    [-38.516, 17.722],
                    [-34.843, 17.524],
                    [-34.445, 21.197],
                    [-33.057, 22.388],
                    [-29.384, 22.289],
                    [-28.987, 25.863],
                    [-27.497, 27.055],
                    [-23.923, 26.956],
                    [-23.525, 30.53],
                    [-22.038, 31.82],
                    [-18.464, 31.82],
                    [-17.969, 35.296],
                    [-16.478, 36.586],
                    [-13.003, 36.586],
                    [-12.508, 40.061],
                    [-11.516, 40.955],
                    [-8.736, 39.962],
                    [-7.843, 39.664]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [58.078, 72.108],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-4.169, -3.375],
                    [-3.275, -2.283],
                    [-2.879, -2.284],
                    [-0.696, -0.397],
                    [-0.695, -0.496],
                    [-0.893, -0.694],
                    [-1.687, -1.29],
                    [8.734, -7.347],
                    [0, 0],
                    [0, 0],
                    [0.101, -0.099],
                    [1.192, 0.795],
                    [-0.794, 1.191],
                    [-0.098, 0.099],
                    [0, 0],
                    [0.099, -0.199],
                    [1.189, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0.099],
                    [0, 0],
                    [0.101, -0.1],
                    [1.192, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0],
                    [0, 0],
                    [0.098, -0.099],
                    [1.192, 0.794],
                    [-0.794, 1.191],
                    [-0.099, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.191, 0.794],
                    [-0.792, 1.192],
                    [0, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.189, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0.101, 0],
                    [1.191, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.192, 0.795],
                    [-0.795, 1.191],
                    [0, 0],
                    [6.751, -8.538]
                  ],
                  "o": [
                    [3.075, 2.482],
                    [2.98, 2.085],
                    [0.596, 0.496],
                    [0.695, 0.497],
                    [0.497, 0.993],
                    [1.789, 1.291],
                    [-6.154, 7.248],
                    [28.292, -23.828],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.1],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.892, 1.191],
                    [-1.192, -0.893],
                    [0.099, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.794],
                    [0.098, -0.1],
                    [0, 0],
                    [0, 0.099],
                    [-0.892, 1.192],
                    [-1.192, -0.893],
                    [0, -0.099],
                    [0, 0],
                    [0, 0.099],
                    [-0.893, 1.192],
                    [-1.191, -0.894],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.192],
                    [-1.191, -0.795],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0, 0],
                    [-4.467, 12.014],
                    [4.369, 2.979]
                  ],
                  "v": [
                    [-19.555, -2.929],
                    [-10.027, 4.121],
                    [-1.588, 11.07],
                    [0.299, 12.46],
                    [2.382, 13.851],
                    [6.154, 16.531],
                    [11.317, 20.602],
                    [-11.018, 42.94],
                    [32.362, -9.084],
                    [31.072, -9.978],
                    [30.872, -9.581],
                    [27.101, -8.985],
                    [26.507, -12.757],
                    [26.802, -13.056],
                    [25.214, -14.147],
                    [25.016, -13.75],
                    [21.245, -13.155],
                    [20.648, -16.929],
                    [20.947, -17.226],
                    [19.358, -18.317],
                    [19.158, -18.02],
                    [15.386, -17.424],
                    [14.793, -21.197],
                    [14.99, -21.396],
                    [13.401, -22.487],
                    [13.204, -22.189],
                    [9.43, -21.594],
                    [8.836, -25.367],
                    [9.033, -25.565],
                    [7.444, -26.657],
                    [7.345, -26.459],
                    [3.574, -25.863],
                    [2.977, -29.636],
                    [3.079, -29.834],
                    [1.589, -30.926],
                    [1.49, -30.729],
                    [-2.282, -30.132],
                    [-2.878, -33.905],
                    [-2.78, -34.004],
                    [-4.267, -35.097],
                    [-4.368, -34.998],
                    [-8.14, -34.401],
                    [-8.734, -38.174],
                    [-8.635, -38.273],
                    [-10.125, -39.367],
                    [-10.125, -39.267],
                    [-13.897, -38.671],
                    [-14.493, -42.443],
                    [-15.187, -42.94],
                    [-32.362, -12.261]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [103.941, 43.812],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 9,
      "ty": 4,
      "nm": "Layer 9 Outlines",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 35,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [1]
              },
              "o": {
                "x": [0.167],
                "y": [0]
              },
              "t": 78,
              "s": [456]
            },
            {
              "t": 123,
              "s": [373]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.667,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [286.5, 73, 0],
              "to": [15.333, 100, 0],
              "ti": [-15.333, -100, 0]
            },
            {
              "t": 123,
              "s": [352.5, 1707, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [8.5, -7, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [160, 160, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.093, -0.099],
                    [0.098, 0.397],
                    [-0.598, 0.695],
                    [0.495, 0.398],
                    [1.887, 1.589],
                    [-0.991, 1.191],
                    [-0.695, 0.099],
                    [-0.101, -0.298],
                    [0.497, -0.596],
                    [-0.499, -0.397],
                    [-2.183, -1.489],
                    [1.093, -1.39]
                  ],
                  "o": [
                    [-0.099, -0.397],
                    [0.695, 0],
                    [0.692, -0.794],
                    [-1.29, -0.992],
                    [-0.793, -0.695],
                    [0.695, -0.894],
                    [0.099, 0.298],
                    [-0.598, 0],
                    [-0.596, 0.695],
                    [1.19, 0.893],
                    [0.895, 0.695],
                    [-0.893, 0.894]
                  ],
                  "v": [
                    [-0.05, 3.524],
                    [-0.248, 2.631],
                    [2.037, 1.439],
                    [2.135, -0.546],
                    [-3.028, 0.844],
                    [-2.93, -2.233],
                    [-0.646, -3.524],
                    [-0.347, -2.73],
                    [-2.234, -1.737],
                    [-2.332, 0.05],
                    [2.828, -1.34],
                    [2.828, 1.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.541, 57.811],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.299, -0.397],
                    [1.389, 1.191],
                    [0.696, -0.695],
                    [-0.2, -0.694],
                    [-1.489, -1.291],
                    [0.299, -0.298],
                    [1.885, 1.788],
                    [-0.295, 0.298],
                    [-0.298, -0.298],
                    [-0.693, 0.695],
                    [-1.092, -0.894],
                    [-1.49, -1.093]
                  ],
                  "o": [
                    [-1.389, -1.092],
                    [-0.892, -0.794],
                    [-0.594, 0.596],
                    [1.488, 1.291],
                    [-0.298, 0.298],
                    [-2.084, -1.688],
                    [0.296, -0.297],
                    [0.299, 0.298],
                    [-0.099, -0.695],
                    [0.994, -0.993],
                    [1.491, 1.191],
                    [-0.197, 0.297]
                  ],
                  "v": [
                    [3.87, 0.546],
                    [0.397, -2.234],
                    [-1.887, -2.135],
                    [-2.481, 0.049],
                    [1.29, 3.227],
                    [0.496, 4.021],
                    [-4.566, -0.348],
                    [-3.774, -1.142],
                    [-3.078, -0.447],
                    [-2.185, -2.929],
                    [0.893, -3.127],
                    [4.566, -0.248]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [78.825, 63.073],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.894],
                    [1.192, -0.992],
                    [-0.994, -0.993],
                    [-1.191, 0.993]
                  ],
                  "o": [
                    [-0.991, -0.894],
                    [-1.09, 0.993],
                    [0.991, 0.993],
                    [1.192, -1.091]
                  ],
                  "v": [
                    [1.686, -1.638],
                    [-1.988, -1.837],
                    [-1.885, 1.539],
                    [1.885, 1.737]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.489, 1.39],
                    [-1.588, 1.39],
                    [-1.487, -1.291],
                    [1.687, -1.489]
                  ],
                  "o": [
                    [-1.388, -1.389],
                    [1.589, -1.39],
                    [1.49, 1.29],
                    [-1.589, 1.489]
                  ],
                  "v": [
                    [-2.781, 2.333],
                    [-2.68, -2.432],
                    [2.48, -2.432],
                    [2.582, 2.333]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [73.267, 68.335],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.09, 1.092],
                    [1.192, -0.894],
                    [-0.099, -0.694],
                    [-0.896, -0.893],
                    [-0.696, 0.596]
                  ],
                  "o": [
                    [-1.093, -1.092],
                    [-0.695, 0.496],
                    [0.893, 0.894],
                    [0.693, 0.199],
                    [1.191, -0.992]
                  ],
                  "v": [
                    [2.135, -2.631],
                    [-1.538, -3.028],
                    [-2.532, -0.944],
                    [-0.346, 1.34],
                    [2.234, 0.744]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.994, 0.199],
                    [-1.093, -0.993],
                    [0.397, -0.298],
                    [2.58, 2.779],
                    [-0.299, 0.298],
                    [-0.298, -0.298],
                    [-0.794, 0.596],
                    [-1.588, -1.589],
                    [1.589, -1.191]
                  ],
                  "o": [
                    [0.994, 0.992],
                    [-0.397, 0.298],
                    [-2.779, -2.681],
                    [0.397, -0.298],
                    [0.299, 0.298],
                    [0, -0.795],
                    [1.487, -1.191],
                    [1.589, 1.489],
                    [-0.794, 0.596]
                  ],
                  "v": [
                    [0.248, 1.837],
                    [2.929, 4.418],
                    [1.935, 5.113],
                    [-4.715, -1.737],
                    [-3.822, -2.433],
                    [-3.127, -1.638],
                    [-1.935, -3.922],
                    [3.126, -3.326],
                    [3.126, 1.241]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [66.664, 74.689],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, -0.298],
                    [0.296, 0.298],
                    [0.992, -0.694],
                    [0.994, 1.092],
                    [1.29, 1.589],
                    [-0.398, 0.199],
                    [-1.191, -1.39],
                    [-0.794, 0.497],
                    [0, 0.595],
                    [1.29, 1.489],
                    [-0.396, 0.198],
                    [-1.887, -1.985]
                  ],
                  "o": [
                    [-0.296, -0.298],
                    [-0.101, 0.794],
                    [-1.388, 0.894],
                    [-1.29, -1.49],
                    [0.397, -0.199],
                    [1.191, 1.39],
                    [0.794, 0.894],
                    [0.794, -0.497],
                    [-1.389, -1.49],
                    [0.396, -0.298],
                    [1.788, 2.085],
                    [-0.397, 0.1]
                  ],
                  "v": [
                    [3.97, 1.489],
                    [3.277, 0.794],
                    [1.787, 3.176],
                    [-1.787, 2.879],
                    [-4.964, -0.894],
                    [-3.969, -1.489],
                    [-0.993, 1.985],
                    [1.489, 2.284],
                    [2.68, 0.298],
                    [-0.694, -3.475],
                    [0.297, -4.07],
                    [4.964, 0.993]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.162, 78.313],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.893, 1.092],
                    [1.392, -0.695],
                    [-0.892, -1.191],
                    [-1.392, 0.794]
                  ],
                  "o": [
                    [-0.894, -1.092],
                    [-1.389, 0.794],
                    [0.894, 1.093],
                    [1.389, -0.894]
                  ],
                  "v": [
                    [2.283, -1.241],
                    [-1.59, -2.134],
                    [-2.185, 1.241],
                    [1.787, 2.135]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.191, 1.588],
                    [-2.084, 1.091],
                    [-1.293, -1.588],
                    [2.185, -1.192]
                  ],
                  "o": [
                    [-1.29, -1.589],
                    [2.085, -1.093],
                    [1.29, 1.589],
                    [-2.085, 1.191]
                  ],
                  "v": [
                    [-3.376, 1.738],
                    [-2.185, -2.928],
                    [3.376, -1.936],
                    [2.382, 2.83]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.816, 82.73],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.687, 2.482],
                    [-2.779, 1.291],
                    [-1.388, -0.496],
                    [0.298, -0.298],
                    [1.091, -0.397],
                    [-1.29, -1.887],
                    [-2.184, 0.992],
                    [-0.102, 0.893],
                    [-0.594, 0.099],
                    [1.786, -0.893]
                  ],
                  "o": [
                    [-1.687, -2.482],
                    [1.687, -0.695],
                    [-0.298, 0.398],
                    [-0.992, -0.397],
                    [-2.184, 0.893],
                    [1.293, 1.886],
                    [1.191, -0.497],
                    [0.594, 0],
                    [-0.098, 1.29],
                    [-2.879, 1.39]
                  ],
                  "v": [
                    [-4.567, 1.936],
                    [-2.184, -4.418],
                    [2.581, -4.518],
                    [1.886, -3.624],
                    [-1.588, -3.624],
                    [-3.277, 1.241],
                    [2.979, 2.83],
                    [4.866, 0.447],
                    [6.254, 0.348],
                    [3.674, 3.723]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [43.485, 85.809],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-20.449, -14.347],
                    [-22.237, -15.736],
                    [-21.243, -17.126],
                    [-19.457, -15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-16.776, -11.666],
                    [-18.564, -13.056],
                    [-17.57, -14.445],
                    [-15.784, -13.056]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-13.204, -8.985],
                    [-14.99, -10.375],
                    [-13.999, -11.765],
                    [-12.211, -10.375]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-9.631, -6.205],
                    [-11.416, -7.595],
                    [-10.425, -8.985],
                    [-8.636, -7.595]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-6.056, -3.524],
                    [-7.842, -4.915],
                    [-6.85, -6.304],
                    [-5.064, -4.915]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.482, -0.843],
                    [-4.27, -2.233],
                    [-3.276, -3.624],
                    [-1.49, -2.233]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [1.191, 1.937],
                    [-0.595, 0.546],
                    [0.397, -0.843],
                    [2.183, 0.546]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.765, 4.617],
                    [2.977, 3.227],
                    [3.971, 1.837],
                    [5.756, 3.227]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [8.339, 7.297],
                    [6.551, 5.908],
                    [7.545, 4.518],
                    [9.33, 5.908]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [11.91, 10.078],
                    [10.125, 8.688],
                    [11.116, 7.297],
                    [12.905, 8.688]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [15.485, 12.757],
                    [13.699, 11.369],
                    [14.691, 9.979],
                    [16.479, 11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [19.059, 15.439],
                    [17.274, 14.05],
                    [18.265, 12.659],
                    [20.051, 14.05]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [21.242, 17.126],
                    [20.845, 16.829],
                    [21.839, 15.439],
                    [22.237, 15.736]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [93.616, 47.684],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.597, 0.298],
                    [-0.398, 0.1],
                    [-0.496, 0.199],
                    [-0.298, 0.198],
                    [-0.496, 0.198],
                    [-0.397, 0.198],
                    [-0.496, 0.297],
                    [-0.397, 0.199],
                    [-0.496, 0.298],
                    [0, 0],
                    [-0.497, 0.198],
                    [-0.299, 0.198],
                    [-0.397, 0.198],
                    [-0.299, 0.199],
                    [-0.397, 0.199],
                    [-0.398, 0.199],
                    [-0.397, 0.298],
                    [-0.398, 0.199],
                    [-0.398, 0.298],
                    [-0.298, 0.298],
                    [-0.396, 0.198],
                    [-0.298, 0.298],
                    [-0.396, 0.298],
                    [-0.397, 0.199],
                    [-0.396, 0.298],
                    [-0.298, 0.199],
                    [-0.396, 0.397],
                    [-0.2, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.199],
                    [-0.496, 0.298],
                    [-0.197, 0.198],
                    [-0.496, 0.397],
                    [-0.098, 0.099],
                    [-0.597, 0.595],
                    [0, 0],
                    [-6.155, 7.248],
                    [1.69, 1.29],
                    [0.597, 0.993],
                    [0.696, 0.496],
                    [0.597, 0.496],
                    [2.976, 2.085],
                    [3.079, 2.482],
                    [3.969, 3.376],
                    [7.542, -1.49],
                    [0.2, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.09, -0.894],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.093, -0.893],
                    [0.892, -1.191],
                    [0, 0],
                    [-1.191, -0.993],
                    [0.892, -1.092],
                    [0, 0],
                    [-1.092, -0.894],
                    [0.794, -1.191],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.795, -1.092],
                    [0, 0],
                    [-0.994, -0.894],
                    [0.794, -1.192],
                    [0, 0],
                    [-1.093, -0.992],
                    [0.697, -1.093],
                    [0, 0],
                    [-0.994, -0.893],
                    [0.694, -1.092],
                    [0, 0],
                    [-0.893, 0.397],
                    [-0.299, 0.099]
                  ],
                  "o": [
                    [0.397, -0.099],
                    [0.496, -0.199],
                    [0.397, -0.198],
                    [0.497, -0.198],
                    [0.396, -0.199],
                    [0.495, -0.199],
                    [0.397, -0.199],
                    [0.499, -0.199],
                    [0, 0],
                    [0.496, -0.198],
                    [0.397, -0.199],
                    [0.496, -0.199],
                    [0.398, -0.199],
                    [0.398, -0.198],
                    [0.398, -0.199],
                    [0.397, -0.298],
                    [0.397, -0.198],
                    [0.397, -0.298],
                    [0.296, -0.198],
                    [0.397, -0.298],
                    [0.299, -0.199],
                    [0.398, -0.298],
                    [0.299, -0.198],
                    [0.397, -0.297],
                    [0.296, -0.199],
                    [0.496, -0.298],
                    [0.299, -0.198],
                    [0.495, -0.298],
                    [0.199, -0.199],
                    [0.496, -0.397],
                    [0.197, -0.199],
                    [0.499, -0.397],
                    [0.098, -0.099],
                    [0.597, -0.496],
                    [0, 0],
                    [8.736, -7.347],
                    [-1.786, -1.39],
                    [-0.893, -0.695],
                    [-0.696, -0.397],
                    [-0.594, -0.397],
                    [-2.879, -2.284],
                    [-3.279, -2.283],
                    [-4.168, -3.375],
                    [-25.512, 32.267],
                    [-0.398, 0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.994, -1.093],
                    [1.093, 0.993],
                    [0, 0],
                    [0.992, -1.092],
                    [1.093, 0.994],
                    [0, 0],
                    [0.995, -1.092],
                    [1.093, 0.993],
                    [0, 0],
                    [0.993, -0.993],
                    [1.091, 0.893],
                    [0, 0],
                    [0.992, -0.992],
                    [1.093, 0.894],
                    [0, 0],
                    [0.991, -0.993],
                    [0.991, 0.893],
                    [0, 0],
                    [0.994, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.991, -0.893],
                    [0.991, 0.894],
                    [0, 0],
                    [0.893, -0.298],
                    [0.299, -0.1],
                    [0.597, -0.099]
                  ],
                  "v": [
                    [-5.956, 39.068],
                    [-4.863, 38.671],
                    [-3.277, 38.075],
                    [-2.185, 37.579],
                    [-0.694, 36.984],
                    [0.497, 36.487],
                    [1.984, 35.792],
                    [3.175, 35.196],
                    [4.566, 34.501],
                    [5.758, 33.905],
                    [7.147, 33.211],
                    [8.239, 32.615],
                    [9.529, 31.92],
                    [10.622, 31.324],
                    [11.912, 30.629],
                    [13.005, 30.033],
                    [14.295, 29.239],
                    [15.388, 28.643],
                    [16.678, 27.849],
                    [17.669, 27.154],
                    [18.959, 26.36],
                    [19.953, 25.665],
                    [21.243, 24.771],
                    [22.235, 24.175],
                    [23.527, 23.282],
                    [24.42, 22.686],
                    [25.71, 21.693],
                    [26.505, 21.098],
                    [27.894, 20.105],
                    [28.589, 19.509],
                    [30.079, 18.417],
                    [30.673, 17.921],
                    [32.262, 16.63],
                    [32.659, 16.332],
                    [34.546, 14.744],
                    [34.645, 14.644],
                    [56.98, -7.695],
                    [51.817, -11.765],
                    [48.046, -14.446],
                    [45.961, -15.836],
                    [44.074, -17.226],
                    [35.639, -24.176],
                    [26.107, -31.225],
                    [13.799, -40.955],
                    [-55.49, 1.837],
                    [-56.386, 2.035],
                    [-56.484, 2.035],
                    [-56.682, 2.035],
                    [-56.78, 2.035],
                    [-56.882, 2.035],
                    [-56.98, 2.035],
                    [-54.896, 3.822],
                    [-54.896, 3.723],
                    [-51.125, 3.425],
                    [-50.826, 7.198],
                    [-49.435, 8.389],
                    [-45.664, 8.091],
                    [-45.365, 11.864],
                    [-43.977, 13.056],
                    [-40.205, 12.857],
                    [-39.906, 16.531],
                    [-38.516, 17.722],
                    [-34.843, 17.524],
                    [-34.445, 21.197],
                    [-33.057, 22.388],
                    [-29.384, 22.289],
                    [-28.987, 25.863],
                    [-27.497, 27.055],
                    [-23.923, 26.956],
                    [-23.525, 30.53],
                    [-22.038, 31.82],
                    [-18.464, 31.82],
                    [-17.969, 35.296],
                    [-16.478, 36.586],
                    [-13.003, 36.586],
                    [-12.508, 40.061],
                    [-11.516, 40.955],
                    [-8.736, 39.962],
                    [-7.843, 39.664]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [58.078, 72.108],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-4.169, -3.375],
                    [-3.275, -2.283],
                    [-2.879, -2.284],
                    [-0.696, -0.397],
                    [-0.695, -0.496],
                    [-0.893, -0.694],
                    [-1.687, -1.29],
                    [8.734, -7.347],
                    [0, 0],
                    [0, 0],
                    [0.101, -0.099],
                    [1.192, 0.795],
                    [-0.794, 1.191],
                    [-0.098, 0.099],
                    [0, 0],
                    [0.099, -0.199],
                    [1.189, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0.099],
                    [0, 0],
                    [0.101, -0.1],
                    [1.192, 0.795],
                    [-0.794, 1.192],
                    [-0.099, 0],
                    [0, 0],
                    [0.098, -0.099],
                    [1.192, 0.794],
                    [-0.794, 1.191],
                    [-0.099, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.191, 0.794],
                    [-0.792, 1.192],
                    [0, 0.099],
                    [0, 0],
                    [0, -0.099],
                    [1.189, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0.101, 0],
                    [1.191, 0.794],
                    [-0.795, 1.191],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.192, 0.795],
                    [-0.795, 1.191],
                    [0, 0],
                    [6.751, -8.538]
                  ],
                  "o": [
                    [3.075, 2.482],
                    [2.98, 2.085],
                    [0.596, 0.496],
                    [0.695, 0.497],
                    [0.497, 0.993],
                    [1.789, 1.291],
                    [-6.154, 7.248],
                    [28.292, -23.828],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.1],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.892, 1.191],
                    [-1.192, -0.893],
                    [0.099, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0.098, -0.099],
                    [0, 0],
                    [-0.099, 0.099],
                    [-0.893, 1.191],
                    [-1.191, -0.794],
                    [0.098, -0.1],
                    [0, 0],
                    [0, 0.099],
                    [-0.892, 1.192],
                    [-1.192, -0.893],
                    [0, -0.099],
                    [0, 0],
                    [0, 0.099],
                    [-0.893, 1.192],
                    [-1.191, -0.894],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.192],
                    [-1.191, -0.795],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.893, 1.191],
                    [-1.191, -0.893],
                    [0, 0],
                    [-4.467, 12.014],
                    [4.369, 2.979]
                  ],
                  "v": [
                    [-19.555, -2.929],
                    [-10.027, 4.121],
                    [-1.588, 11.07],
                    [0.299, 12.46],
                    [2.382, 13.851],
                    [6.154, 16.531],
                    [11.317, 20.602],
                    [-11.018, 42.94],
                    [32.362, -9.084],
                    [31.072, -9.978],
                    [30.872, -9.581],
                    [27.101, -8.985],
                    [26.507, -12.757],
                    [26.802, -13.056],
                    [25.214, -14.147],
                    [25.016, -13.75],
                    [21.245, -13.155],
                    [20.648, -16.929],
                    [20.947, -17.226],
                    [19.358, -18.317],
                    [19.158, -18.02],
                    [15.386, -17.424],
                    [14.793, -21.197],
                    [14.99, -21.396],
                    [13.401, -22.487],
                    [13.204, -22.189],
                    [9.43, -21.594],
                    [8.836, -25.367],
                    [9.033, -25.565],
                    [7.444, -26.657],
                    [7.345, -26.459],
                    [3.574, -25.863],
                    [2.977, -29.636],
                    [3.079, -29.834],
                    [1.589, -30.926],
                    [1.49, -30.729],
                    [-2.282, -30.132],
                    [-2.878, -33.905],
                    [-2.78, -34.004],
                    [-4.267, -35.097],
                    [-4.368, -34.998],
                    [-8.14, -34.401],
                    [-8.734, -38.174],
                    [-8.635, -38.273],
                    [-10.125, -39.367],
                    [-10.125, -39.267],
                    [-13.897, -38.671],
                    [-14.493, -42.443],
                    [-15.187, -42.94],
                    [-32.362, -12.261]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [103.941, 43.812],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 10,
      "ty": 4,
      "nm": "Layer 10 Outlines 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 0,
              "s": [26]
            },
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 72,
              "s": [-45]
            },
            {
              "t": 138,
              "s": [19]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.458,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [287.5, 185, 0],
              "to": [-0.667, 110, 0],
              "ti": [0.667, -110, 0]
            },
            {
              "t": 143,
              "s": [283.5, 845, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [119.5, -146, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [66, 66, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.696, 0.794],
                    [-0.2, 0.298],
                    [-0.893, -0.099],
                    [0, 0.695],
                    [-0.296, 2.482],
                    [-1.589, -0.199],
                    [-0.496, -0.595],
                    [0.197, -0.298],
                    [0.794, 0.099],
                    [0.099, -0.596],
                    [0.098, -2.681],
                    [1.785, 0.198]
                  ],
                  "o": [
                    [0.2, -0.298],
                    [0.397, 0.595],
                    [1.093, 0.1],
                    [0.098, -1.588],
                    [0.101, -0.992],
                    [1.093, 0.099],
                    [-0.2, 0.298],
                    [-0.397, -0.497],
                    [-0.893, -0.099],
                    [-0.098, 1.489],
                    [0, 1.092],
                    [-1.093, -0.099]
                  ],
                  "v": [
                    [-2.829, 2.135],
                    [-2.232, 1.44],
                    [-0.049, 2.631],
                    [1.638, 1.638],
                    [-2.333, -1.936],
                    [0.348, -3.524],
                    [2.731, -2.333],
                    [2.235, -1.638],
                    [0.348, -2.73],
                    [-1.241, -1.836],
                    [2.731, 1.738],
                    [-0.049, 3.525]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [67.101, 60.714],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.1],
                    [-0.2, 1.687],
                    [0.896, 0.099],
                    [0.495, -0.397],
                    [0.199, -1.986],
                    [0.397, 0.1],
                    [-0.397, 2.581],
                    [-0.498, -0.099],
                    [0.098, -0.397],
                    [-0.994, -0.099],
                    [0.2, -1.39],
                    [0.099, -1.887]
                  ],
                  "o": [
                    [0.099, -1.787],
                    [0.099, -1.192],
                    [-0.793, -0.199],
                    [-0.299, 1.986],
                    [-0.397, -0.099],
                    [0.298, -2.68],
                    [0.397, 0.099],
                    [-0.101, 0.397],
                    [0.596, -0.497],
                    [1.389, 0.298],
                    [-0.197, 1.886],
                    [-0.495, 0]
                  ],
                  "v": [
                    [1.539, 3.722],
                    [1.936, -0.645],
                    [0.643, -2.432],
                    [-1.539, -1.837],
                    [-2.136, 3.028],
                    [-3.226, 2.829],
                    [-2.334, -3.823],
                    [-1.241, -3.624],
                    [-1.44, -2.631],
                    [1.142, -3.326],
                    [3.026, -0.844],
                    [2.629, 3.823]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.451, 59.622],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.2, 1.39],
                    [1.392, 0.397],
                    [0.298, -1.29],
                    [-1.49, -0.398]
                  ],
                  "o": [
                    [0.197, -1.39],
                    [-1.487, -0.397],
                    [-0.296, 1.39],
                    [1.49, 0.397]
                  ],
                  "v": [
                    [2.384, 0.546],
                    [0.595, -2.63],
                    [-2.184, -0.744],
                    [-0.297, 2.533]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.397, 1.985],
                    [-2.087, -0.596],
                    [0.299, -1.986],
                    [2.182, 0.595]
                  ],
                  "o": [
                    [0.397, -1.986],
                    [2.084, 0.596],
                    [-0.296, 1.986],
                    [-2.087, -0.596]
                  ],
                  "v": [
                    [-3.376, -1.042],
                    [0.697, -3.524],
                    [3.474, 0.845],
                    [-0.494, 3.525]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.757, 58.032],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.296, 1.39],
                    [1.293, 0.397],
                    [0.495, -0.397],
                    [0.298, -1.191],
                    [-0.895, -0.298]
                  ],
                  "o": [
                    [0.298, -1.489],
                    [-0.794, -0.298],
                    [-0.299, 1.192],
                    [0.2, 0.695],
                    [1.389, 0.397]
                  ],
                  "v": [
                    [2.433, 0.397],
                    [0.844, -2.879],
                    [-1.437, -2.582],
                    [-2.134, 0.397],
                    [-0.246, 2.283]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.993],
                    [0.197, -1.489],
                    [0.398, 0.199],
                    [-0.994, 3.673],
                    [-0.495, -0.099],
                    [0.101, -0.397],
                    [-0.994, -0.298],
                    [0.395, -2.185],
                    [1.788, 0.695]
                  ],
                  "o": [
                    [-0.299, 1.39],
                    [-0.496, -0.199],
                    [0.696, -3.772],
                    [0.397, 0.199],
                    [-0.099, 0.397],
                    [0.695, -0.497],
                    [1.786, 0.596],
                    [-0.396, 2.184],
                    [-1.093, -0.298]
                  ],
                  "v": [
                    [-2.33, 1.191],
                    [-3.027, 4.865],
                    [-4.119, 4.467],
                    [-1.933, -4.865],
                    [-0.844, -4.468],
                    [-1.141, -3.475],
                    [1.441, -3.773],
                    [3.725, 0.695],
                    [-0.049, 3.177]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [44.865, 55.998],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.199],
                    [-0.098, 0.397],
                    [1.09, 0.496],
                    [-0.397, 1.489],
                    [-0.597, 1.787],
                    [-0.495, -0.199],
                    [0.499, -1.788],
                    [-0.992, -0.496],
                    [-0.496, 0.298],
                    [-0.496, 1.886],
                    [-0.496, -0.099],
                    [0.595, -2.681]
                  ],
                  "o": [
                    [0.099, -0.397],
                    [-0.693, 0.397],
                    [-1.49, -0.695],
                    [0.499, -1.886],
                    [0.398, 0.198],
                    [-0.594, 1.688],
                    [-0.296, 1.191],
                    [0.893, 0.397],
                    [0.496, -1.985],
                    [0.397, 0.198],
                    [-0.795, 2.681],
                    [-0.397, -0.099]
                  ],
                  "v": [
                    [0.944, 4.219],
                    [1.141, 3.227],
                    [-1.636, 3.227],
                    [-3.326, 0.049],
                    [-1.936, -4.617],
                    [-0.845, -4.121],
                    [-2.135, 0.249],
                    [-0.943, 2.531],
                    [1.341, 2.433],
                    [2.63, -2.433],
                    [3.724, -2.036],
                    [2.036, 4.617]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.321, 52.374],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.397, 1.39],
                    [1.389, 0.794],
                    [0.497, -1.39],
                    [-1.489, -0.794]
                  ],
                  "o": [
                    [0.397, -1.39],
                    [-1.39, -0.794],
                    [-0.496, 1.39],
                    [1.489, 0.794]
                  ],
                  "v": [
                    [2.232, 1.192],
                    [0.843, -2.581],
                    [-2.334, -1.29],
                    [-0.845, 2.582]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.694, 1.887],
                    [-2.085, -1.092],
                    [0.598, -1.886],
                    [2.085, 1.091]
                  ],
                  "o": [
                    [0.696, -1.886],
                    [1.986, 1.093],
                    [-0.594, 1.887],
                    [-2.184, -1.093]
                  ],
                  "v": [
                    [-3.327, -1.886],
                    [1.24, -3.475],
                    [3.423, 1.688],
                    [-1.043, 3.476]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [29.678, 48.75],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.191, 2.78],
                    [-2.581, -1.688],
                    [-0.298, -1.489],
                    [0.496, 0.099],
                    [0.994, 0.694],
                    [0.993, -2.184],
                    [-2.085, -1.291],
                    [-0.794, 0.397],
                    [-0.298, -0.397],
                    [1.688, 1.093]
                  ],
                  "o": [
                    [1.191, -2.78],
                    [1.588, 1.092],
                    [-0.497, 0],
                    [-0.199, -1.092],
                    [-1.985, -1.291],
                    [-0.894, 2.185],
                    [1.092, 0.695],
                    [0.298, 0.496],
                    [-1.191, 0.596],
                    [-2.68, -1.687]
                  ],
                  "v": [
                    [-4.07, -2.979],
                    [2.581, -4.368],
                    [5.261, -0.398],
                    [4.07, -0.496],
                    [2.183, -3.376],
                    [-2.879, -2.086],
                    [-0.794, 3.971],
                    [2.283, 4.269],
                    [3.077, 5.361],
                    [-1.192, 4.964]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.984, 42.793],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.102, -0.099],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, -0.099]
                  ],
                  "v": [
                    [0.051, 0.049],
                    [-0.051, 0.049]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [48.142, 84.443],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.945, -24.971],
                    [1.142, -27.253],
                    [2.83, -27.154],
                    [2.631, -24.871]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.547, -20.502],
                    [0.745, -22.786],
                    [2.432, -22.687],
                    [2.234, -20.403]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.25, -16.035],
                    [0.447, -18.318],
                    [2.136, -18.219],
                    [1.937, -15.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.049, -11.467],
                    [0.15, -13.751],
                    [1.837, -13.651],
                    [1.638, -11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.348, -7],
                    [-0.148, -9.284],
                    [1.54, -9.184],
                    [1.342, -6.9]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.644, -2.532],
                    [-0.446, -4.815],
                    [1.241, -4.716],
                    [1.043, -2.433]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.041, 1.936],
                    [-0.843, -0.348],
                    [0.844, -0.249],
                    [0.646, 2.035]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.339, 6.502],
                    [-1.14, 4.22],
                    [0.547, 4.318],
                    [0.348, 6.603]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.638, 10.971],
                    [-1.438, 8.688],
                    [0.25, 8.787],
                    [0.048, 11.07]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.934, 15.438],
                    [-1.736, 13.154],
                    [-0.049, 13.254],
                    [-0.247, 15.538]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.232, 19.907],
                    [-2.034, 17.623],
                    [-0.348, 17.722],
                    [-0.545, 20.005]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.629, 24.474],
                    [-2.433, 22.189],
                    [-0.745, 22.289],
                    [-0.942, 24.573]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.83, 27.154],
                    [-2.83, 26.757],
                    [-1.14, 26.856],
                    [-1.14, 27.253]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [81.297, 63.891],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.596, -0.397],
                    [-0.298, -0.298],
                    [-0.496, -0.298],
                    [-0.297, -0.198],
                    [-0.497, -0.297],
                    [-0.397, -0.199],
                    [-0.397, -0.298],
                    [-0.397, -0.298],
                    [-0.397, -0.297],
                    [-0.397, -0.299],
                    [-0.397, -0.298],
                    [-0.298, -0.198],
                    [-0.397, -0.198],
                    [-0.298, -0.199],
                    [-0.397, -0.198],
                    [-0.298, -0.199],
                    [-0.497, -0.199],
                    [-0.297, -0.099],
                    [-0.496, -0.298],
                    [-0.397, -0.199],
                    [-0.497, -0.199],
                    [-0.397, -0.199],
                    [-0.397, -0.198],
                    [-0.397, -0.1],
                    [-0.498, -0.198],
                    [-0.299, -0.099],
                    [-0.595, -0.199],
                    [-0.398, -0.198],
                    [-0.496, -0.198],
                    [-0.299, -0.099],
                    [-0.595, -0.199],
                    [-0.2, 0],
                    [-0.696, -0.297],
                    [-0.199, -0.099],
                    [-0.696, -0.199],
                    [0, 0],
                    [-9.429, -1.191],
                    [-0.197, 2.184],
                    [-0.496, 0.992],
                    [0, 0],
                    [-0.099, 0.695],
                    [-0.098, 3.674],
                    [-0.397, 3.971],
                    [-0.696, 5.163],
                    [5.46, 5.461],
                    [0.199, 0.198],
                    [0, 0],
                    [0, 0],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0.199],
                    [0, 0],
                    [0.199, -1.39],
                    [1.489, 0.199],
                    [0, 0],
                    [0.198, -1.39],
                    [1.39, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.389, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0],
                    [0, 0],
                    [0.198, -1.39],
                    [1.291, 0],
                    [0, 0],
                    [0.199, -1.389],
                    [1.29, 0],
                    [0, 0],
                    [-0.794, -0.595],
                    [-0.299, -0.199]
                  ],
                  "o": [
                    [0.297, 0.199],
                    [0.497, 0.298],
                    [0.298, 0.199],
                    [0.497, 0.298],
                    [0.396, 0.199],
                    [0.397, 0.298],
                    [0.397, 0.198],
                    [0.397, 0.298],
                    [0.397, 0.199],
                    [0.397, 0.297],
                    [0.397, 0.198],
                    [0.397, 0.199],
                    [0.397, 0.199],
                    [0.398, 0.199],
                    [0.397, 0.199],
                    [0.496, 0.198],
                    [0.397, 0.199],
                    [0.496, 0.199],
                    [0.397, 0.199],
                    [0.496, 0.198],
                    [0.397, 0.198],
                    [0.496, 0.198],
                    [0.398, 0.1],
                    [0.496, 0.198],
                    [0.296, 0.1],
                    [0.496, 0.199],
                    [0.298, 0.099],
                    [0.495, 0.199],
                    [0.299, 0.099],
                    [0.594, 0.198],
                    [0.199, 0.099],
                    [0.693, 0.199],
                    [0.197, 0.1],
                    [0.795, 0.298],
                    [0, 0],
                    [10.92, 3.276],
                    [0.198, -2.184],
                    [0.101, -1.092],
                    [0, 0],
                    [0, -0.795],
                    [0.397, -3.673],
                    [0.2, -3.971],
                    [0.597, -5.262],
                    [-40.998, -3.772],
                    [-0.298, -0.298],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.49, 0.199],
                    [-0.198, 1.49],
                    [0, 0],
                    [1.489, 0.199],
                    [-0.198, 1.489],
                    [0, 0],
                    [1.39, 0.198],
                    [-0.199, 1.39],
                    [0, 0],
                    [1.39, 0.298],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.389, 0.297],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.291, 0.298],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.291, 0.298],
                    [-0.199, 1.39],
                    [0, 0],
                    [1.29, 0.397],
                    [-0.198, 1.291],
                    [0, 0],
                    [0.794, 0.596],
                    [0.298, 0.199],
                    [0.893, 0]
                  ],
                  "v": [
                    [-36.332, 17.623],
                    [-35.439, 18.318],
                    [-34.049, 19.311],
                    [-33.057, 20.006],
                    [-31.667, 20.899],
                    [-30.575, 21.595],
                    [-29.284, 22.488],
                    [-28.192, 23.183],
                    [-26.902, 23.977],
                    [-25.81, 24.673],
                    [-24.519, 25.467],
                    [-23.427, 26.062],
                    [-22.137, 26.757],
                    [-21.045, 27.353],
                    [-19.754, 28.048],
                    [-18.662, 28.644],
                    [-17.272, 29.339],
                    [-16.181, 29.835],
                    [-14.792, 30.53],
                    [-13.699, 31.027],
                    [-12.309, 31.623],
                    [-11.217, 32.119],
                    [-9.829, 32.714],
                    [-8.736, 33.112],
                    [-7.246, 33.707],
                    [-6.254, 34.104],
                    [-4.665, 34.7],
                    [-3.671, 35.097],
                    [-2.086, 35.693],
                    [-1.19, 35.991],
                    [0.596, 36.587],
                    [1.291, 36.785],
                    [3.277, 37.48],
                    [3.771, 37.679],
                    [6.057, 38.374],
                    [6.155, 38.374],
                    [37.027, 44.926],
                    [37.622, 38.374],
                    [37.822, 33.807],
                    [37.822, 31.325],
                    [38.019, 29.041],
                    [39.21, 18.219],
                    [39.906, 6.404],
                    [41.396, -9.184],
                    [-32.262, -43.933],
                    [-32.957, -44.628],
                    [-33.057, -44.727],
                    [-33.156, -44.827],
                    [-33.255, -44.926],
                    [-33.652, -42.245],
                    [-33.553, -42.245],
                    [-31.271, -39.267],
                    [-34.248, -36.983],
                    [-34.446, -35.097],
                    [-32.163, -32.118],
                    [-35.141, -29.835],
                    [-35.439, -27.948],
                    [-33.255, -24.97],
                    [-36.134, -22.686],
                    [-36.432, -20.8],
                    [-34.248, -17.821],
                    [-37.126, -15.538],
                    [-37.424, -13.651],
                    [-35.34, -10.673],
                    [-38.119, -8.389],
                    [-38.417, -6.503],
                    [-36.432, -3.524],
                    [-39.211, -1.241],
                    [-39.509, 0.645],
                    [-37.523, 3.624],
                    [-40.204, 5.908],
                    [-40.501, 7.794],
                    [-38.616, 10.772],
                    [-41.196, 13.056],
                    [-41.396, 14.446],
                    [-39.112, 16.233],
                    [-38.317, 16.829]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [41.739, 46.019],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.496, -5.262],
                    [0.2, -3.971],
                    [0.397, -3.574],
                    [0.098, -0.794],
                    [0, 0],
                    [0.098, -1.092],
                    [0.197, -2.184],
                    [10.917, 3.276],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.389, -0.099],
                    [-0.098, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.388, -0.099],
                    [-0.099, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [-0.098, -0.1],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.389],
                    [-1.388, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.389],
                    [-1.389, -0.099],
                    [0, 0],
                    [10.819, 0.993]
                  ],
                  "o": [
                    [-0.397, 3.972],
                    [-0.197, 3.674],
                    [-0.099, 0.794],
                    [0, 0],
                    [-0.499, 0.993],
                    [-0.197, 2.184],
                    [-9.433, -1.191],
                    [35.338, 10.722],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.099],
                    [0.101, -1.489],
                    [0.199, 0],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.1],
                    [0.101, -1.49],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.1],
                    [0.099, -1.488],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.49],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.49, -0.099],
                    [0.101, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.49, -0.1],
                    [0.101, -1.49],
                    [0, 0],
                    [-12.508, 2.78],
                    [-0.397, 4.865]
                  ],
                  "v": [
                    [-1.241, -12.56],
                    [-1.937, -0.744],
                    [-3.128, 10.077],
                    [-3.325, 12.361],
                    [-3.325, 14.844],
                    [-3.525, 19.41],
                    [-4.119, 25.963],
                    [-34.991, 19.41],
                    [32.211, 27.452],
                    [32.312, 25.864],
                    [31.814, 25.864],
                    [29.333, 23.083],
                    [32.113, 20.601],
                    [32.509, 20.7],
                    [32.608, 18.716],
                    [32.211, 18.716],
                    [29.73, 15.935],
                    [32.509, 13.453],
                    [32.907, 13.552],
                    [33.006, 11.666],
                    [32.608, 11.666],
                    [30.127, 8.885],
                    [32.907, 6.404],
                    [33.205, 6.504],
                    [33.304, 4.616],
                    [33.006, 4.616],
                    [30.524, 1.837],
                    [33.304, -0.646],
                    [33.602, -0.646],
                    [33.701, -2.531],
                    [33.403, -2.531],
                    [30.921, -5.312],
                    [33.701, -7.794],
                    [33.901, -7.794],
                    [34, -9.68],
                    [33.8, -9.68],
                    [31.318, -12.46],
                    [34.098, -14.943],
                    [34.298, -14.943],
                    [34.397, -16.828],
                    [34.298, -16.828],
                    [31.814, -19.609],
                    [34.594, -22.091],
                    [34.695, -22.091],
                    [34.794, -23.977],
                    [34.695, -23.977],
                    [32.211, -26.757],
                    [34.991, -29.24],
                    [34.991, -30.133],
                    [-0.05, -27.849]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.184, 64.884],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 11",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 11,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 11,
      "ty": 4,
      "nm": "Layer 10 Outlines",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 0,
              "s": [26]
            },
            {
              "i": {
                "x": [0.667],
                "y": [1]
              },
              "o": {
                "x": [0.333],
                "y": [0]
              },
              "t": 72,
              "s": [-45]
            },
            {
              "t": 138,
              "s": [19]
            }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.458,
                "y": 1
              },
              "o": {
                "x": 0.333,
                "y": 0
              },
              "t": 0,
              "s": [213.5, -249, 0],
              "to": [-0.667, 110, 0],
              "ti": [0.667, -110, 0]
            },
            {
              "t": 143,
              "s": [209.5, 411, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [119.5, -146, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [174, 174, 100],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.696, 0.794],
                    [-0.2, 0.298],
                    [-0.893, -0.099],
                    [0, 0.695],
                    [-0.296, 2.482],
                    [-1.589, -0.199],
                    [-0.496, -0.595],
                    [0.197, -0.298],
                    [0.794, 0.099],
                    [0.099, -0.596],
                    [0.098, -2.681],
                    [1.785, 0.198]
                  ],
                  "o": [
                    [0.2, -0.298],
                    [0.397, 0.595],
                    [1.093, 0.1],
                    [0.098, -1.588],
                    [0.101, -0.992],
                    [1.093, 0.099],
                    [-0.2, 0.298],
                    [-0.397, -0.497],
                    [-0.893, -0.099],
                    [-0.098, 1.489],
                    [0, 1.092],
                    [-1.093, -0.099]
                  ],
                  "v": [
                    [-2.829, 2.135],
                    [-2.232, 1.44],
                    [-0.049, 2.631],
                    [1.638, 1.638],
                    [-2.333, -1.936],
                    [0.348, -3.524],
                    [2.731, -2.333],
                    [2.235, -1.638],
                    [0.348, -2.73],
                    [-1.241, -1.836],
                    [2.731, 1.738],
                    [-0.049, 3.525]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [67.101, 60.714],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.1],
                    [-0.2, 1.687],
                    [0.896, 0.099],
                    [0.495, -0.397],
                    [0.199, -1.986],
                    [0.397, 0.1],
                    [-0.397, 2.581],
                    [-0.498, -0.099],
                    [0.098, -0.397],
                    [-0.994, -0.099],
                    [0.2, -1.39],
                    [0.099, -1.887]
                  ],
                  "o": [
                    [0.099, -1.787],
                    [0.099, -1.192],
                    [-0.793, -0.199],
                    [-0.299, 1.986],
                    [-0.397, -0.099],
                    [0.298, -2.68],
                    [0.397, 0.099],
                    [-0.101, 0.397],
                    [0.596, -0.497],
                    [1.389, 0.298],
                    [-0.197, 1.886],
                    [-0.495, 0]
                  ],
                  "v": [
                    [1.539, 3.722],
                    [1.936, -0.645],
                    [0.643, -2.432],
                    [-1.539, -1.837],
                    [-2.136, 3.028],
                    [-3.226, 2.829],
                    [-2.334, -3.823],
                    [-1.241, -3.624],
                    [-1.44, -2.631],
                    [1.142, -3.326],
                    [3.026, -0.844],
                    [2.629, 3.823]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [60.451, 59.622],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.2, 1.39],
                    [1.392, 0.397],
                    [0.298, -1.29],
                    [-1.49, -0.398]
                  ],
                  "o": [
                    [0.197, -1.39],
                    [-1.487, -0.397],
                    [-0.296, 1.39],
                    [1.49, 0.397]
                  ],
                  "v": [
                    [2.384, 0.546],
                    [0.595, -2.63],
                    [-2.184, -0.744],
                    [-0.297, 2.533]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.397, 1.985],
                    [-2.087, -0.596],
                    [0.299, -1.986],
                    [2.182, 0.595]
                  ],
                  "o": [
                    [0.397, -1.986],
                    [2.084, 0.596],
                    [-0.296, 1.986],
                    [-2.087, -0.596]
                  ],
                  "v": [
                    [-3.376, -1.042],
                    [0.697, -3.524],
                    [3.474, 0.845],
                    [-0.494, 3.525]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [52.757, 58.032],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.296, 1.39],
                    [1.293, 0.397],
                    [0.495, -0.397],
                    [0.298, -1.191],
                    [-0.895, -0.298]
                  ],
                  "o": [
                    [0.298, -1.489],
                    [-0.794, -0.298],
                    [-0.299, 1.192],
                    [0.2, 0.695],
                    [1.389, 0.397]
                  ],
                  "v": [
                    [2.433, 0.397],
                    [0.844, -2.879],
                    [-1.437, -2.582],
                    [-2.134, 0.397],
                    [-0.246, 2.283]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.993],
                    [0.197, -1.489],
                    [0.398, 0.199],
                    [-0.994, 3.673],
                    [-0.495, -0.099],
                    [0.101, -0.397],
                    [-0.994, -0.298],
                    [0.395, -2.185],
                    [1.788, 0.695]
                  ],
                  "o": [
                    [-0.299, 1.39],
                    [-0.496, -0.199],
                    [0.696, -3.772],
                    [0.397, 0.199],
                    [-0.099, 0.397],
                    [0.695, -0.497],
                    [1.786, 0.596],
                    [-0.396, 2.184],
                    [-1.093, -0.298]
                  ],
                  "v": [
                    [-2.33, 1.191],
                    [-3.027, 4.865],
                    [-4.119, 4.467],
                    [-1.933, -4.865],
                    [-0.844, -4.468],
                    [-1.141, -3.475],
                    [1.441, -3.773],
                    [3.725, 0.695],
                    [-0.049, 3.177]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [44.865, 55.998],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.397, 0.199],
                    [-0.098, 0.397],
                    [1.09, 0.496],
                    [-0.397, 1.489],
                    [-0.597, 1.787],
                    [-0.495, -0.199],
                    [0.499, -1.788],
                    [-0.992, -0.496],
                    [-0.496, 0.298],
                    [-0.496, 1.886],
                    [-0.496, -0.099],
                    [0.595, -2.681]
                  ],
                  "o": [
                    [0.099, -0.397],
                    [-0.693, 0.397],
                    [-1.49, -0.695],
                    [0.499, -1.886],
                    [0.398, 0.198],
                    [-0.594, 1.688],
                    [-0.296, 1.191],
                    [0.893, 0.397],
                    [0.496, -1.985],
                    [0.397, 0.198],
                    [-0.795, 2.681],
                    [-0.397, -0.099]
                  ],
                  "v": [
                    [0.944, 4.219],
                    [1.141, 3.227],
                    [-1.636, 3.227],
                    [-3.326, 0.049],
                    [-1.936, -4.617],
                    [-0.845, -4.121],
                    [-2.135, 0.249],
                    [-0.943, 2.531],
                    [1.341, 2.433],
                    [2.63, -2.433],
                    [3.724, -2.036],
                    [2.036, 4.617]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [37.321, 52.374],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.397, 1.39],
                    [1.389, 0.794],
                    [0.497, -1.39],
                    [-1.489, -0.794]
                  ],
                  "o": [
                    [0.397, -1.39],
                    [-1.39, -0.794],
                    [-0.496, 1.39],
                    [1.489, 0.794]
                  ],
                  "v": [
                    [2.232, 1.192],
                    [0.843, -2.581],
                    [-2.334, -1.29],
                    [-0.845, 2.582]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.694, 1.887],
                    [-2.085, -1.092],
                    [0.598, -1.886],
                    [2.085, 1.091]
                  ],
                  "o": [
                    [0.696, -1.886],
                    [1.986, 1.093],
                    [-0.594, 1.887],
                    [-2.184, -1.093]
                  ],
                  "v": [
                    [-3.327, -1.886],
                    [1.24, -3.475],
                    [3.423, 1.688],
                    [-1.043, 3.476]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [29.678, 48.75],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.191, 2.78],
                    [-2.581, -1.688],
                    [-0.298, -1.489],
                    [0.496, 0.099],
                    [0.994, 0.694],
                    [0.993, -2.184],
                    [-2.085, -1.291],
                    [-0.794, 0.397],
                    [-0.298, -0.397],
                    [1.688, 1.093]
                  ],
                  "o": [
                    [1.191, -2.78],
                    [1.588, 1.092],
                    [-0.497, 0],
                    [-0.199, -1.092],
                    [-1.985, -1.291],
                    [-0.894, 2.185],
                    [1.092, 0.695],
                    [0.298, 0.496],
                    [-1.191, 0.596],
                    [-2.68, -1.687]
                  ],
                  "v": [
                    [-4.07, -2.979],
                    [2.581, -4.368],
                    [5.261, -0.398],
                    [4.07, -0.496],
                    [2.183, -3.376],
                    [-2.879, -2.086],
                    [-0.794, 3.971],
                    [2.283, 4.269],
                    [3.077, 5.361],
                    [-1.192, 4.964]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.984, 42.793],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.102, -0.099],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, -0.099]
                  ],
                  "v": [
                    [0.051, 0.049],
                    [-0.051, 0.049]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [48.142, 84.443],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.945, -24.971],
                    [1.142, -27.253],
                    [2.83, -27.154],
                    [2.631, -24.871]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.547, -20.502],
                    [0.745, -22.786],
                    [2.432, -22.687],
                    [2.234, -20.403]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.25, -16.035],
                    [0.447, -18.318],
                    [2.136, -18.219],
                    [1.937, -15.936]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.049, -11.467],
                    [0.15, -13.751],
                    [1.837, -13.651],
                    [1.638, -11.369]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.348, -7],
                    [-0.148, -9.284],
                    [1.54, -9.184],
                    [1.342, -6.9]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-0.644, -2.532],
                    [-0.446, -4.815],
                    [1.241, -4.716],
                    [1.043, -2.433]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.041, 1.936],
                    [-0.843, -0.348],
                    [0.844, -0.249],
                    [0.646, 2.035]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.339, 6.502],
                    [-1.14, 4.22],
                    [0.547, 4.318],
                    [0.348, 6.603]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.638, 10.971],
                    [-1.438, 8.688],
                    [0.25, 8.787],
                    [0.048, 11.07]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.934, 15.438],
                    [-1.736, 13.154],
                    [-0.049, 13.254],
                    [-0.247, 15.538]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.232, 19.907],
                    [-2.034, 17.623],
                    [-0.348, 17.722],
                    [-0.545, 20.005]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.629, 24.474],
                    [-2.433, 22.189],
                    [-0.745, 22.289],
                    [-0.942, 24.573]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.83, 27.154],
                    [-2.83, 26.757],
                    [-1.14, 26.856],
                    [-1.14, 27.253]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [81.297, 63.891],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.596, -0.397],
                    [-0.298, -0.298],
                    [-0.496, -0.298],
                    [-0.297, -0.198],
                    [-0.497, -0.297],
                    [-0.397, -0.199],
                    [-0.397, -0.298],
                    [-0.397, -0.298],
                    [-0.397, -0.297],
                    [-0.397, -0.299],
                    [-0.397, -0.298],
                    [-0.298, -0.198],
                    [-0.397, -0.198],
                    [-0.298, -0.199],
                    [-0.397, -0.198],
                    [-0.298, -0.199],
                    [-0.497, -0.199],
                    [-0.297, -0.099],
                    [-0.496, -0.298],
                    [-0.397, -0.199],
                    [-0.497, -0.199],
                    [-0.397, -0.199],
                    [-0.397, -0.198],
                    [-0.397, -0.1],
                    [-0.498, -0.198],
                    [-0.299, -0.099],
                    [-0.595, -0.199],
                    [-0.398, -0.198],
                    [-0.496, -0.198],
                    [-0.299, -0.099],
                    [-0.595, -0.199],
                    [-0.2, 0],
                    [-0.696, -0.297],
                    [-0.199, -0.099],
                    [-0.696, -0.199],
                    [0, 0],
                    [-9.429, -1.191],
                    [-0.197, 2.184],
                    [-0.496, 0.992],
                    [0, 0],
                    [-0.099, 0.695],
                    [-0.098, 3.674],
                    [-0.397, 3.971],
                    [-0.696, 5.163],
                    [5.46, 5.461],
                    [0.199, 0.198],
                    [0, 0],
                    [0, 0],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0.199],
                    [0, 0],
                    [0.199, -1.39],
                    [1.489, 0.199],
                    [0, 0],
                    [0.198, -1.39],
                    [1.39, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.389, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0.099],
                    [0, 0],
                    [0.199, -1.39],
                    [1.39, 0],
                    [0, 0],
                    [0.198, -1.39],
                    [1.291, 0],
                    [0, 0],
                    [0.199, -1.389],
                    [1.29, 0],
                    [0, 0],
                    [-0.794, -0.595],
                    [-0.299, -0.199]
                  ],
                  "o": [
                    [0.297, 0.199],
                    [0.497, 0.298],
                    [0.298, 0.199],
                    [0.497, 0.298],
                    [0.396, 0.199],
                    [0.397, 0.298],
                    [0.397, 0.198],
                    [0.397, 0.298],
                    [0.397, 0.199],
                    [0.397, 0.297],
                    [0.397, 0.198],
                    [0.397, 0.199],
                    [0.397, 0.199],
                    [0.398, 0.199],
                    [0.397, 0.199],
                    [0.496, 0.198],
                    [0.397, 0.199],
                    [0.496, 0.199],
                    [0.397, 0.199],
                    [0.496, 0.198],
                    [0.397, 0.198],
                    [0.496, 0.198],
                    [0.398, 0.1],
                    [0.496, 0.198],
                    [0.296, 0.1],
                    [0.496, 0.199],
                    [0.298, 0.099],
                    [0.495, 0.199],
                    [0.299, 0.099],
                    [0.594, 0.198],
                    [0.199, 0.099],
                    [0.693, 0.199],
                    [0.197, 0.1],
                    [0.795, 0.298],
                    [0, 0],
                    [10.92, 3.276],
                    [0.198, -2.184],
                    [0.101, -1.092],
                    [0, 0],
                    [0, -0.795],
                    [0.397, -3.673],
                    [0.2, -3.971],
                    [0.597, -5.262],
                    [-40.998, -3.772],
                    [-0.298, -0.298],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.49, 0.199],
                    [-0.198, 1.49],
                    [0, 0],
                    [1.489, 0.199],
                    [-0.198, 1.489],
                    [0, 0],
                    [1.39, 0.198],
                    [-0.199, 1.39],
                    [0, 0],
                    [1.39, 0.298],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.389, 0.297],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.291, 0.298],
                    [-0.198, 1.39],
                    [0, 0],
                    [1.291, 0.298],
                    [-0.199, 1.39],
                    [0, 0],
                    [1.29, 0.397],
                    [-0.198, 1.291],
                    [0, 0],
                    [0.794, 0.596],
                    [0.298, 0.199],
                    [0.893, 0]
                  ],
                  "v": [
                    [-36.332, 17.623],
                    [-35.439, 18.318],
                    [-34.049, 19.311],
                    [-33.057, 20.006],
                    [-31.667, 20.899],
                    [-30.575, 21.595],
                    [-29.284, 22.488],
                    [-28.192, 23.183],
                    [-26.902, 23.977],
                    [-25.81, 24.673],
                    [-24.519, 25.467],
                    [-23.427, 26.062],
                    [-22.137, 26.757],
                    [-21.045, 27.353],
                    [-19.754, 28.048],
                    [-18.662, 28.644],
                    [-17.272, 29.339],
                    [-16.181, 29.835],
                    [-14.792, 30.53],
                    [-13.699, 31.027],
                    [-12.309, 31.623],
                    [-11.217, 32.119],
                    [-9.829, 32.714],
                    [-8.736, 33.112],
                    [-7.246, 33.707],
                    [-6.254, 34.104],
                    [-4.665, 34.7],
                    [-3.671, 35.097],
                    [-2.086, 35.693],
                    [-1.19, 35.991],
                    [0.596, 36.587],
                    [1.291, 36.785],
                    [3.277, 37.48],
                    [3.771, 37.679],
                    [6.057, 38.374],
                    [6.155, 38.374],
                    [37.027, 44.926],
                    [37.622, 38.374],
                    [37.822, 33.807],
                    [37.822, 31.325],
                    [38.019, 29.041],
                    [39.21, 18.219],
                    [39.906, 6.404],
                    [41.396, -9.184],
                    [-32.262, -43.933],
                    [-32.957, -44.628],
                    [-33.057, -44.727],
                    [-33.156, -44.827],
                    [-33.255, -44.926],
                    [-33.652, -42.245],
                    [-33.553, -42.245],
                    [-31.271, -39.267],
                    [-34.248, -36.983],
                    [-34.446, -35.097],
                    [-32.163, -32.118],
                    [-35.141, -29.835],
                    [-35.439, -27.948],
                    [-33.255, -24.97],
                    [-36.134, -22.686],
                    [-36.432, -20.8],
                    [-34.248, -17.821],
                    [-37.126, -15.538],
                    [-37.424, -13.651],
                    [-35.34, -10.673],
                    [-38.119, -8.389],
                    [-38.417, -6.503],
                    [-36.432, -3.524],
                    [-39.211, -1.241],
                    [-39.509, 0.645],
                    [-37.523, 3.624],
                    [-40.204, 5.908],
                    [-40.501, 7.794],
                    [-38.616, 10.772],
                    [-41.196, 13.056],
                    [-41.396, 14.446],
                    [-39.112, 16.233],
                    [-38.317, 16.829]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [41.739, 46.019],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.496, -5.262],
                    [0.2, -3.971],
                    [0.397, -3.574],
                    [0.098, -0.794],
                    [0, 0],
                    [0.098, -1.092],
                    [0.197, -2.184],
                    [10.917, 3.276],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.389, -0.099],
                    [-0.098, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.388, -0.099],
                    [-0.099, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [-0.098, -0.1],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.099, 1.389],
                    [-1.388, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.39],
                    [-1.389, -0.099],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.098, 1.389],
                    [-1.389, -0.099],
                    [0, 0],
                    [10.819, 0.993]
                  ],
                  "o": [
                    [-0.397, 3.972],
                    [-0.197, 3.674],
                    [-0.099, 0.794],
                    [0, 0],
                    [-0.499, 0.993],
                    [-0.197, 2.184],
                    [-9.433, -1.191],
                    [35.338, 10.722],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.099],
                    [0.101, -1.489],
                    [0.199, 0],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.1],
                    [0.101, -1.49],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [-1.487, -0.1],
                    [0.099, -1.488],
                    [0.099, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.488, -0.099],
                    [0.099, -1.49],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.49, -0.099],
                    [0.101, -1.489],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.49, -0.1],
                    [0.101, -1.49],
                    [0, 0],
                    [-12.508, 2.78],
                    [-0.397, 4.865]
                  ],
                  "v": [
                    [-1.241, -12.56],
                    [-1.937, -0.744],
                    [-3.128, 10.077],
                    [-3.325, 12.361],
                    [-3.325, 14.844],
                    [-3.525, 19.41],
                    [-4.119, 25.963],
                    [-34.991, 19.41],
                    [32.211, 27.452],
                    [32.312, 25.864],
                    [31.814, 25.864],
                    [29.333, 23.083],
                    [32.113, 20.601],
                    [32.509, 20.7],
                    [32.608, 18.716],
                    [32.211, 18.716],
                    [29.73, 15.935],
                    [32.509, 13.453],
                    [32.907, 13.552],
                    [33.006, 11.666],
                    [32.608, 11.666],
                    [30.127, 8.885],
                    [32.907, 6.404],
                    [33.205, 6.504],
                    [33.304, 4.616],
                    [33.006, 4.616],
                    [30.524, 1.837],
                    [33.304, -0.646],
                    [33.602, -0.646],
                    [33.701, -2.531],
                    [33.403, -2.531],
                    [30.921, -5.312],
                    [33.701, -7.794],
                    [33.901, -7.794],
                    [34, -9.68],
                    [33.8, -9.68],
                    [31.318, -12.46],
                    [34.098, -14.943],
                    [34.298, -14.943],
                    [34.397, -16.828],
                    [34.298, -16.828],
                    [31.814, -19.609],
                    [34.594, -22.091],
                    [34.695, -22.091],
                    [34.794, -23.977],
                    [34.695, -23.977],
                    [32.211, -26.757],
                    [34.991, -29.24],
                    [34.991, -30.133],
                    [-0.05, -27.849]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [83.184, 64.884],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 11",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 11,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 12,
      "ty": 4,
      "nm": "Layer 11 Outlines",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 0,
              "s": [0]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 18,
              "s": [100]
            },
            {
              "i": {
                "x": [0.833],
                "y": [0.833]
              },
              "o": {
                "x": [0.167],
                "y": [0.167]
              },
              "t": 87,
              "s": [100]
            },
            {
              "t": 143,
              "s": [0]
            }
          ],
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": {
                "x": 0.833,
                "y": 0.833
              },
              "o": {
                "x": 0.167,
                "y": 0.167
              },
              "t": 0,
              "s": [195, 443.5, 0],
              "to": [91.333, 156.333, 0],
              "ti": [-217.333, -162.333, 0]
            },
            {
              "t": 141,
              "s": [239, 1033.5, 0]
            }
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [28, 37.5, 0],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [100, 100, 100],
          "ix": 6
        }
      },
      "ao": 1,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.099, 0.594],
                    [0, 0],
                    [-0.299, -0.397],
                    [-0.197, 0.298],
                    [-0.893, 0.794],
                    [-0.498, -0.693],
                    [0, -0.396],
                    [0.099, -0.099],
                    [0.299, 0.398],
                    [0.198, -0.199],
                    [0.994, -0.994],
                    [0.597, 0.696]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0.396],
                    [0.397, 0.397],
                    [0.597, -0.594],
                    [0.397, -0.397],
                    [0.397, 0.499],
                    [-0.2, 0],
                    [0, -0.298],
                    [-0.298, -0.396],
                    [-0.596, 0.496],
                    [-0.397, 0.398],
                    [-0.495, -0.597]
                  ],
                  "v": [
                    [-1.787, -0.347],
                    [-1.292, -0.347],
                    [-0.894, 0.943],
                    [0.097, 1.141],
                    [-0.199, -1.64],
                    [1.39, -1.243],
                    [1.886, 0.05],
                    [1.488, 0.148],
                    [1.091, -0.944],
                    [0.198, -1.142],
                    [0.494, 1.639],
                    [-1.193, 1.34]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [26.815, 44.825],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.101, 0.2],
                    [-0.693, 0.695],
                    [0.296, 0.396],
                    [0.398, 0],
                    [0.794, -0.696],
                    [0.102, 0.197],
                    [-1.191, 0.892],
                    [-0.098, -0.197],
                    [0.197, -0.099],
                    [-0.299, -0.496],
                    [0.597, -0.495],
                    [0.795, -0.695]
                  ],
                  "o": [
                    [0.695, -0.594],
                    [0.499, -0.397],
                    [-0.299, -0.398],
                    [-0.794, 0.695],
                    [-0.099, -0.197],
                    [1.093, -0.893],
                    [0.099, 0.2],
                    [-0.199, 0.101],
                    [0.396, 0],
                    [0.495, 0.594],
                    [-0.794, 0.696],
                    [0, -0.098]
                  ],
                  "v": [
                    [-0.595, 1.985],
                    [1.092, 0.397],
                    [1.193, -0.794],
                    [0.1, -1.29],
                    [-1.885, 0.397],
                    [-2.184, -0.099],
                    [0.596, -2.383],
                    [0.894, -1.886],
                    [0.498, -1.589],
                    [1.689, -0.893],
                    [1.489, 0.696],
                    [-0.396, 2.383]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [24.53, 41.896],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.498, 0.397],
                    [0.398, 0.694],
                    [0.597, -0.496],
                    [-0.496, -0.597]
                  ],
                  "o": [
                    [0.595, -0.496],
                    [-0.397, -0.695],
                    [-0.594, 0.397],
                    [0.498, 0.695]
                  ],
                  "v": [
                    [0.646, 1.042],
                    [1.043, -0.843],
                    [-0.745, -1.042],
                    [-1.142, 0.845]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.893, 0.595],
                    [-0.598, -0.994],
                    [0.794, -0.695],
                    [0.595, 0.991]
                  ],
                  "o": [
                    [0.794, -0.596],
                    [0.593, 0.992],
                    [-0.793, 0.693],
                    [-0.695, -0.995]
                  ],
                  "v": [
                    [-0.942, -1.637],
                    [1.54, -1.141],
                    [1.043, 1.54],
                    [-1.438, 1.144]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [22.297, 38.57],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.695, 0.496],
                    [0.298, 0.696],
                    [0.397, 0],
                    [0.597, -0.397],
                    [-0.298, -0.397]
                  ],
                  "o": [
                    [0.693, -0.496],
                    [-0.198, -0.397],
                    [-0.499, 0.397],
                    [-0.197, 0.397],
                    [0.296, 0.695]
                  ],
                  "v": [
                    [1.291, 1.142],
                    [1.886, -0.745],
                    [0.894, -1.438],
                    [-0.497, -0.545],
                    [-0.396, 0.844]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.197, 0.496],
                    [0.596, -0.498],
                    [0.097, 0.298],
                    [-1.688, 0.994],
                    [-0.101, -0.197],
                    [0.201, -0.099],
                    [-0.197, -0.496],
                    [0.895, -0.696],
                    [0.495, 0.893]
                  ],
                  "o": [
                    [-0.593, 0.398],
                    [-0.099, -0.199],
                    [1.588, -1.191],
                    [0.098, 0.2],
                    [-0.2, 0.101],
                    [0.398, 0.098],
                    [0.496, 0.892],
                    [-0.893, 0.693],
                    [-0.2, -0.498]
                  ],
                  "v": [
                    [-0.895, -0.247],
                    [-2.482, 0.945],
                    [-2.778, 0.348],
                    [1.39, -2.432],
                    [1.688, -1.936],
                    [1.189, -1.637],
                    [2.282, -0.843],
                    [1.587, 1.739],
                    [-0.793, 1.342]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [19.469, 34.797],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.099, 0.2],
                    [-0.101, 0.102],
                    [0.197, 0.595],
                    [-0.697, 0.396],
                    [-0.895, 0.495],
                    [-0.099, -0.299],
                    [0.795, -0.498],
                    [-0.2, -0.496],
                    [-0.397, -0.099],
                    [-0.893, 0.498],
                    [-0.099, -0.299],
                    [1.191, -0.794]
                  ],
                  "o": [
                    [0.197, -0.099],
                    [-0.397, -0.098],
                    [-0.299, -0.794],
                    [0.892, -0.496],
                    [0.1, 0.199],
                    [-0.795, 0.496],
                    [-0.597, 0.296],
                    [0.197, 0.496],
                    [0.896, -0.597],
                    [0.098, 0.2],
                    [-1.19, 0.794],
                    [0, -0.396]
                  ],
                  "v": [
                    [-1.09, 1.836],
                    [-0.693, 1.537],
                    [-1.786, 0.547],
                    [-1.29, -1.241],
                    [0.895, -2.531],
                    [1.093, -1.935],
                    [-0.992, -0.743],
                    [-1.389, 0.547],
                    [-0.397, 1.341],
                    [1.887, -0.051],
                    [2.084, 0.547],
                    [-0.992, 2.531]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [18.277, 31.024],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.597, 0.299],
                    [0.295, 0.892],
                    [0.697, -0.396],
                    [-0.296, -0.795]
                  ],
                  "o": [
                    [0.693, -0.397],
                    [-0.299, -0.795],
                    [-0.692, 0.397],
                    [0.298, 0.797]
                  ],
                  "v": [
                    [0.498, 1.29],
                    [1.293, -0.695],
                    [-0.398, -1.293],
                    [-1.191, 0.693]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.892, 0.495],
                    [-0.396, -1.089],
                    [0.893, -0.498],
                    [0.398, 1.192]
                  ],
                  "o": [
                    [0.992, -0.496],
                    [0.395, 1.093],
                    [-0.892, 0.496],
                    [-0.396, -1.191]
                  ],
                  "v": [
                    [-0.595, -1.887],
                    [1.689, -0.896],
                    [0.695, 1.887],
                    [-1.688, 0.991]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [16.59, 26.706],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.49, 0.597],
                    [-0.397, -1.589],
                    [0.394, -0.696],
                    [0.099, 0.099],
                    [0.099, 0.594],
                    [1.093, -0.496],
                    [-0.299, -1.191],
                    [-0.498, -0.098],
                    [0, -0.299],
                    [0.298, 0.991]
                  ],
                  "o": [
                    [1.489, -0.595],
                    [0.199, 0.991],
                    [-0.201, -0.198],
                    [0.296, -0.495],
                    [-0.296, -1.191],
                    [-1.09, 0.498],
                    [0.197, 0.696],
                    [0, 0.299],
                    [-0.693, -0.2],
                    [-0.496, -1.589]
                  ],
                  "v": [
                    [-0.546, -2.583],
                    [2.53, -0.795],
                    [2.136, 1.687],
                    [1.738, 1.289],
                    [2.034, -0.495],
                    [-0.349, -1.788],
                    [-1.737, 1.289],
                    [-0.645, 2.481],
                    [-0.746, 3.177],
                    [-2.233, 1.49]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [15.846, 21.642],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [9.234, -9.384],
                    [10.127, -10.177],
                    [10.721, -9.482],
                    [9.828, -8.687]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [7.544, -7.693],
                    [8.439, -8.487],
                    [9.034, -7.794],
                    [8.141, -7]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [5.857, -6.105],
                    [6.75, -6.899],
                    [7.346, -6.205],
                    [6.454, -5.411]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.071, -4.516],
                    [4.963, -5.31],
                    [5.558, -4.617],
                    [4.666, -3.823]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [2.384, -2.828],
                    [3.277, -3.623],
                    [3.872, -2.927],
                    [2.978, -2.134]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.595, -1.24],
                    [1.489, -2.034],
                    [2.086, -1.339],
                    [1.292, -0.544]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.091, 0.348],
                    [-0.199, -0.445],
                    [0.398, 0.25],
                    [-0.495, 1.044]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-2.779, 2.036],
                    [-1.886, 1.24],
                    [-1.288, 1.937],
                    [-2.184, 2.731]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-4.567, 3.624],
                    [-3.671, 2.83],
                    [-3.078, 3.525],
                    [-3.97, 4.319]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 9,
              "ty": "sh",
              "ix": 10,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-6.254, 5.213],
                    [-5.362, 4.418],
                    [-4.764, 5.114],
                    [-5.658, 5.907]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 10",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 10,
              "ty": "sh",
              "ix": 11,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-7.942, 6.899],
                    [-7.048, 6.105],
                    [-6.452, 6.801],
                    [-7.344, 7.595]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 11",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 11,
              "ty": "sh",
              "ix": 12,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-9.727, 8.488],
                    [-8.834, 7.694],
                    [-8.24, 8.389],
                    [-9.133, 9.183]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 12",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 12,
              "ty": "sh",
              "ix": 13,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-10.721, 9.482],
                    [-10.522, 9.281],
                    [-9.927, 9.978],
                    [-10.124, 10.177]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 13",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.181, 50.98],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 15,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, -0.397],
                    [0, -0.201],
                    [-0.099, -0.298],
                    [0, -0.2],
                    [-0.099, -0.2],
                    [-0.101, -0.198],
                    [-0.098, -0.299],
                    [-0.101, -0.298],
                    [-0.099, -0.299],
                    [-0.102, -0.299],
                    [0, -0.298],
                    [-0.1, -0.198],
                    [-0.098, -0.296],
                    [-0.098, -0.2],
                    [-0.101, -0.299],
                    [0, -0.196],
                    [-0.098, -0.197],
                    [0, -0.199],
                    [-0.098, -0.197],
                    [0, -0.2],
                    [-0.099, -0.199],
                    [-0.098, -0.197],
                    [-0.101, -0.298],
                    [-0.098, -0.2],
                    [-0.198, -0.299],
                    [0, -0.2],
                    [-0.098, -0.299],
                    [0, -0.197],
                    [-0.099, -0.299],
                    [-0.098, -0.098],
                    [-0.197, -0.296],
                    [-0.102, -0.197],
                    [-0.099, -0.397],
                    [0, 0],
                    [-0.2, -0.298],
                    [0, 0],
                    [-3.275, -3.873],
                    [-0.896, 0.696],
                    [-0.496, 0.197],
                    [-0.298, 0.299],
                    [-0.296, 0.199],
                    [-1.389, 1.389],
                    [-1.588, 1.388],
                    [-2.084, 1.687],
                    [0.197, 4.07],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.596, -0.497],
                    [0.499, 0.594],
                    [0, 0],
                    [0.595, -0.496],
                    [0.495, 0.594],
                    [0, 0],
                    [0.593, -0.496],
                    [0.496, 0.594],
                    [0, 0],
                    [0.598, -0.397],
                    [0.496, 0.495],
                    [0, 0],
                    [0.593, -0.496],
                    [0.499, 0.495],
                    [0, 0],
                    [0.595, -0.496],
                    [0.495, 0.495],
                    [0, 0],
                    [0.596, -0.496],
                    [0.496, 0.496],
                    [0, 0],
                    [0.496, -0.397],
                    [0.498, 0.496],
                    [0, 0],
                    [0, -0.496],
                    [0, -0.197]
                  ],
                  "o": [
                    [0, 0.199],
                    [0.098, 0.299],
                    [0, 0.2],
                    [0.099, 0.296],
                    [0.098, 0.197],
                    [0.099, 0.297],
                    [0.099, 0.2],
                    [0.099, 0.299],
                    [0.098, 0.199],
                    [0.098, 0.299],
                    [0.099, 0.197],
                    [0.099, 0.299],
                    [0.102, 0.2],
                    [0.099, 0.298],
                    [0.099, 0.198],
                    [0.098, 0.299],
                    [0.099, 0.2],
                    [0.101, 0.197],
                    [0.099, 0.2],
                    [0.098, 0.299],
                    [0.098, 0.198],
                    [0.099, 0.299],
                    [0.099, 0.2],
                    [0.102, 0.296],
                    [0.1, 0.197],
                    [0.098, 0.298],
                    [0.099, 0.197],
                    [0.101, 0.298],
                    [0.101, 0.098],
                    [0.198, 0.298],
                    [0.099, 0.101],
                    [0.197, 0.298],
                    [0, 0.099],
                    [0.2, 0.396],
                    [0, 0],
                    [3.075, 5.162],
                    [0.892, -0.795],
                    [0.397, -0.397],
                    [0.299, -0.299],
                    [0.299, -0.296],
                    [1.489, -1.29],
                    [1.49, -1.49],
                    [2.084, -1.888],
                    [-14.494, -16.085],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.496, 0.598],
                    [-0.595, 0.498],
                    [0, 0],
                    [0.499, 0.598],
                    [-0.595, 0.498],
                    [0, 0],
                    [0.496, 0.598],
                    [-0.598, 0.498],
                    [0, 0],
                    [0.398, 0.597],
                    [-0.594, 0.495],
                    [0, 0],
                    [0.398, 0.598],
                    [-0.598, 0.495],
                    [0, 0],
                    [0.397, 0.598],
                    [-0.597, 0.495],
                    [0, 0],
                    [0.398, 0.598],
                    [-0.595, 0.495],
                    [0, 0],
                    [0.396, 0.594],
                    [-0.496, 0.397],
                    [0, 0],
                    [0.099, 0.496],
                    [0, 0.198],
                    [0.692, 0.201]
                  ],
                  "v": [
                    [-19.207, -7.101],
                    [-19.109, -6.503],
                    [-18.911, -5.611],
                    [-18.81, -5.013],
                    [-18.613, -4.219],
                    [-18.413, -3.625],
                    [-18.217, -2.831],
                    [-18.016, -2.135],
                    [-17.819, -1.34],
                    [-17.618, -0.646],
                    [-17.422, 0.148],
                    [-17.222, 0.744],
                    [-16.927, 1.538],
                    [-16.726, 2.135],
                    [-16.427, 2.929],
                    [-16.23, 3.522],
                    [-15.932, 4.219],
                    [-15.735, 4.815],
                    [-15.436, 5.509],
                    [-15.236, 6.105],
                    [-14.94, 6.801],
                    [-14.642, 7.396],
                    [-14.344, 8.189],
                    [-14.048, 8.788],
                    [-13.65, 9.582],
                    [-13.45, 10.078],
                    [-13.053, 10.872],
                    [-12.856, 11.368],
                    [-12.459, 12.162],
                    [-12.26, 12.559],
                    [-11.763, 13.452],
                    [-11.563, 13.849],
                    [-11.068, 14.843],
                    [-10.969, 15.041],
                    [-10.371, 16.133],
                    [-10.371, 16.231],
                    [-0.744, 29.835],
                    [1.838, 27.551],
                    [3.525, 25.864],
                    [4.418, 24.87],
                    [5.311, 24.076],
                    [9.679, 20.304],
                    [14.146, 16.035],
                    [20.301, 10.573],
                    [4.22, -29.14],
                    [4.22, -29.635],
                    [4.22, -29.737],
                    [4.22, -29.835],
                    [3.128, -28.943],
                    [2.928, -26.957],
                    [0.942, -27.154],
                    [0.148, -26.561],
                    [-0.05, -24.574],
                    [-2.034, -24.771],
                    [-2.829, -24.177],
                    [-3.026, -22.191],
                    [-5.012, -22.388],
                    [-5.806, -21.794],
                    [-6.007, -19.907],
                    [-7.89, -20.005],
                    [-8.685, -19.412],
                    [-8.983, -17.524],
                    [-10.87, -17.623],
                    [-11.664, -17.029],
                    [-11.961, -15.141],
                    [-13.847, -15.24],
                    [-14.642, -14.646],
                    [-14.94, -12.758],
                    [-16.824, -12.858],
                    [-17.618, -12.162],
                    [-17.918, -10.376],
                    [-19.705, -10.476],
                    [-20.301, -9.979],
                    [-20.104, -8.489],
                    [-20.002, -7.994]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.106, 30.926],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [2.084, -1.885],
                    [1.489, -1.389],
                    [1.49, -1.293],
                    [0.299, -0.299],
                    [0.296, -0.296],
                    [0.398, -0.398],
                    [0.894, -0.694],
                    [3.079, 5.162],
                    [0, 0],
                    [0, 0],
                    [0.098, 0.101],
                    [-0.499, 0.498],
                    [-0.495, -0.496],
                    [0, -0.098],
                    [0, 0],
                    [0.099, 0],
                    [-0.495, 0.496],
                    [-0.496, -0.496],
                    [0, -0.099],
                    [0, 0],
                    [0, 0],
                    [-0.499, 0.499],
                    [-0.496, -0.495],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.496, 0.496],
                    [-0.496, -0.498],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.499, 0.495],
                    [-0.498, -0.496],
                    [-0.099, 0],
                    [0, 0],
                    [0, 0.098],
                    [-0.496, 0.496],
                    [-0.496, -0.496],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.495, 0.499],
                    [-0.497, -0.495],
                    [0, 0],
                    [-0.498, 0.496],
                    [-0.496, -0.498],
                    [0, 0],
                    [3.87, 4.266]
                  ],
                  "o": [
                    [-1.589, 1.392],
                    [-1.391, 1.391],
                    [-0.298, 0.298],
                    [-0.298, 0.299],
                    [-0.496, 0.2],
                    [-0.895, 0.793],
                    [-3.176, -3.87],
                    [9.83, 16.778],
                    [0, 0],
                    [-0.099, 0],
                    [-0.499, -0.594],
                    [0.594, -0.496],
                    [0.102, 0.102],
                    [0, 0],
                    [-0.099, 0],
                    [-0.495, -0.597],
                    [0.595, -0.496],
                    [0, 0],
                    [0, 0],
                    [-0.101, 0],
                    [-0.499, -0.595],
                    [0.594, -0.495],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.496, -0.598],
                    [0.496, -0.498],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.499, -0.596],
                    [0.594, -0.496],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.496, -0.594],
                    [0.498, -0.496],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.495, -0.597],
                    [0.595, -0.495],
                    [0, 0],
                    [-0.498, -0.598],
                    [0.595, -0.498],
                    [0, 0],
                    [-5.855, -3.377],
                    [-1.589, 2.084]
                  ],
                  "v": [
                    [2.285, -10.724],
                    [-2.182, -6.454],
                    [-6.552, -2.68],
                    [-7.444, -1.886],
                    [-8.336, -0.895],
                    [-10.024, 0.796],
                    [-12.607, 3.077],
                    [-22.237, -10.524],
                    [0.896, 16.579],
                    [1.49, 15.985],
                    [1.294, 15.785],
                    [1.294, 13.799],
                    [3.276, 13.799],
                    [3.378, 13.999],
                    [4.071, 13.303],
                    [3.873, 13.205],
                    [3.873, 11.219],
                    [5.859, 11.219],
                    [5.958, 11.417],
                    [6.653, 10.723],
                    [6.554, 10.623],
                    [6.554, 8.636],
                    [8.538, 8.636],
                    [8.638, 8.738],
                    [9.332, 8.043],
                    [9.233, 7.944],
                    [9.233, 5.958],
                    [11.219, 5.958],
                    [11.317, 6.056],
                    [12.013, 5.361],
                    [11.915, 5.262],
                    [11.915, 3.277],
                    [13.9, 3.277],
                    [13.999, 3.376],
                    [14.694, 2.679],
                    [14.594, 2.581],
                    [14.594, 0.595],
                    [16.579, 0.595],
                    [16.677, 0.694],
                    [17.373, 0.001],
                    [17.274, 0.001],
                    [17.274, -1.988],
                    [19.26, -1.988],
                    [19.956, -2.68],
                    [19.956, -4.666],
                    [21.939, -4.666],
                    [22.237, -4.964],
                    [7.844, -16.579]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.5607843137254902, 0.7333333333333333, 0.32941176470588235, 1],
                "ix": 4
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [33.266, 57.484],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 144,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
